webpackJsonp([0],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_accueil_model__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_common_model__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__providers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_message_repository__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_antenne_repository__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repositories_reclamation_prtv_repository__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__repositories_reclamation_lte_repository__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__repositories_apiadressedatagouv_repository__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__repositories_suivie_dossier_repository__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_some__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FROM_RECLAMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validateDemandeForStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return nextStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prevStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return allPrevSteps; });
/* unused harmony export prePostPrtv */
/* unused harmony export preUpdatePrtv */










//TODO: Ajouter le call a l'API Brouillage
//import webserviceLteRepository from '../repositories/webservice-lte.repository';







var ACCUEIL_INTERFACE_1 = 'accueil-interface-1';
var ACCUEIL_INTERFACE_2 = 'accueil-interface-2';
var ACCUEIL_INTERFACE_3 = 'accueil-interface-3';
var ETAT_CHAINES = 'etat-chaines';
var REAMENAGEMENT = 'reamenagement';
var ANTENNE_ACCESSIBLE = 'antenne-accessible';
var FIN_ACCUEIL = 'fin-accueil';
var INTERVENTION_ANTENNISTE = 'intervention-antenniste';
var SIGNALEMENT_ANTENNISTE = 'signalement-antenniste';
var DYSFONCTIONNEMENT_INTERFACE = 'dysfonctionnement-interface';
var INCIDENT_DETECTE = 'incident-detecte';
var AUCUN_INCIDENT_DETECTE = 'aucun-incident-detecte';
var CONCLUSION = 'conclusion';
var HOME = 'home';
var ZONE_PERTURBE = 'zone-perturbe';
var CONTACT = 'contact';
var CONSTAT = 'constat';
var FIN_ANTENNISTE = 'fin-antenniste';

var PRTV_INTERFACE_1 = 'prtv-interface-1';
var PRTV_INTERFACE_2 = 'prtv-interface-2';
var PRTV_INTERFACE_3 = 'prtv-interface-3';
var PRTV_INTERFACE_4 = 'prtv-interface-4';
var PRTV_INTERFACE_5 = 'prtv-interface-5';
var PRTV_INTERFACE_6 = 'prtv-interface-6';
var PRTV_DEPOT_FACTURE = 'prtv-depot-facture';
var PRTV_DEPOT_FACTURE_2 = 'prtv-depot-facture-2';
var PRTV_DEPOT_FACTURE_3 = 'prtv-depot-facture-3';

var LTE_INTERFACE_1 = 'lte-interface-1';
var LTE_INTERFACE_2 = 'lte-interface-2';
var SUIVIE_AUTHENT = 'suivie-authent';
var SUIVIE_RESULTAT = 'suivie-resultat';
var FROM_RECLAMATION = 'from_reclamation';
var STEPS = {
  ACCUEIL_INTERFACE_1: ACCUEIL_INTERFACE_1,
  ACCUEIL_INTERFACE_2: ACCUEIL_INTERFACE_2,
  ACCUEIL_INTERFACE_3: ACCUEIL_INTERFACE_3,
  ETAT_CHAINES: ETAT_CHAINES,
  REAMENAGEMENT: REAMENAGEMENT,
  ANTENNE_ACCESSIBLE: ANTENNE_ACCESSIBLE,
  INTERVENTION_ANTENNISTE: INTERVENTION_ANTENNISTE,
  SIGNALEMENT_ANTENNISTE: SIGNALEMENT_ANTENNISTE,
  FIN_ACCUEIL: FIN_ACCUEIL,
  DYSFONCTIONNEMENT_INTERFACE: DYSFONCTIONNEMENT_INTERFACE,
  INCIDENT_DETECTE: INCIDENT_DETECTE,
  AUCUN_INCIDENT_DETECTE: AUCUN_INCIDENT_DETECTE,
  CONCLUSION: CONCLUSION,
  HOME: HOME,
  ZONE_PERTURBE: ZONE_PERTURBE,
  CONTACT: CONTACT,
  CONSTAT: CONSTAT,
  FIN_ANTENNISTE: FIN_ANTENNISTE,
  PRTV_INTERFACE_1: PRTV_INTERFACE_1,
  PRTV_INTERFACE_2: PRTV_INTERFACE_2,
  PRTV_INTERFACE_3: PRTV_INTERFACE_3,
  PRTV_INTERFACE_4: PRTV_INTERFACE_4,
  PRTV_INTERFACE_5: PRTV_INTERFACE_5,
  PRTV_INTERFACE_6: PRTV_INTERFACE_6,
  PRTV_DEPOT_FACTURE: PRTV_DEPOT_FACTURE,
  PRTV_DEPOT_FACTURE_2: PRTV_DEPOT_FACTURE_2,
  PRTV_DEPOT_FACTURE_3: PRTV_DEPOT_FACTURE_3,
  LTE_INTERFACE_1: LTE_INTERFACE_1,
  LTE_INTERFACE_2: LTE_INTERFACE_2,
  SUIVIE_AUTHENT: SUIVIE_AUTHENT,
  SUIVIE_RESULTAT: SUIVIE_RESULTAT
};

function validateDemandeForStep(demande, step) {
  switch (step) {
    case ACCUEIL_INTERFACE_1:
      // Pas de contraintes sur la demande
      return demande.typePersonne !== __WEBPACK_IMPORTED_MODULE_0__modules_accueil_model__["a" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION;
    case ACCUEIL_INTERFACE_2:
      if (demande.typePersonne === __WEBPACK_IMPORTED_MODULE_0__modules_accueil_model__["a" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION) {
        return validateDemandeForStep(demande, HOME);
      }
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_1) && demande.accueilInterface1;
    case ACCUEIL_INTERFACE_3:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case INCIDENT_DETECTE:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case AUCUN_INCIDENT_DETECTE:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case ETAT_CHAINES:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case CONCLUSION:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case REAMENAGEMENT:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case ANTENNE_ACCESSIBLE:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case FIN_ACCUEIL:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case INTERVENTION_ANTENNISTE:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case SIGNALEMENT_ANTENNISTE:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case PRTV_INTERFACE_1:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2) && demande.numeroAnfr;
    case DYSFONCTIONNEMENT_INTERFACE:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case LTE_INTERFACE_1:
      if (demande.signalementAntenniste && demande.signalementAntenniste.antennes) {
        return validateDemandeForStep(demande, SIGNALEMENT_ANTENNISTE);
      } else if (demande.dysfonctionnementInterface && demande.dysfonctionnementInterface.antennes) {
        return validateDemandeForStep(demande, DYSFONCTIONNEMENT_INTERFACE);
      }
      break;
    case LTE_INTERFACE_2:
      return validateDemandeForStep(demande, LTE_INTERFACE_1) && demande.numeroAnfr;
    case PRTV_INTERFACE_2:
      if (demande.numeroAnfr === (demande.suivieAuthent ? demande.suivieAuthent.identifiant : '')) {
        return validateDemandeForStep(demande, SUIVIE_AUTHENT) && demande.numeroAnfr;
      }
      return validateDemandeForStep(demande, PRTV_INTERFACE_1) && demande.numeroAnfr;
    case PRTV_INTERFACE_3:
      return validateDemandeForStep(demande, PRTV_INTERFACE_2) && demande.numeroAnfr;
    case PRTV_INTERFACE_4:
      return validateDemandeForStep(demande, PRTV_INTERFACE_3) && demande.numeroAnfr;
    case PRTV_INTERFACE_5:
      return validateDemandeForStep(demande, PRTV_INTERFACE_4) && demande.numeroAnfr;
    case PRTV_INTERFACE_6:
      return validateDemandeForStep(demande, PRTV_INTERFACE_5) && demande.numeroAnfr;
    case PRTV_DEPOT_FACTURE:
      if (demande.numeroAnfr === (demande.suivieAuthent ? demande.suivieAuthent.identifiant : '')) {
        return validateDemandeForStep(demande, SUIVIE_AUTHENT) && demande.numeroAnfr;
      } else {
        return validateDemandeForStep(demande, PRTV_INTERFACE_6) && demande.numeroAnfr;
      }
      break;
    case PRTV_DEPOT_FACTURE_2:
      return validateDemandeForStep(demande, PRTV_DEPOT_FACTURE) && demande.numeroAnfr;
    case PRTV_DEPOT_FACTURE_3:
      return validateDemandeForStep(demande, PRTV_DEPOT_FACTURE_2) && demande.numeroAnfr;
    case CONTACT:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case ZONE_PERTURBE:
      return validateDemandeForStep(demande, ACCUEIL_INTERFACE_2);
    case CONSTAT:
      return validateDemandeForStep(demande, CONTACT);
    case FIN_ANTENNISTE:
      return validateDemandeForStep(demande, CONSTAT);
    case SUIVIE_AUTHENT:
      // Pas de contraintes sur la demande
      return demande.suivieAuthent;
    case SUIVIE_RESULTAT:
      return validateDemandeForStep(demande, SUIVIE_AUTHENT);
    default:
      // Par défaut on doit avoir un objet demande
      return !!demande;
  }
}

function nextStep(demande, currentStep) {
  switch (currentStep) {
    case HOME:
      if (demande.suivieAuthent) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: SUIVIE_AUTHENT
        });
      } else {
        if (demande.typePersonne === __WEBPACK_IMPORTED_MODULE_0__modules_accueil_model__["a" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
            step: ACCUEIL_INTERFACE_2
          });
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: ACCUEIL_INTERFACE_1
        });
      }
      return;
    case ACCUEIL_INTERFACE_1:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: ACCUEIL_INTERFACE_2
      });
    case ACCUEIL_INTERFACE_2:
      if (demande.typePersonne === __WEBPACK_IMPORTED_MODULE_0__modules_accueil_model__["a" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION) {
        return handleAccueilInterface2Antenniste(demande, true);
      }
      return searchReamenagement(demande, true);
    case ACCUEIL_INTERFACE_3:
      if (demande.typePersonne === __WEBPACK_IMPORTED_MODULE_0__modules_accueil_model__["a" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION) {
        return handleAccueilInterface3Antenniste(demande);
      }
      return searchReamenagement(demande, false);
    case REAMENAGEMENT:
      if (demande.reamenagement.source === 'fin') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: CONCLUSION
        });
      }
      return handleAccueilInterface2NextStep(demande, false);
    case ANTENNE_ACCESSIBLE:
      return handleAntenneAccessibleNextStep(demande);
    case INTERVENTION_ANTENNISTE:
      return handleInterventionAntennisteNextStep(demande);
    case SIGNALEMENT_ANTENNISTE:
      return handleSignalementAntennisteNextStep(demande);
    case DYSFONCTIONNEMENT_INTERFACE:
      return handleDysfonctionnementInterfaceNextStep(demande);
    case FIN_ACCUEIL:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: HOME
      });
    case ETAT_CHAINES:
      return handleEtatChainesNextStep(demande);
    case AUCUN_INCIDENT_DETECTE:
      if (demande.aucunIncidentDetecte.continuerPrtv === true) {
        var _insert = null;
        if (demande.numeroAnfr) {
          _insert = preUpdatePrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
        } else {
          _insert = prePostPrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
        }
        // on envoie tjrs une promesse
        return _insert.then(function (result) {
          demande.numeroAnfr = result.numeroAnfr;
          demande.checkCode = result.checkCode;
          return {
            step: PRTV_INTERFACE_1,
            updatedDemande: demande
          };
        });
      }
      // Ne devrait pas arriver, on renvoie vers la première page
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: CONCLUSION
      });
    case INCIDENT_DETECTE:
      //  update ou poste suivant si on a un numero anfr ou pas
      var insert = null;
      if (demande.numeroAnfr) {
        insert = preUpdatePrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
      } else {
        insert = prePostPrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
      }
      if (demande.incidentDetecte.continuerPrtv === true) {
        // on envoie tjrs une promesse
        return insert.then(function (result) {
          demande.numeroAnfr = result.numeroAnfr;
          demande.checkCode = result.checkCode;
          return {
            step: PRTV_INTERFACE_1,
            updatedDemande: demande
          };
        });
      }
      return insert.then(function (result) {
        demande.numeroAnfr = result.numeroAnfr;
        demande.checkCode = result.checkCode;
        return {
          step: CONCLUSION,
          updatedDemande: demande
        };
      });
    case ZONE_PERTURBE:
      if (demande.zonePerturbe.source === 'oui') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: CONTACT
        });
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: CONCLUSION
      });
    case CONTACT:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: CONSTAT
      });
    case FIN_ANTENNISTE:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: HOME
      });
    case CONSTAT:
      return postPrtvAntenniste(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeAntennisteToPrtv(demande));
    case LTE_INTERFACE_1:
      return postLte(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToLte(demande));
    case LTE_INTERFACE_2:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: HOME
      });
    case CONCLUSION:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: HOME
      });
    case PRTV_INTERFACE_1:
      return updatePrtvFirstStep(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
    case PRTV_INTERFACE_2:
      if (demande.prtvInterface2.demandeEnquetePapier) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: PRTV_INTERFACE_3
        });
      } else {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: HOME
        });
      }
      break;
    case PRTV_INTERFACE_3:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: PRTV_INTERFACE_4
      });
    case PRTV_INTERFACE_4:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: PRTV_INTERFACE_5
      });
    case PRTV_INTERFACE_5:
      return updatePrtvupdateReclamationDemandeEnquete(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtvDemandeEnquete(demande));
    case PRTV_INTERFACE_6:
      return checkFactureDossier(demande);
    case PRTV_DEPOT_FACTURE:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: PRTV_DEPOT_FACTURE_2
      });
    case PRTV_DEPOT_FACTURE_2:
      return updateDossierWithAntenniste(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeAvecFactureDemandeEnquete(demande));
    case PRTV_DEPOT_FACTURE_3:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: HOME
      });
    case SUIVIE_AUTHENT:
      return checkDossier(demande);
    case SUIVIE_RESULTAT:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: HOME
      });
    default:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: HOME
      });
  }
}

function checkFactureDossier(demande) {
  return __WEBPACK_IMPORTED_MODULE_9__repositories_suivie_dossier_repository__["a" /* default */].checkFactureDossier(demande).then(function (result) {
    if (result.data.codeStatut === 'PRTV_DE_EN_COURS_SAISIE_PAR_LE_TSP') {
      return {
        step: PRTV_DEPOT_FACTURE,
        updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          numeroAnfr: result.data.numeroAnfr,
          codeStatut: result.data.codeStatut,
          demandeEnquete: result.data.demandeEnquete,
          typePersonne: result.data.typePersonne,
          checkCode: result.data.checkCode
        }, demande)
      };
    }
  });
}

function checkDossier(demande) {
  return __WEBPACK_IMPORTED_MODULE_9__repositories_suivie_dossier_repository__["a" /* default */].checkDossier(demande).then(function (result) {
    if (result.data.codeStatut === 'PRTV_DE_EN_COURS_SAISIE_PAR_LE_TSP') {
      return {
        step: PRTV_DEPOT_FACTURE,
        updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          numeroAnfr: result.data.numeroAnfr,
          codeStatut: result.data.codeStatut,
          demandeEnquete: result.data.demandeEnquete,
          typePersonne: result.data.typePersonne,
          checkCode: result.data.checkCode,
          informationsSuivi: result.data.informationsSuivi
        }, demande)
      };
    }
    if (result.data.codeStatut === 'PRTV_DE_NOM_ENREGISTRE') {
      return {
        step: PRTV_INTERFACE_2,
        updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          numeroAnfr: result.data.numeroAnfr,
          codeStatut: result.data.codeStatut,
          demandeEnquete: result.data.demandeEnquete,
          typePersonne: result.data.typePersonne,
          checkCode: result.data.checkCode,
          informationsSuivi: result.data.informationsSuivi
        }, demande)
      };
    }
    return {
      step: SUIVIE_RESULTAT,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        suivieResultat: result.data
      }, demande)
    };
  });
}

function updateDossierWithAntenniste(demande, demandePrtv) {
  return __WEBPACK_IMPORTED_MODULE_6__repositories_reclamation_prtv_repository__["a" /* default */].updateReclamationDemandeFacture(demandePrtv).then(function (result) {
    return {
      step: PRTV_DEPOT_FACTURE_3,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        numeroAnfr: result.data.numeroAnfr,
        codeStatut: result.data.codeStatut
      }, demande)
    };
  });
}

function postLte(demande, demandeLte) {
  return __WEBPACK_IMPORTED_MODULE_7__repositories_reclamation_lte_repository__["a" /* default */].postReclamation(demandeLte).then(function (result) {
    return {
      step: LTE_INTERFACE_2,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        numeroAnfr: result.data.numeroAnfr
      }, demande)
    };
  });
}

function postPrtvAntenniste(demande, demandePrtv) {
  return __WEBPACK_IMPORTED_MODULE_6__repositories_reclamation_prtv_repository__["a" /* default */].postReclamation(demandePrtv).then(function (result) {
    return {
      step: FIN_ANTENNISTE,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        numeroAnfr: result.data.numeroAnfr
      }, demande)
    };
  });
}

// post au milieu de script
function prePostPrtv(demande, demandePrtv) {
  return __WEBPACK_IMPORTED_MODULE_6__repositories_reclamation_prtv_repository__["a" /* default */].postReclamation(demandePrtv).then(function (result) {
    return {
      numeroAnfr: result.data.numeroAnfr,
      checkCode: result.data.checkCode
    };
  });
}
//methode appelé en update au milieu de script
function preUpdatePrtv(demande, demandePrtv) {
  return __WEBPACK_IMPORTED_MODULE_6__repositories_reclamation_prtv_repository__["a" /* default */].updateReclamation(demandePrtv).then(function (result) {
    return {
      numeroAnfr: result.data.numeroAnfr,
      checkCode: result.data.checkCode
    };
  });
}

function updatePrtvFirstStep(demande, demandePrtv) {
  return __WEBPACK_IMPORTED_MODULE_6__repositories_reclamation_prtv_repository__["a" /* default */].updateReclamation(demandePrtv).then(function (result) {
    return {
      step: PRTV_INTERFACE_2,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        numeroAnfr: result.data.numeroAnfr
      }, demande)
    };
  });
}

function updatePrtvupdateReclamationDemandeEnquete(demande, demandePrtv) {
  return __WEBPACK_IMPORTED_MODULE_6__repositories_reclamation_prtv_repository__["a" /* default */].updateReclamationDemandeEnquete(demandePrtv).then(function (result) {
    return {
      step: PRTV_INTERFACE_6,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        numeroAnfr: result.data.numeroAnfr
      }, demande)
    };
  });
}

function searchReamenagement(demande, checkAdresse) {
  var objetAdresse = void 0;
  var codeDepCom = Array('975', '977', '978', '986', '987', '988');
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }

  var nomCommune = renameStCommuneShortName(objetAdresse.commune.nom);
  var insee = objetAdresse.commune.insee.substring(0, 3);

  if (codeDepCom.indexOf(insee) !== -1) {
    // Filtre sur les COM
    return handleAccueilInterface2NextStep(demande, checkAdresse);
  } else {
    if (checkAdresse) {
      var adresseSaisie = (objetAdresse.numero || '') + ' ' + unminifyNameVoie(objetAdresse.voie) + ' ' + objetAdresse.codePostal.codepostal + ' ' + nomCommune;
      // on contrôle l'adresse
      return __WEBPACK_IMPORTED_MODULE_8__repositories_apiadressedatagouv_repository__["a" /* default */].getAdresseApiDataGouv(adresseSaisie).then(function (adresses) {
        if (adresses.length > 0 && checkAdresseValid((objetAdresse.numero || '') + ' ' + objetAdresse.voie, adresses[0].properties.score)) {
          // Normalisation du nom de voie
          demande = __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
            voieShort: normalizeAdresseVoie(adresses[0].properties)
          }, demande);

          var adresse = (objetAdresse.numero || '') + ' ' + demande.voieShort + ' ' + objetAdresse.codePostal.codepostal + ' ' + nomCommune;
          return __WEBPACK_IMPORTED_MODULE_5__repositories_antenne_repository__["a" /* default */].getReamenagement(adresse, objetAdresse.commune.nom).then(function (result) {
            //On vérifie si y'a un objet dans le multiArray
            if (result.data.multiArray.length > 0) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
                step: REAMENAGEMENT,
                updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
                  reamenagement: {
                    phases: result.data
                  }
                }, demande)
              });
            }
            return handleAccueilInterface2NextStep(demande, false);
          });
        } else {
          demande = __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
            voieShort: demande.accueilInterface2.adresse.voie
          }, demande);
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
            step: ACCUEIL_INTERFACE_3,
            updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()(demande)
          });
        }
      });
    } else {
      var adresse = (objetAdresse.numero || '') + ' ' + demande.voieShort + ' ' + objetAdresse.codePostal.codepostal + ' ' + nomCommune;
      return __WEBPACK_IMPORTED_MODULE_5__repositories_antenne_repository__["a" /* default */].getReamenagement(adresse, objetAdresse.commune.nom).then(function (result) {
        //On vérifie si y'a un objet dans le multiArray
        if (result.data.multiArray.length > 0) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
            step: REAMENAGEMENT,
            updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
              reamenagement: {
                phases: result.data
              }
            }, demande)
          });
        }
        return handleAccueilInterface2NextStep(demande, false);
      });
    }
  }
}

function handleAccueilInterface2NextStep(demande, checkAdresse) {
  var multiplex = demande.accueilInterface2.multiplex;
  var chaines = demande.accueilInterface2.chaines;
  var muxConcernes = __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default()(multiplex, function (m) {
    return m.chainesActives.length && __WEBPACK_IMPORTED_MODULE_12_lodash_some___default()(m.chainesActives, function (c) {
      return __WEBPACK_IMPORTED_MODULE_12_lodash_some___default()(chaines, function (c2) {
        return c.id === c2.id;
      });
    });
  });

  var objetAdresse = void 0;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  var codeInsee = objetAdresse.commune.insee;
  var nomCommune = renameStCommuneShortName(objetAdresse.commune.nom);

  // on contrôle l'adresse
  if (checkAdresse) {
    var adresseSaisie = (objetAdresse.numero || '') + ' ' + unminifyNameVoie(objetAdresse.voie) + ' ' + objetAdresse.codePostal.codepostal + ' ' + nomCommune;
    return __WEBPACK_IMPORTED_MODULE_8__repositories_apiadressedatagouv_repository__["a" /* default */].getAdresseApiDataGouv(adresseSaisie).then(function (adresses) {
      if (adresses.length > 0 && checkAdresseValid((objetAdresse.numero || '') + ' ' + objetAdresse.voie, adresses[0].properties.score)) {
        // Normalisation du nom de voie
        demande = __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          voieShort: normalizeAdresseVoie(adresses[0].properties)
        }, demande);
        var adresse = (objetAdresse.numero || '') + ' ' + demande.voieShort + ' ' + objetAdresse.codePostal.codepostal + ' ' + nomCommune;
        // renvoie vers la page etat chaine
        return redirectToETatChaine(codeInsee, adresse, muxConcernes, demande);
      } else {
        demande = __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          voieShort: demande.accueilInterface2.adresse.voie
        }, demande);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: ACCUEIL_INTERFACE_3,
          updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()(demande)
        });
      }
    });
  } else {
    var adresse = (objetAdresse.numero || '') + ' ' + demande.voieShort + ' ' + objetAdresse.codePostal.codepostal + ' ' + nomCommune;
    // renvoie vers la page etat chaine
    return redirectToETatChaine(codeInsee, adresse, muxConcernes, demande);
  }
}

function redirectToETatChaine(codeInsee, adresse, muxConcernes, demande) {
  //On ne vérifie plus si on au moins un antenne
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
    step: ETAT_CHAINES,
    updatedDemande: demande
  });
}

function handleAccueilInterface3Antenniste(demande) {
  return handleAccueilInterface2Antenniste(demande, false);
}

function checkAdresseValid(adresse, score) {
  // Valide l'adresse en fonction du score et de la longueur de l'adresse
  var resultat = false;
  var scoreMin = 0.55;

  if (adresse.length > 15) {
    scoreMin = 0.65;
  }

  if (adresse.length > 20) {
    scoreMin = 0.7;
  }

  if (adresse.length > 25) {
    scoreMin = 0.75;
  }

  if (adresse.length > 30) {
    scoreMin = 0.8;
  }

  if (score >= scoreMin) {
    resultat = true;
  }

  return resultat;
}

function handleAccueilInterface2Antenniste(demande, checkAdresse) {
  var multiplex = demande.accueilInterface2.multiplex;
  var chaines = demande.accueilInterface2.chaines;
  var muxConcernes = __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default()(multiplex, function (m) {
    return m.chainesActives.length && __WEBPACK_IMPORTED_MODULE_12_lodash_some___default()(m.chainesActives, function (c) {
      return __WEBPACK_IMPORTED_MODULE_12_lodash_some___default()(chaines, function (c2) {
        return c.id === c2.id;
      });
    });
  });

  var objetAdresse = void 0;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  var codeInsee = objetAdresse.commune.insee;

  // on contrôle l'adresse
  if (checkAdresse) {
    var nomCommune = renameStCommuneShortName(objetAdresse.commune.nom);
    var adresse = (objetAdresse.numero || '') + ' ' + unminifyNameVoie(objetAdresse.voie) + ' ' + objetAdresse.codePostal.codepostal + ' ' + nomCommune;
    return __WEBPACK_IMPORTED_MODULE_8__repositories_apiadressedatagouv_repository__["a" /* default */].getAdresseApiDataGouv(adresse).then(function (adresses) {
      if (adresses.length > 0 && checkAdresseValid((objetAdresse.numero || '') + ' ' + objetAdresse.voie, adresses[0].properties.score)) {
        // Normalisation du nom de voie
        demande = __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          voieShort: normalizeAdresseVoie(adresses[0].properties)
        }, demande);
        // Vérification de la présence d'un message pour la commune
        return __WEBPACK_IMPORTED_MODULE_4__repositories_message_repository__["a" /* default */].getMessageCommune(codeInsee).then(function (messages) {
          var messageFound = getMessagePourAuMoins(messages.data, muxConcernes, muxConcernes.length);
          if (messageFound) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
              step: ZONE_PERTURBE,
              updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
                zonePerturbe: {
                  message: messageFound
                }
              }, demande)
            });
          }
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
            step: CONTACT,
            updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
              contact: {}
            }, demande)
          });
        });
      } else {
        demande = __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          voieShort: demande.accueilInterface2.adresse.voie
        }, demande);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: ACCUEIL_INTERFACE_3,
          updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()(demande)
        });
      }
    });
  } else {
    // Vérification de la présence d'un message pour la commune
    return __WEBPACK_IMPORTED_MODULE_4__repositories_message_repository__["a" /* default */].getMessageCommune(codeInsee).then(function (messages) {
      var messageFound = getMessagePourAuMoins(messages.data, muxConcernes, muxConcernes.length);
      if (messageFound) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: ZONE_PERTURBE,
          updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
            zonePerturbe: {
              message: messageFound
            }
          }, demande)
        });
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: CONTACT,
        updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          contact: {}
        }, demande)
      });
    });
  }
}

function handleAntenneAccessibleNextStep(demande) {
  // Si oui, on passe a la question suivante
  if (demande.antenneAccessible.source) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
      step: INTERVENTION_ANTENNISTE,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        antenneAccessible: {
          source: demande.antenneAccessible.source
        }
      }, demande)
    });
  } // si  non, fin du processus
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
    step: FIN_ACCUEIL,
    updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
      antenneAccessible: {
        source: demande.antenneAccessible.source
      }
    }, demande)
  });
}

function handleDysfonctionnementInterfaceNextStep(demande) {
  demande.defaultSuspicionLte = false;
  //si c'est un brouillage
  var objetAdresse = void 0;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  var codeInsee = objetAdresse.commune.insee;
  var adresseStruct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["deburr"])((objetAdresse.numero || '') + ' ' + objetAdresse.voie + ' ' + objetAdresse.codePostal.codepostal + ' ' + objetAdresse.commune.nom);
  // Si permanent
  if (demande.dysfonctionnementInterface.natureDysfonctionnement === __WEBPACK_IMPORTED_MODULE_1__modules_common_model__["a" /* PERMANENT_ALEATOIRE */].PERMANENT) {
    // appel au rayon par defaut.
    return __WEBPACK_IMPORTED_MODULE_5__repositories_antenne_repository__["a" /* default */].getAntenneLTEPerturbation(codeInsee, adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 'commune_defaut').then(function (antennes) {
      if (antennes.total > 0) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: LTE_INTERFACE_1,
          updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
            dysfonctionnementInterface: {
              antennes: antennes
            }
          }, demande)
        });
      } else {
        //appel pour avoir la perturbation lte et savoir si c'est un PRTV risque LTE ou non
        var _objetAdresse = void 0;
        if (demande.accueilInterface2.adresse) {
          _objetAdresse = demande.accueilInterface2.adresse;
        }
        var _codeInsee = _objetAdresse.commune.insee;
        var _adresseStruct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["deburr"])((_objetAdresse.numero || '') + ' ' + _objetAdresse.voie + ' ' + _objetAdresse.codePostal.codepostal + '\n         ' + _objetAdresse.commune.nom);
        // appel LTE a 3km
        return __WEBPACK_IMPORTED_MODULE_5__repositories_antenne_repository__["a" /* default */].getAntenneLTEPerturbation(_codeInsee, _adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 3000).then(function (antennes) {
          if (antennes.total > 0) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
              step: LTE_INTERFACE_1,
              updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
                dysfonctionnementInterface: {
                  antennes: antennes
                }
              }, demande)
            });
          } else {
            demande.defaultSuspicionLte = false;
          }
          //save/update et go to PRTV
          var insert = null;
          if (demande.numeroAnfr) {
            insert = preUpdatePrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
          } else {
            insert = prePostPrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
          }
          return insert.then(function (result) {
            demande.numeroAnfr = result.numeroAnfr;
            demande.checkCode = result.checkCode;
            return {
              step: PRTV_INTERFACE_1,
              updatedDemande: demande
            };
          });
        });
      }
    });
  }
  // si aleatoire
  if (demande.dysfonctionnementInterface.natureDysfonctionnement === __WEBPACK_IMPORTED_MODULE_1__modules_common_model__["a" /* PERMANENT_ALEATOIRE */].ALEATOIRE) {
    //appel pour avoir la perturbation lte et savoir si c'est un PRTV risque LTE ou non
    var _objetAdresse2 = void 0;
    if (demande.accueilInterface2.adresse) {
      _objetAdresse2 = demande.accueilInterface2.adresse;
    }
    var _codeInsee2 = _objetAdresse2.commune.insee;
    var _adresseStruct2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["deburr"])((_objetAdresse2.numero || '') + ' ' + _objetAdresse2.voie + ' ' + _objetAdresse2.codePostal.codepostal + '\n     ' + _objetAdresse2.commune.nom);
    // appel LTE a 3km
    return __WEBPACK_IMPORTED_MODULE_5__repositories_antenne_repository__["a" /* default */].getAntenneLTEPerturbation(_codeInsee2, _adresseStruct2, demande.accueilInterface2.datePerturbation, null, null, 3000).then(function (antennes) {
      if (antennes.total > 0) {
        //flag PRTV risque LTE
        demande.defaultSuspicionLte = true;
      } else {
        demande.defaultSuspicionLte = false;
      }
      //save/update et go to PRTV
      var insert = null;
      if (demande.numeroAnfr) {
        insert = preUpdatePrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
      } else {
        insert = prePostPrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
      }
      return insert.then(function (result) {
        demande.numeroAnfr = result.numeroAnfr;
        demande.checkCode = result.checkCode;
        return {
          step: PRTV_INTERFACE_1,
          updatedDemande: demande
        };
      });
    });
  }
}

function handleInterventionAntennisteNextStep(demande) {
  // Si oui, on passe a la question suivante
  if (demande.interventionAntenniste.source) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
      step: SIGNALEMENT_ANTENNISTE,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        interventionAntenniste: {
          source: demande.interventionAntenniste.source
        }
      }, demande)
    });
  } // si  non, type defaut
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
    step: DYSFONCTIONNEMENT_INTERFACE,
    updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
      interventionAntenniste: {
        source: demande.interventionAntenniste.source
      }
    }, demande)
  });
}

function handleSignalementAntennisteNextStep(demande) {
  demande.defaultSuspicionLte = false;
  //si c'est un brouillage
  var objetAdresse = void 0;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  var codeInsee = objetAdresse.commune.insee;
  var adresseStruct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["deburr"])((objetAdresse.numero || '') + ' ' + objetAdresse.voie + ' ' + objetAdresse.codePostal.codepostal + ' ' + objetAdresse.commune.nom);
  if (demande.signalementAntenniste.natureProbleme === __WEBPACK_IMPORTED_MODULE_1__modules_common_model__["b" /* NATURE_PERTURBATION */].BROUILLAGE_4G_5G) {
    // appel LTE a 3km.
    return __WEBPACK_IMPORTED_MODULE_5__repositories_antenne_repository__["a" /* default */].getAntenneLTEPerturbation(codeInsee, adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 3000).then(function (antennes) {
      if (antennes.total > 0) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: LTE_INTERFACE_1,
          updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
            signalementAntenniste: {
              antennes: antennes
            }
          }, demande)
        });
      } else {
        // appel LTE a 5km
        return __WEBPACK_IMPORTED_MODULE_5__repositories_antenne_repository__["a" /* default */].getAntenneLTEPerturbation(codeInsee, adresseStruct, demande.accueilInterface2.datePerturbation, null, null, 5000).then(function (antennes) {
          if (antennes.total > 0) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
              step: LTE_INTERFACE_1,
              updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
                signalementAntenniste: {
                  antennes: antennes
                }
              }, demande)
            });
          } else {
            //PRTV risque LTE
            var insert = null;
            demande.defaultSuspicionLte = true;
            if (demande.numeroAnfr) {
              insert = preUpdatePrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
            } else {
              insert = prePostPrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
            }
            return insert.then(function (result) {
              demande.numeroAnfr = result.numeroAnfr;
              demande.checkCode = result.checkCode;
              return {
                step: PRTV_INTERFACE_1,
                updatedDemande: demande
              };
            });
          }
        });
      }
    });
  } else {
    var insert = null;
    if (demande.numeroAnfr) {
      insert = preUpdatePrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
    } else {
      insert = prePostPrtv(demande, __WEBPACK_IMPORTED_MODULE_10__utils_demande_util__["a" /* default */].demandeToPrtv(demande));
    }
    // on envoie tjrs une promesse
    return insert.then(function (result) {
      demande.numeroAnfr = result.numeroAnfr;
      demande.checkCode = result.checkCode;
      return {
        step: PRTV_INTERFACE_1,
        updatedDemande: demande
      };
    });
  }
}

function handleEtatChainesNextStep(demande) {
  var multiplex = demande.accueilInterface2.multiplex;
  var chaines = demande.accueilInterface2.chaines;
  var muxConcernes = __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default()(multiplex, function (m) {
    return m.chainesActives.length && __WEBPACK_IMPORTED_MODULE_12_lodash_some___default()(m.chainesActives, function (c) {
      return __WEBPACK_IMPORTED_MODULE_12_lodash_some___default()(chaines, function (c2) {
        return c.id === c2.id;
      });
    });
  });

  var objetAdresse = void 0;
  if (demande.accueilInterface2.adresse) {
    objetAdresse = demande.accueilInterface2.adresse;
  }
  var codeInsee = objetAdresse.commune.insee;

  // Vérification de la présence d'un message pour la commune
  if (demande.etatChaines.source === 'oui') {
    return __WEBPACK_IMPORTED_MODULE_4__repositories_message_repository__["a" /* default */].getMessageCommune(codeInsee).then(function (messages) {
      var messageFound = getMessagePourAuMoins(messages.data, muxConcernes, muxConcernes.length);
      if (messageFound) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
          step: INCIDENT_DETECTE,
          updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
            incidentDetecte: {
              message: messageFound
            }
          }, demande)
        });
      }
      //Si aucun message n’est présent, on passe à une question nouvelle sur l’accès à l’antenne
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: ANTENNE_ACCESSIBLE,
        updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          aucunIncidentDetecte: {}
        }, demande)
      });
    });
  } // si la source de la commande est 'non' on fait le test pour tout les multiplex
  return __WEBPACK_IMPORTED_MODULE_4__repositories_message_repository__["a" /* default */].getMessageCommune(codeInsee).then(function (messages) {
    var messageFound = getMessagePourAuMoins(messages.data, multiplex, multiplex.length);
    if (messageFound) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
        step: INCIDENT_DETECTE,
        updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
          incidentDetecte: {
            message: messageFound
          }
        }, demande)
      });
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
      step: ANTENNE_ACCESSIBLE,
      updatedDemande: __WEBPACK_IMPORTED_MODULE_13_lodash_defaultsDeep___default()({
        lteInterface1: {}
      }, demande)
    });
  });
}

function getMessagePourAuMoins(messages, multiplexConcernes, seuil) {
  if (!messages) {
    return null;
  }
  var messagesToReturn = [];
  for (var i = 0; i < messages.length; i++) {
    var message = messages[i];
    // Recherche d'un message qui concerne au moins la moitié des multiplex de la demande
    var nbMultiplexConcernes = countMultiplexCodeInList(message.multiplex, multiplexConcernes);
    if (nbMultiplexConcernes >= seuil) {
      messagesToReturn.push(message);
    }
  }
  if (messagesToReturn.length > 0) {
    return messagesToReturn;
  } else {
    return null;
  }
}

function countMultiplexCodeInList(codes, list) {
  return __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default()(codes, function (m) {
    return __WEBPACK_IMPORTED_MODULE_12_lodash_some___default()(list, function (mc) {
      return mc.code === m;
    });
  }).length;
}

function prevStep(demande, currentStep) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["d" /* $qProvider */])().when({
    step: prevStepSync(demande, currentStep)
  });
}

function prevStepSync(demande, currentStep) {
  switch (currentStep) {
    case ACCUEIL_INTERFACE_1:
      //au retour on affiche la page "qui etes vous"
      window.localStorage.setItem(FROM_RECLAMATION, true);
      return HOME;
    case SUIVIE_AUTHENT:
      //au retour on affiche la page "vous souhaitez"
      window.localStorage.removeItem(FROM_RECLAMATION);
      return HOME;
    case SUIVIE_RESULTAT:
      return SUIVIE_AUTHENT;
    case HOME:
      return;
    case LTE_INTERFACE_1:
      if (demande.signalementAntenniste && demande.signalementAntenniste.natureProbleme !== '' && demande.signalementAntenniste.natureProbleme !== undefined) {
        return SIGNALEMENT_ANTENNISTE;
      }
      return DYSFONCTIONNEMENT_INTERFACE;
    case ETAT_CHAINES:
      if (demande.reamenagement && demande.reamenagement.source === 'oui') {
        return REAMENAGEMENT;
      }
      return ACCUEIL_INTERFACE_2;
    case ANTENNE_ACCESSIBLE:
      return ETAT_CHAINES;
    case INTERVENTION_ANTENNISTE:
      return ANTENNE_ACCESSIBLE;
    case SIGNALEMENT_ANTENNISTE:
      return INTERVENTION_ANTENNISTE;
    case DYSFONCTIONNEMENT_INTERFACE:
      return INTERVENTION_ANTENNISTE;
    case FIN_ACCUEIL:
      return ANTENNE_ACCESSIBLE;
    case REAMENAGEMENT:
      return ACCUEIL_INTERFACE_2;
    case INCIDENT_DETECTE:
      if (demande.etatChaines && demande.incidentDetecte && demande.incidentDetecte.message) {
        return ETAT_CHAINES;
      }
      if (demande.reamenagement && demande.reamenagement.source === 'oui') {
        return REAMENAGEMENT;
      }
      return ACCUEIL_INTERFACE_2;
    case AUCUN_INCIDENT_DETECTE:
      if (demande.etatChaines && demande.etatChaines.source === 'oui') {
        return ETAT_CHAINES;
      }
      if (demande.reamenagement && demande.reamenagement.source === 'oui') {
        return REAMENAGEMENT;
      }
      return ACCUEIL_INTERFACE_2;
    case CONCLUSION:
      if (demande.typePersonne === __WEBPACK_IMPORTED_MODULE_0__modules_accueil_model__["a" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION) {
        return ZONE_PERTURBE;
      }
      if (demande.incidentDetecte && demande.incidentDetecte.message) {
        return INCIDENT_DETECTE;
      }
      if (demande.reamenagement && demande.reamenagement.source === 'fin') {
        return REAMENAGEMENT;
      }
      return AUCUN_INCIDENT_DETECTE;
    case ACCUEIL_INTERFACE_2:
      if (demande.typePersonne === __WEBPACK_IMPORTED_MODULE_0__modules_accueil_model__["a" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION) {
        window.localStorage.setItem(FROM_RECLAMATION, true);
        return HOME;
      }
      return ACCUEIL_INTERFACE_1;
    case ACCUEIL_INTERFACE_3:
      return ACCUEIL_INTERFACE_2;
    case CONSTAT:
      return CONTACT;
    case CONTACT:
      if (demande.zonePerturbe && demande.zonePerturbe.source === 'oui') {
        return ZONE_PERTURBE;
      }
      return ACCUEIL_INTERFACE_2;
    case FIN_ANTENNISTE:
      return CONSTAT;
    case PRTV_INTERFACE_1:
      if (demande.aucunIncidentDetecte && demande.aucunIncidentDetecte.continuerPrtv === true) {
        return AUCUN_INCIDENT_DETECTE;
      }
      if (demande.signalementAntenniste && demande.signalementAntenniste.natureProbleme !== '') {
        return SIGNALEMENT_ANTENNISTE;
      }
      if (demande.dysfonctionnementInterface && demande.dysfonctionnementInterface.natureDysfonctionnement !== '') {
        return DYSFONCTIONNEMENT_INTERFACE;
      }
      return INCIDENT_DETECTE;
    case PRTV_INTERFACE_2:
      return PRTV_INTERFACE_1;
    case PRTV_INTERFACE_3:
      return PRTV_INTERFACE_2;
    case PRTV_INTERFACE_4:
      return PRTV_INTERFACE_3;
    case PRTV_INTERFACE_5:
      return PRTV_INTERFACE_4;
    case PRTV_DEPOT_FACTURE:
      return PRTV_INTERFACE_6;
    case PRTV_DEPOT_FACTURE_2:
      return PRTV_DEPOT_FACTURE;
    case LTE_INTERFACE_2:
      return LTE_INTERFACE_1;
    case ZONE_PERTURBE:
      return ACCUEIL_INTERFACE_2;
    default:
      return HOME;
  }
}

function allPrevSteps(demande, currentStep) {
  var steps = [];
  if (currentStep) {
    steps = [currentStep];
    var prev = currentStep;
    while (prev !== HOME) {
      prev = prevStepSync(demande, prev);
      steps.push(prev);
    }
  }
  return steps;
}

function normalizeAdresseVoie(adresseDataGouv) {
  var adresseNormalized = '';
  if (adresseDataGouv.type === 'housenumber') {
    adresseNormalized = adresseDataGouv.street;
  } else {
    // Précision : Voie sans numéro
    adresseNormalized = adresseDataGouv.name;
  }

  return minifyNameVoie(adresseNormalized);
}

function renameStCommuneShortName(communeShortName) {
  var communeLongName = communeShortName;
  communeLongName = communeLongName.replace(new RegExp('^ST ', 'ig'), 'SAINT ');
  return communeLongName;
}

function minifyNameVoie(voieLongName) {
  var voieShortName = voieLongName;
  voieShortName = voieShortName.replace(new RegExp('^Allée ', 'ig'), 'ALL ').replace(new RegExp('^Arcade ', 'ig'), 'ARC ').replace(new RegExp('^Autoroute ', 'ig'), 'AUT ').replace(new RegExp('^Avenue ', 'ig'), 'AV ').replace(new RegExp('^Boulevard ', 'ig'), 'BD ').replace(new RegExp('^Bretelle ', 'ig'), 'BRE ').replace(new RegExp('^Carrefour ', 'ig'), 'CAR ').replace(new RegExp('^Chaussée ', 'ig'), 'CHAU ').replace(new RegExp('^Chemin ', 'ig'), 'CHE ').replace(new RegExp('^Chemin Départemental ', 'ig'), 'CD ').replace(new RegExp('^Chemin Rural ', 'ig'), 'CR ').replace(new RegExp('^Chemin Vicinal ', 'ig'), 'CV ').replace(new RegExp('^Corniche ', 'ig'), 'COR ').replace(new RegExp('^Cour ', 'ig'), 'COUR ').replace(new RegExp('^Cours ', 'ig'), 'CRS ').replace(new RegExp('^Coursière ', 'ig'), 'CRsIERE ').replace(new RegExp('^Descente ', 'ig'), 'DSC ').replace(new RegExp('^Déviation ', 'ig'), 'DEVI ').replace(new RegExp('^Escalier ', 'ig'), 'ESC ').replace(new RegExp('^Espace ', 'ig'), 'ESPA ').replace(new RegExp('^Esplanade ', 'ig'), 'ESP ').replace(new RegExp('^Grapillon ', 'ig'), 'GRAP ').replace(new RegExp('^Grimpillon ', 'ig'), 'GRIMP ').replace(new RegExp('^Hameau ', 'ig'), 'HAM ').replace(new RegExp('^Impasse ', 'ig'), 'IMP ').replace(new RegExp('^Jardin ', 'ig'), 'JARD ').replace(new RegExp('^Lieudit ', 'ig'), 'LD ').replace(new RegExp('^Lotissement ', 'ig'), 'LOT ').replace(new RegExp('^Montée ', 'ig'), 'MTE ').replace(new RegExp('^Parc ', 'ig'), 'PARC ').replace(new RegExp('^Passage ', 'ig'), 'PAS ').replace(new RegExp('^Passerelle ', 'ig'), 'PLE ').replace(new RegExp('^Place ', 'ig'), 'PLE ').replace(new RegExp('^Placette ', 'ig'), 'PTTE ').replace(new RegExp('^Pont ', 'ig'), 'PONT ').replace(new RegExp('^Promenade ', 'ig'), 'PROM ').replace(new RegExp('^Quai ', 'ig'), 'QUAI ').replace(new RegExp('^Raidillon ', 'ig'), 'RON ').replace(new RegExp('^Rocade ', 'ig'), 'ROC ').replace(new RegExp('^Rond-Point ', 'ig'), 'RPT ').replace(new RegExp('^Route ', 'ig'), 'RTE ').replace(new RegExp('^Route Départementale ', 'ig'), 'RD ').replace(new RegExp('^Route Nationale ', 'ig'), 'RN ').replace(new RegExp('^Rue ', 'ig'), 'R ').replace(new RegExp('^Ruelle ', 'ig'), 'RLE ').replace(new RegExp('^Ruette ', 'ig'), 'RUET ').replace(new RegExp('^Sentier ', 'ig'), 'SEN ').replace(new RegExp('^Square ', 'ig'), 'SQ ').replace(new RegExp('^Tunnel ', 'ig'), 'TUN ').replace(new RegExp('^Venelle ', 'ig'), 'VEN ').replace(new RegExp('^Viaduc ', 'ig'), 'VIAD ').replace(new RegExp('^Voie ', 'ig'), 'VOIE ').replace(new RegExp('^Voie Communale ', 'ig'), 'VC ').replace(new RegExp('^Voie Nouvelle ', 'ig'), 'VN ').replace(new RegExp('^Professeur ', 'ig'), 'PFR ').replace(new RegExp('^Cardinal ', 'ig'), 'CDL ').replace(new RegExp('^Lieutenant ', 'ig'), 'LT ').replace(new RegExp('^Commandant ', 'ig'), 'CDT ').replace(new RegExp('^Colonel ', 'ig'), 'CEL ').replace(new RegExp('^Général ', 'ig'), 'GAL ').replace(new RegExp('^Docteur ', 'ig'), 'DR ').replace(new RegExp('^Amiral ', 'ig'), 'AM ').replace(new RegExp('^Capitaine ', 'ig'), 'CNE ').replace(new RegExp('^Caporal ', 'ig'), 'CAL ').replace(new RegExp('^Maréchal ', 'ig'), 'MAL ').replace(new RegExp('^Président ', 'ig'), 'PDT ').replace(new RegExp('^Sergent ', 'ig'), 'SGT ').replace(new RegExp('^Saint ', 'ig'), 'Ste ').replace(new RegExp('^Sainte ', 'ig'), 'STE ').replace(new RegExp('^Intérieur ', 'ig'), 'INT ').replace(new RegExp('^Extérieur ', 'ig'), 'EXT ').replace(new RegExp('^Police ', 'ig'), 'POL ').replace(new RegExp('^Résidence ', 'ig'), 'RESID ').replace(new RegExp('^Ancien ', 'ig'), 'ANCE ').replace(new RegExp('^Cimetière ', 'ig'), 'CIM ').replace(new RegExp('^Arrondissement ', 'ig'), 'ARROND ').replace(new RegExp('^Association ', 'ig'), 'ASS ').replace(new RegExp('^Chapelle ', 'ig'), 'CHAP ').replace(new RegExp('^Collège ', 'ig'), 'COLL ').replace(new RegExp('^Domaine ', 'ig'), 'DOM ').replace(new RegExp('^Maternelle ', 'ig'), 'MATER ').replace(new RegExp('^Eglise ', 'ig'), 'EGL ').replace(new RegExp('^Gendarmerie ', 'ig'), 'GEND ').replace(new RegExp('^Quartier ', 'ig'), 'QUART ').replace(new RegExp('^Lotissement ', 'ig'), 'LOT ');
  return voieShortName;
}

function unminifyNameVoie(voieShortName) {
  var voieLongName = voieShortName;
  voieLongName = voieLongName.replace(new RegExp('^ALL ', 'ig'), 'Allée ').replace(new RegExp('^ARC ', 'ig'), 'Arcade ').replace(new RegExp('^AUT ', 'ig'), 'Autoroute ').replace(new RegExp('^AV ', 'ig'), 'Avenue ').replace(new RegExp('^BAD ', 'ig'), 'Boulevard ').replace(new RegExp('^BRE ', 'ig'), 'Bretelle ').replace(new RegExp('^CAR ', 'ig'), 'Carrefour ').replace(new RegExp('^CHAU ', 'ig'), 'Chaussée ').replace(new RegExp('^CHE ', 'ig'), 'Chemin ').replace(new RegExp('^CD ', 'ig'), 'Chemin Départemental ').replace(new RegExp('^CR ', 'ig'), 'Chemin Rural ').replace(new RegExp('^CV ', 'ig'), 'Chemin Vicinal ').replace(new RegExp('^COR ', 'ig'), 'Corniche ').replace(new RegExp('^COUR ', 'ig'), 'Cour ').replace(new RegExp('^CRS ', 'ig'), 'Cours ').replace(new RegExp('^CRsIERE ', 'ig'), 'Coursière ').replace(new RegExp('^DSC ', 'ig'), 'Descente ').replace(new RegExp('^DEVI ', 'ig'), 'Déviation ').replace(new RegExp('^ESC ', 'ig'), 'Escalier ');
  return voieLongName;
}



/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_demande_repository__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__providers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_DEMANDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_DEMANDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAILURE_DEMANDE; });







var REQUEST_DEMANDE = 'REQUEST_DEMANDE';
var RECEIVE_DEMANDE = 'RECEIVE_DEMANDE';
var FAILURE_DEMANDE = 'FAILURE_DEMANDE';

function reset() {
  return function (dispatch) {
    dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskStarted());
    __WEBPACK_IMPORTED_MODULE_1__repositories_demande_repository__["a" /* default */].cacheDemande({}).then(function () {
      dispatch(receiveDemande({}));
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskDone());
    }, function () {
      dispatch(failureDemande());
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskFailed('Une erreur est survenue'));
    });
  };
}

function failureDemande() {
  return {
    type: FAILURE_DEMANDE,
    payload: {}
  };
}

function receiveDemande(demande) {
  return {
    type: RECEIVE_DEMANDE,
    payload: {
      demande: demande
    }
  };
}

function requestDemande() {
  return {
    type: REQUEST_DEMANDE,
    payload: {}
  };
}

function cacheDemandeAndGo(demande, currentStep, back) {
  return function (dispatch) {
    dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskStarted());
    __WEBPACK_IMPORTED_MODULE_1__repositories_demande_repository__["a" /* default */].cacheDemande(demande).then(function () {
      var nextStepPromise = back ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["a" /* prevStep */])(demande, currentStep) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["b" /* nextStep */])(demande, currentStep);
      nextStepPromise.then(function (_ref) {
        var step = _ref.step,
            updatedDemande = _ref.updatedDemande;

        // Si le calcul de la route ajoute des données dans la demande, on récupère la nouvelle version
        if (updatedDemande) {
          __WEBPACK_IMPORTED_MODULE_1__repositories_demande_repository__["a" /* default */].cacheDemande(updatedDemande).then(function () {
            dispatch(receiveDemande(updatedDemande));
            dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskDone());
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["c" /* $stateProvider */])().go(step);
          });
        } else {
          dispatch(receiveDemande(demande));
          dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskDone());
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__providers__["c" /* $stateProvider */])().go(step);
        }
      }, function () {
        dispatch(failureDemande());
        dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskFailed('Une erreur est survenue'));
      });
    });
  };
}

function startNewDemande(data) {
  return function (dispatch) {
    dispatch(cacheDemandeAndGo(data, __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].HOME));
  };
}

function startSuivieDossier(data) {
  return function (dispatch) {
    dispatch(cacheDemandeAndGo(data, __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].HOME));
  };
}

function loadDemande(step) {
  return function (dispatch) {
    dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskStarted());
    dispatch(requestDemande());
    __WEBPACK_IMPORTED_MODULE_1__repositories_demande_repository__["a" /* default */].loadDemande().then(function (demande) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["d" /* validateDemandeForStep */])(demande, step)) {
        dispatch(failureDemande());
        dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskFailed('Données non trouvées pour la demande.'));
      } else {
        dispatch(receiveDemande(demande));
        dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskDone());
      }
    }, function () {
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskFailed());
      dispatch(failureDemande());
    });
  };
}

function updateAccueilInterface1(accueilInterface1, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      accueilInterface1: accueilInterface1
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_1, back));
  };
}

function updateContact(contact, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      contact: contact
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].CONTACT, back));
  };
}

function updateZonePerturbe(zonePerturbe, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      zonePerturbe: zonePerturbe
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].ZONE_PERTURBE, back));
  };
}

function updateConstat(constat, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      constat: constat
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].CONSTAT, back));
  };
}

function updateAccueilInterface2(accueilInterface2, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      accueilInterface2: accueilInterface2
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_2, back));
  };
}

function updateAccueilInterface3(accueilInterface3, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({}).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_3, back));
  };
}

function updateEtatChaines(etatChaines, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      etatChaines: etatChaines
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].ETAT_CHAINES, back));
  };
}

function updateReamenagement(reamenagement, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      reamenagement: reamenagement
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].REAMENAGEMENT, back));
  };
}

function updateAntenneAccessible(antenneAccessible, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      antenneAccessible: antenneAccessible
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].ANTENNE_ACCESSIBLE, back));
  };
}

function updateFinAccueil(fin, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      fin: fin
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].FIN_ACCUEIL, back));
  };
}

function updateInterventionAntenniste(interventionAntenniste, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      interventionAntenniste: interventionAntenniste
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].INTERVENTION_ANTENNISTE, back));
  };
}

function updateSignalementAntenniste(signalementAntenniste, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      signalementAntenniste: signalementAntenniste
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].SIGNALEMENT_ANTENNISTE, back));
  };
}

function updateIncidentDetecte(incidentDetecte, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      incidentDetecte: incidentDetecte
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].INCIDENT_DETECTE, back));
  };
}

function updateAucunIncidentDetecte(aucunIncidentDetecte, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      aucunIncidentDetecte: aucunIncidentDetecte
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].AUCUN_INCIDENT_DETECTE, back));
  };
}

function updateDysfonctionnementInterface(dysfonctionnementInterface, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      dysfonctionnementInterface: dysfonctionnementInterface
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].DYSFONCTIONNEMENT_INTERFACE, back));
  };
}

function updateConclusion(conclusion, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      conclusion: conclusion
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].CONCLUSION, back));
  };
}

function updateFinAntenniste(finAntenniste, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      finAntenniste: finAntenniste
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].FIN_ANTENNISTE, back));
  };
}

function updateLteInterface1(lteInterface1, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      lteInterface1: lteInterface1
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].LTE_INTERFACE_1, back));
  };
}

function updateLteInterface2(lteInterface2, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      lteInterface2: lteInterface2
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].LTE_INTERFACE_2, back));
  };
}

function updatePrtvInterface1(prtvInterface1, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface1: prtvInterface1
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_1, back));
  };
}

function updatePrtvInterface2(prtvInterface2, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface2: prtvInterface2
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_2, back));
  };
}

function updatePrtvInterface3(prtvInterface3, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface3: prtvInterface3
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_3, back));
  };
}

function updatePrtvInterface4(prtvInterface4, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface4: prtvInterface4
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_4, back));
  };
}

function updatePrtvInterface5(prtvInterface5, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface5: prtvInterface5
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_5, back));
  };
}

function updatePrtv6ToFacture(prtvInterface6, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvInterface6: prtvInterface6
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_6, back));
  };
}
function updatePrtvDepotFacture(prtvDepotFacture, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvDepotFacture: prtvDepotFacture
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE, back));
  };
}

function updatePrtvDepotFacture2(prtvDepotFacture2, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvDepotFacture2: prtvDepotFacture2
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE_2, back));
  };
}

function updatePrtvDepotFacture3(prtvDepotFacture3, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      prtvDepotFacture3: prtvDepotFacture3
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE_3, back));
  };
}

function updateSuivieAuthent(suivieAuthent, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      suivieAuthent: suivieAuthent
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].SUIVIE_AUTHENT, back));
  };
}

function updateSuivieResultat(suivieResultat, back) {
  return function (dispatch, getState) {
    dispatch(cacheDemandeAndGo(getState().demande.data.merge({
      suivieResultat: suivieResultat
    }).asMutable(), __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].SUIVIE_RESULTAT, back));
  };
}
/* harmony default export */ __webpack_exports__["d"] = {
  reset: reset,
  startNewDemande: startNewDemande,
  updateAccueilInterface1: updateAccueilInterface1,
  updateAccueilInterface2: updateAccueilInterface2,
  updateAccueilInterface3: updateAccueilInterface3,
  updateEtatChaines: updateEtatChaines,
  updateIncidentDetecte: updateIncidentDetecte,
  updateAucunIncidentDetecte: updateAucunIncidentDetecte,
  updateDysfonctionnementInterface: updateDysfonctionnementInterface,
  updateConclusion: updateConclusion,
  updateLteInterface1: updateLteInterface1,
  updateLteInterface2: updateLteInterface2,
  updatePrtvInterface1: updatePrtvInterface1,
  updatePrtvInterface2: updatePrtvInterface2,
  updatePrtvInterface3: updatePrtvInterface3,
  updatePrtvInterface4: updatePrtvInterface4,
  updatePrtvInterface5: updatePrtvInterface5,
  updatePrtv6ToFacture: updatePrtv6ToFacture,
  updatePrtvDepotFacture: updatePrtvDepotFacture,
  updatePrtvDepotFacture2: updatePrtvDepotFacture2,
  updatePrtvDepotFacture3: updatePrtvDepotFacture3,
  updateZonePerturbe: updateZonePerturbe,
  updateContact: updateContact,
  updateConstat: updateConstat,
  updateFinAntenniste: updateFinAntenniste,
  loadDemande: loadDemande,
  updateReamenagement: updateReamenagement,
  updateAntenneAccessible: updateAntenneAccessible,
  updateInterventionAntenniste: updateInterventionAntenniste,
  updateSignalementAntenniste: updateSignalementAntenniste,
  updateFinAccueil: updateFinAccueil,
  startSuivieDossier: startSuivieDossier,
  updateSuivieAuthent: updateSuivieAuthent,
  updateSuivieResultat: updateSuivieResultat
};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODE_RACCORDEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TYPE_PROBLEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TYPE_LOGEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return OUI_NON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OUI_NON_NSP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MAUVAISE_INSTABLE_BONNE_EXCELLENTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PERTURBATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TYPE_CONSTRUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NATURE_PERTURBATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PERMANENT_ALEATOIRE; });
var OUI = 'OUI';
var NON = 'NON';
var NE_SAIT_PAS = 'NE_SAIT_PAS';
var INDIVIDUEL = 'INDIVIDUEL';
var COLLECTIF = 'COLLECTIF';
var NSP = 'NSP';
var IMMEUBLE = 'IMMEUBLE';
var MAISON = 'MAISON';
var PERMANENT = 'PERMANENT';
var TEMPORAIRE = 'TEMPORAIRE';
var MAUVAISE = 'MAUVAISE';
var INSTABLE = 'INSTABLE';
var BONNE = 'BONNE';
var EXCELLENTE = 'EXCELLENTE';
var PERMANENTES = 'PERMANENTES';
var ALEATOIRES = 'ALEATOIRES';
var ALEATOIRE = 'ALEATOIRE';
var EOLIENNE = 'EOLIENNE';
var ANTENNE_EN_PANNE = 'ANTENNE_EN_PANNE';
var PROBLEME_PREAMPLI = 'PROBLEME_PREAMPLI';
var SIGNAL_ABSENT_OU_FAIBLE = 'SIGNAL_ABSENT_OU_FAIBLE';
var PROBLEME_DIFFUSION = 'PROBLEME_DIFFUSION';
var BROUILLAGE_4G_5G = 'BROUILLAGE_4G_5G';
var AUTRE = 'AUTRE';

var OUI_NON = {
  OUI: OUI,
  NON: NON,

  VALUES: [OUI, NON]
};

var OUI_NON_NSP = {
  OUI: OUI,
  NON: NON,
  NE_SAIT_PAS: NE_SAIT_PAS,

  VALUES: [OUI, NON, NE_SAIT_PAS],
  DEFAULT_VALUE: OUI
};

var MODE_RACCORDEMENT = {
  INDIVIDUEL: INDIVIDUEL,
  COLLECTIF: COLLECTIF,
  NSP: NSP,

  VALUES: [INDIVIDUEL, COLLECTIF, NSP],
  DEFAULT_VALUE: INDIVIDUEL
};

var TYPE_PROBLEME = {
  TEMPORAIRE: TEMPORAIRE,
  PERMANENT: PERMANENT,

  VALUES: [TEMPORAIRE, PERMANENT],

  DEFAULT_VALUE: TEMPORAIRE
};

var TYPE_LOGEMENT = {
  IMMEUBLE: IMMEUBLE,
  MAISON: MAISON,

  VALUES: [IMMEUBLE, MAISON],

  DEFAULT_VALUE: IMMEUBLE
};

var MAUVAISE_INSTABLE_BONNE_EXCELLENTE = {
  MAUVAISE: MAUVAISE,
  INSTABLE: INSTABLE,
  BONNE: BONNE,
  EXCELLENTE: EXCELLENTE,

  VALUES: [MAUVAISE, INSTABLE, BONNE, EXCELLENTE]
};

var PERTURBATIONS = {
  PERMANENTES: PERMANENTES,
  ALEATOIRES: ALEATOIRES,

  VALUES: [PERMANENTES, ALEATOIRES]
};

var TYPE_CONSTRUCTION = {
  EOLIENNE: EOLIENNE,
  IMMEUBLE: IMMEUBLE,

  VALUES: [EOLIENNE, IMMEUBLE]
};

var NATURE_PERTURBATION = {
  ANTENNE_EN_PANNE: ANTENNE_EN_PANNE,
  PROBLEME_PREAMPLI: PROBLEME_PREAMPLI,
  SIGNAL_ABSENT_OU_FAIBLE: SIGNAL_ABSENT_OU_FAIBLE,
  PROBLEME_DIFFUSION: PROBLEME_DIFFUSION,
  BROUILLAGE_4G_5G: BROUILLAGE_4G_5G,
  AUTRE: AUTRE,

  VALUES: [ANTENNE_EN_PANNE, PROBLEME_PREAMPLI, SIGNAL_ABSENT_OU_FAIBLE, PROBLEME_DIFFUSION, BROUILLAGE_4G_5G, AUTRE]
};

var PERMANENT_ALEATOIRE = {
  PERMANENT: PERMANENT,
  ALEATOIRE: ALEATOIRE,

  VALUES: [PERMANENT, ALEATOIRE]
};



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return $httpProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return $qProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return $stateProvider; });
/* unused harmony export $reduxProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $notificationProvider; });
/* unused harmony export $routesUtilProvider */
var element = void 0;

function getInjector() {
  if (!element) {
    element = angular.element(document.body);
  }
  return element.injector();
}

var $httpProvider = function $httpProvider() {
  return getInjector().get('$http');
};
var $qProvider = function $qProvider() {
  return getInjector().get('$q');
};
var $stateProvider = function $stateProvider() {
  return getInjector().get('$state');
};
var $reduxProvider = function $reduxProvider() {
  return getInjector().get('$ngRedux');
};
var $notificationProvider = function $notificationProvider() {
  return getInjector().get('Notification');
};
var $routesUtilProvider = function $routesUtilProvider() {
  return getInjector().get('RoutesUtil');
};



/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  // Définir ici les URL des services à appeler (possibilité d'avoir des pathParam)
  // getXXX: '/get/{id}'
  getChainesLocales: 'api/reamenagementChaines?adresse={adresseInsee}&codeinsee={codeInsee}',
  getMultiplex: '/api/multiplex.json',
  getAntennisteList: '/api/antennistes/getAllAntenniste?numeroanfr={numeroAnfr}&rayon={rayonMax}',
  getTypePerturbation: '/api/typeprtvperturbation.json',
  getTypeDefaut: '/api/typeprtvdefaut.json',
  searchCommune: '/api/communes/nom.json',
  searchCodepostal: '/api/communes/codepostal.json',
  searchEmetteurTnt: '/api/emetteurtnt.json',
  getMessageCommune: '/api/messages/getmessagecommune',
  getAntenneLTEPerturbation: '/api/perturbation_lte',
  postPrtv: '/api/reclamation_prtv/create',
  updatePrtv: '/api/reclamation_prtv/update',
  updatePrtvWithFactureAntenniste: '/api/reclamation_prtv/updateWithFacture',
  updatePrtvDemandeEnquete: '/api/reclamation_prtv/updateDemandeEnquete',
  postLte: '/api/reclamation_lte/create',
  getPrtvPdf: '/api/reclamation_prtv/pdf',
  searchSuspicionLte: '/api/emetteurlte/suspicionlte?voie={concatVoie}&codepostal={codePostal}&commune={nomCommune}',
  getReamenagement: '/api/reamenagement',
  checkDossier: '/api/reclamation_prtv/suividossier?numeroanfr={numeroAnfr}&codepostal={codePostal}&nom={nomUser}&prenom={prenomUser}',
  remplirDemande: '/api/reclamation_prtv/remplirdemandeenquete?numeroanfr={numeroAnfr}&checkcode={checkCode}&accept={accepter}',
  imprimerDemande: '/api/reclamation_prtv/impressiondemandeenquete?numeroanfr={numeroAnfr}&checkcode={checkCode}&impressionde={impressionDe}'
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CIVILITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TYPE_PERSONNE; });
var MADAME = 'MME';
var MONSIEUR = 'M';

var PARTICULIER = 'PART';
var PROFESSIONNEL_RECEPTION = 'PRO';
var SYNDIC_BAILLEUR = 'GEST_SYNDIC';
var ELU = 'ELU';
var JOURNALISTE = 'PRO_JOURNALISTE';
var AUTRE = 'AUTRE';

var CIVILITE = {
  MADAME: MADAME,
  MONSIEUR: MONSIEUR,

  VALUES: [MADAME, MONSIEUR],
  DEFAULT_VALUE: MADAME
};

var TYPE_PERSONNE = {
  PARTICULIER: PARTICULIER,
  PROFESSIONNEL_RECEPTION: PROFESSIONNEL_RECEPTION,
  SYNDIC_BAILLEUR: SYNDIC_BAILLEUR,
  ELU: ELU,
  JOURNALISTE: JOURNALISTE,
  AUTRE: AUTRE,

  VALUES: [PARTICULIER, PROFESSIONNEL_RECEPTION, SYNDIC_BAILLEUR, ELU, JOURNALISTE, AUTRE]
};



/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__providers__ = __webpack_require__(3);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TASK_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TASK_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET; });


var TASK_STARTED = 'TASK_STARTED';
var TASK_DONE = 'TASK_DONE';
var RESET = 'RESET';

function taskStarted() {
  return {
    type: TASK_STARTED,
    payload: {}
  };
}

function taskDone() {
  return {
    type: TASK_DONE,
    payload: {}
  };
}

function reset() {
  return {
    type: RESET,
    payload: {}
  };
}

function taskSucceeded() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Opération réalisée';

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__providers__["a" /* $notificationProvider */])().success(msg);
  return taskDone();
}

function taskFailed() {
  var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Une erreur est survenue';

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__providers__["a" /* $notificationProvider */])().error(msg);
  return taskDone();
}

/* harmony default export */ __webpack_exports__["d"] = {
  reset: reset,
  taskStarted: taskStarted,
  taskFailed: taskFailed,
  taskSucceeded: taskSucceeded,
  taskDone: taskDone
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPE_PERTURBATEUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OTHER_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NO_ANSWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MINUMUM_DISTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAXIMUM_DISTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISTANCE_STEP; });
var CONSTRUCTION = 'CONSTRUCTION';
var EOLIENNE = 'EOLIENNE';
var OTHER_VALUE = 'Autre';
var NO_ANSWER = 'N’a pas répondu';
var MINUMUM_DISTANCE = 5000;
var MAXIMUM_DISTANCE = 50000;
var DISTANCE_STEP = 5000;

var TYPE_PERTURBATEUR = {
  CONSTRUCTION: CONSTRUCTION,
  EOLIENNE: EOLIENNE,

  VALUES: [CONSTRUCTION, EOLIENNE]
};



/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_multiplex_repository__ = __webpack_require__(556);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_MULTIPLEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_MULTIPLEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAILURE_MULTIPLEX; });




var REQUEST_MULTIPLEX = 'REQUEST_MULTIPLEX';
var RECEIVE_MULTIPLEX = 'RECEIVE_MULTIPLEX';
var FAILURE_MULTIPLEX = 'FAILURE_MULTIPLEX';

function failureMultiplex() {
  return {
    type: FAILURE_MULTIPLEX,
    payload: {}
  };
}

function receiveMultiplex(data) {
  return {
    type: RECEIVE_MULTIPLEX,
    payload: {
      data: data
    }
  };
}

function requestMultiplex() {
  return {
    type: REQUEST_MULTIPLEX,
    payload: {}
  };
}

function loadData() {
  return function (dispatch) {
    dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskStarted());
    dispatch(requestMultiplex());
    __WEBPACK_IMPORTED_MODULE_1__repositories_multiplex_repository__["a" /* default */].getMultiplexList().then(function (response) {
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskDone());
      dispatch(receiveMultiplex(response));
    }, function () {
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskFailed());
      dispatch(failureMultiplex());
    });
  };
}

/* harmony default export */ __webpack_exports__["d"] = {
  loadData: loadData
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODE_RECEPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPE_PERSONNE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RAISON_DEMANDE; });
var ANTENNE_RATEAU = 'ANTENNE_RATEAU';
var ANTENNE_INTERIEURE = 'ANTENNE_INTERIEURE';
var ADSL_FIBRE = 'ADSL_FIBRE';
var PARABOLE = 'PARABOLE';
var CABLE = 'CABLE';
var AUTRE = 'AUTRE';
var DEFAUT_RECEPTION = 'DEFAUT_RECEPTION';
var DEMANDE_AIDE = 'DEMANDE_AIDE';
var PARTICULIER = 'PART';
var PROFESSIONNEL_RECEPTION = 'PRO';
var SYNDIC_BAILLEUR = 'GEST_SYNDIC';
var ELU = 'ELU';
var JOURNALISTE = 'PRO_JOURNALISTE';

var MODE_RECEPTION = {
  ANTENNE_RATEAU: ANTENNE_RATEAU,
  ANTENNE_INTERIEURE: ANTENNE_INTERIEURE,
  ADSL_FIBRE: ADSL_FIBRE,
  PARABOLE: PARABOLE,
  CABLE: CABLE,
  AUTRE: AUTRE,

  VALUES: [ANTENNE_RATEAU, ANTENNE_INTERIEURE, ADSL_FIBRE, PARABOLE, CABLE, AUTRE]
};

var RAISON_DEMANDE = {
  DEFAUT_RECEPTION: DEFAUT_RECEPTION,
  DEMANDE_AIDE: DEMANDE_AIDE,

  VALUES: [DEFAUT_RECEPTION, DEMANDE_AIDE]
};

var TYPE_PERSONNE = {
  PARTICULIER: PARTICULIER,
  PROFESSIONNEL_RECEPTION: PROFESSIONNEL_RECEPTION,
  SYNDIC_BAILLEUR: SYNDIC_BAILLEUR,
  ELU: ELU,
  JOURNALISTE: JOURNALISTE,
  AUTRE: AUTRE,

  VALUES: [PARTICULIER, PROFESSIONNEL_RECEPTION, SYNDIC_BAILLEUR, ELU, JOURNALISTE, AUTRE]
};



/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMAIL_PATTERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TELEPHONE_PATTERN; });
var EMAIL_PATTERN = new RegExp(/^[^\s@]+@[^\s@0-9]+\.[^\s@0-9]+$/);
var TELEPHONE_PATTERN = new RegExp(/^\d{10}$/);

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_type_defaut_repository__ = __webpack_require__(560);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_TYPE_DEFAUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_TYPE_DEFAUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAILURE_TYPE_DEFAUT; });




var REQUEST_TYPE_DEFAUT = 'REQUEST_TYPE_DEFAUT';
var RECEIVE_TYPE_DEFAUT = 'RECEIVE_TYPE_DEFAUT';
var FAILURE_TYPE_DEFAUT = 'FAILURE_TYPE_DEFAUT';

function failureTypeDefaut() {
  return {
    type: FAILURE_TYPE_DEFAUT,
    payload: {}
  };
}

function receiveTypeDefaut(data) {
  return {
    type: RECEIVE_TYPE_DEFAUT,
    payload: {
      data: data
    }
  };
}

function requestTypeDefaut() {
  return {
    type: REQUEST_TYPE_DEFAUT,
    payload: {}
  };
}

function loadData() {
  return function (dispatch, getState) {
    if (getState().typeDefaut.fetching || getState().typeDefaut.data) {
      // Chargement en cours ou on a des données, on ne fait rien
      return;
    }
    dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskStarted());
    dispatch(requestTypeDefaut());
    __WEBPACK_IMPORTED_MODULE_1__repositories_type_defaut_repository__["a" /* default */].load().then(function (response) {
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskDone());
      dispatch(receiveTypeDefaut(response.data));
    }, function () {
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskFailed());
      dispatch(failureTypeDefaut());
    });
  };
}

/* harmony default export */ __webpack_exports__["d"] = {
  loadData: loadData
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function validate(value) {
  if (value === undefined || value === '') {
    return true;
  }
  var date = new Date(dateFromMask(value));
  return !isNaN(date.valueOf());
}

function dateToMask(value) {
  if (!value) {
    return value;
  }
  if (value.indexOf('-') === -1) {
    return value;
  }
  var res = value.replace(/-/g, '');
  return res.substr(6, 2) + res.substr(4, 2) + res.substr(0, 4);
}

function dateFromMask(value) {
  if (!value) {
    return value;
  }
  var res = value.replace(/\//g, '');
  return res.substr(4, 4) + '-' + res.substr(2, 2) + '-' + res.substr(0, 2);
}

/* harmony default export */ __webpack_exports__["a"] = { validate: validate, dateFromMask: dateFromMask, dateToMask: dateToMask };

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_type_perturbation_repository__ = __webpack_require__(561);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_TYPE_PERTURBATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_TYPE_PERTURBATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAILURE_TYPE_PERTURBATION; });




var REQUEST_TYPE_PERTURBATION = 'REQUEST_TYPE_PERTURBATION';
var RECEIVE_TYPE_PERTURBATION = 'RECEIVE_TYPE_PERTURBATION';
var FAILURE_TYPE_PERTURBATION = 'FAILURE_TYPE_PERTURBATION';

function failureTypePerturbation() {
  return {
    type: FAILURE_TYPE_PERTURBATION,
    payload: {}
  };
}

function receiveTypePerturbation(data) {
  return {
    type: RECEIVE_TYPE_PERTURBATION,
    payload: {
      data: data
    }
  };
}

function requestTypePerturbation() {
  return {
    type: REQUEST_TYPE_PERTURBATION,
    payload: {}
  };
}

function loadData() {
  return function (dispatch, getState) {
    if (getState().typePerturbation.fetching || getState().typePerturbation.data) {
      // Chargement en cours ou on a des données, on ne fait rien
      return;
    }
    dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskStarted());
    dispatch(requestTypePerturbation());
    __WEBPACK_IMPORTED_MODULE_1__repositories_type_perturbation_repository__["a" /* default */].load().then(function (response) {
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskDone());
      dispatch(receiveTypePerturbation(response.data));
    }, function () {
      dispatch(__WEBPACK_IMPORTED_MODULE_0__general_actions__["d" /* default */].taskFailed());
      dispatch(failureTypePerturbation());
    });
  };
}

/* harmony default export */ __webpack_exports__["d"] = {
  loadData: loadData
};

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* CIVILITE */].MADAME:
        return 'Madame';
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* CIVILITE */].MONSIEUR:
        return 'Monsieur';
      default:
        return '';
    }
  };
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["d" /* OUI_NON */].OUI:
        return 'Oui';
      case __WEBPACK_IMPORTED_MODULE_0__model__["d" /* OUI_NON */].NON:
        return 'Non';
      default:
        return '';
    }
  };
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function searchEmetteurtnt(query) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].searchEmetteurTnt,
    params: {
      query: query,
      page: page,
      start: start,
      limit: limit
    }
  }).then(function (r) {
    return r.data;
  });
}

function searchSuspicionLte(concatVoie, codePostal, nomCommune) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].searchSuspicionLte,
    urlConfig: {
      pathParams: {
        voie: concatVoie,
        codepostal: codePostal,
        commune: nomCommune
      }
    }
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  searchEmetteurtnt: searchEmetteurtnt,
  searchSuspicionLte: searchSuspicionLte
};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony export (immutable) */ __webpack_exports__["a"] = deeply;





function deeply(m) {
  return function (obj, fn) {
    return m(__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(obj, function (v) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject___default()(v)) {
        return deeply(m)(v, fn);
      }
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(v)) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(v, function (v2) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject___default()(v2) || __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(v2) ? deeply(m)(v2, fn) : v2;
        });
      }
      return v;
    }), fn);
  };
}

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration_js__ = __webpack_require__(5);


function buildPdfUrl(numeroAnfr, checkCode) {
  return __WEBPACK_IMPORTED_MODULE_0__configuration_js__["a" /* default */].getPrtvPdf + '?numeroanfr=' + numeroAnfr + '&checkcode=' + checkCode;
}

function buildPdfUrl(numeroAnfr, checkCode, deEnvoyee) {
  return __WEBPACK_IMPORTED_MODULE_0__configuration_js__["a" /* default */].getPrtvPdf + '?numeroanfr=' + numeroAnfr + '&checkcode=' + checkCode + '&deenvoyee=' + deEnvoyee;
}

function openPdfUrl(numeroAnfr, checkCode) {
  window.open(buildPdfUrl(numeroAnfr, checkCode), '_blank');
}

function openPdfUrl(numeroAnfr, checkCode, deEnvoyee) {
  window.open(buildPdfUrl(numeroAnfr, checkCode, deEnvoyee), '_blank');
}

/* harmony default export */ __webpack_exports__["a"] = {
  buildPdfUrl: buildPdfUrl,
  openPdfUrl: openPdfUrl
};

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_deburr__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_deburr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_deburr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_words__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_words___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_words__);
/* harmony export (immutable) */ __webpack_exports__["a"] = snakeCase;



/** Used to match words to create compound words. */
var reWords = function () {
  var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]';
  var lower = '[a-z\\xdf-\\xf6\\xf8-\\xff0-9]+';

  return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper, 'g');
}();

function snakeCase(string) {
  var index = -1;
  var array = __WEBPACK_IMPORTED_MODULE_1_lodash_words___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_deburr___default()(string), reWords);
  var length = array.length;
  var result = '';

  while (++index < length) {
    result = handleWorld(result, array[index], index);
  }
  return result;
}

function handleWorld(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
}

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = "<div class=\"ui-select-container selectize-control single\" ng-class=\"{'open': $select.open}\">\n  <div class=\"selectize-input\" ng-class=\"{'focus': $select.open, 'disabled': $select.disabled, 'selectize-focus' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\">\n    <div class=\"ui-select-match\"></div>\n    <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{'ui-select-search-hidden':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\"\n        ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\">\n    <span ng-show=\"$select.refreshing\" class=\"ui-select-refreshing icon-loading-hourglass\"></span>\n  </div>\n  <div class=\"ui-select-choices\"></div>\n  <div class=\"ui-select-no-choice\"></div>\n</div>";

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MainRouterConfig;
// @ngInject
function MainRouterConfig($urlRouterProvider) {
  $urlRouterProvider.otherwise('/');
}

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_accueil_interface_1_accueil_interface_1_component__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_accueil_interface_2_accueil_interface_2_component__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accueil_interface_3_accueil_interface_3_component__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_etat_chaines_etat_chaines_component__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reamenagement_reamenagement_component__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_antenne_accessible_antenne_accessible_component__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_fin_accueil_fin_accueil_component__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_intervention_antenniste_intervention_antenniste_component__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_signalement_antenniste_signalement_antenniste_component__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_incident_detecte_incident_detecte_component__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_aucun_incident_detecte_aucun_incident_detecte_component__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dysfonctionnement_interface_dysfonctionnement_interface_component__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_conclusion_conclusion_component__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters_mode_reception_filter__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filters_raison_demande_filter__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filters_type_personne_filter__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__routes__ = __webpack_require__(495);



















__webpack_require__(224);

var moduleName = 'dmattnt-accueil';
angular.module(moduleName, ['ui.router']).component('dmattntAccueilInterface1', new __WEBPACK_IMPORTED_MODULE_0__components_accueil_interface_1_accueil_interface_1_component__["a" /* default */]()).component('dmattntAccueilInterface2', new __WEBPACK_IMPORTED_MODULE_1__components_accueil_interface_2_accueil_interface_2_component__["a" /* default */]()).component('dmattntAccueilInterface3', new __WEBPACK_IMPORTED_MODULE_2__components_accueil_interface_3_accueil_interface_3_component__["a" /* default */]()).component('dmattntEtatChaines', new __WEBPACK_IMPORTED_MODULE_3__components_etat_chaines_etat_chaines_component__["a" /* default */]()).component('dmattntReamenagement', new __WEBPACK_IMPORTED_MODULE_4__components_reamenagement_reamenagement_component__["a" /* default */]()).component('dmattntAntenneAccessible', new __WEBPACK_IMPORTED_MODULE_5__components_antenne_accessible_antenne_accessible_component__["a" /* default */]()).component('dmattntFinAccueil', new __WEBPACK_IMPORTED_MODULE_6__components_fin_accueil_fin_accueil_component__["a" /* default */]()).component('dmattntInterventionAntenniste', new __WEBPACK_IMPORTED_MODULE_7__components_intervention_antenniste_intervention_antenniste_component__["a" /* default */]()).component('dmattntSignalementAntenniste', new __WEBPACK_IMPORTED_MODULE_8__components_signalement_antenniste_signalement_antenniste_component__["a" /* default */]()).component('dmattntIncidentDetecte', new __WEBPACK_IMPORTED_MODULE_9__components_incident_detecte_incident_detecte_component__["a" /* default */]()).component('dmattntAucunIncidentDetecte', new __WEBPACK_IMPORTED_MODULE_10__components_aucun_incident_detecte_aucun_incident_detecte_component__["a" /* default */]()).component('dmattntDysfonctionnementInterface', new __WEBPACK_IMPORTED_MODULE_11__components_dysfonctionnement_interface_dysfonctionnement_interface_component__["a" /* default */]()).component('dmattntConclusion', new __WEBPACK_IMPORTED_MODULE_12__components_conclusion_conclusion_component__["a" /* default */]()).filter('labelModeReception', __WEBPACK_IMPORTED_MODULE_13__filters_mode_reception_filter__["a" /* default */]).filter('labelRaisonDemande', __WEBPACK_IMPORTED_MODULE_14__filters_raison_demande_filter__["a" /* default */]).filter('labelTypePersonne', __WEBPACK_IMPORTED_MODULE_15__filters_type_personne_filter__["a" /* default */]).config(__WEBPACK_IMPORTED_MODULE_16__routes__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = {
  moduleName: moduleName
};

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_zone_perturbe_zone_perturbe_component__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contact_contact_component__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_constat_constat_component__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_fin_antenniste_fin_antenniste_component__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_filters_type_probleme_filter__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(500);








__webpack_require__(238);

var moduleName = 'dmattnt-antenniste';
angular.module(moduleName, ['ui.router']).component('dmattntZonePerturbe', new __WEBPACK_IMPORTED_MODULE_0__components_zone_perturbe_zone_perturbe_component__["a" /* default */]()).component('dmattntContact', new __WEBPACK_IMPORTED_MODULE_1__components_contact_contact_component__["a" /* default */]()).component('dmattntConstat', new __WEBPACK_IMPORTED_MODULE_2__components_constat_constat_component__["a" /* default */]()).component('dmattntFinAntenniste', new __WEBPACK_IMPORTED_MODULE_3__components_fin_antenniste_fin_antenniste_component__["a" /* default */]()).filter('labelTypeProbleme', __WEBPACK_IMPORTED_MODULE_4__common_filters_type_probleme_filter__["a" /* default */]).config(__WEBPACK_IMPORTED_MODULE_5__routes__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = {
  moduleName: moduleName
};

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_header_component__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer_footer_component__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_menu_menu_component__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_home_component__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters_civilite_filter__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters_type_personne_filter__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mentions_legales_mentions_legales_component__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes__ = __webpack_require__(507);









__webpack_require__(243);

var moduleName = 'dmattnt-base';
angular.module(moduleName, ['ui.router']).component('dmattntHeader', new __WEBPACK_IMPORTED_MODULE_0__components_header_header_component__["a" /* default */]()).component('dmattntFooter', new __WEBPACK_IMPORTED_MODULE_1__components_footer_footer_component__["a" /* default */]()).component('dmattntMenu', new __WEBPACK_IMPORTED_MODULE_2__components_menu_menu_component__["a" /* default */]()).component('dmattntHome', new __WEBPACK_IMPORTED_MODULE_3__components_home_home_component__["a" /* default */]()).component('dmattntMentionsLegales', new __WEBPACK_IMPORTED_MODULE_6__components_mentions_legales_mentions_legales_component__["a" /* default */]()).filter('labelCivilite', __WEBPACK_IMPORTED_MODULE_4__filters_civilite_filter__["a" /* default */]).filter('labelTypePersonne', __WEBPACK_IMPORTED_MODULE_5__filters_type_personne_filter__["a" /* default */]).config(__WEBPACK_IMPORTED_MODULE_7__routes__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = {
  moduleName: moduleName
};

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_progress_progress_component__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_adresse_adresse_component__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_emetteurtnt_emetteurtnt_component__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_complement_adresse_complement_adresse_component__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_type_defaut_type_defaut_component__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_type_perturbation_type_perturbation_component__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_prerequis_prerequis_component__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prerequis_prerequis_conclusion_component__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters_mauvaise_instable_bonne_excellente_filter__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters_type_construction_filter__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters_perturbations_filter__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filters_nature_perturbation_filter__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filters_nature_dysfonctionnement_filter__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filters_mode_raccordement_filter__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filters_oui_non_filter__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filters_oui_non_nsp_filter__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters_type_logement_filter__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_url_resolver_service__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__interceptors_url_resolver_interceptor__ = __webpack_require__(525);























__webpack_require__(249);

var moduleName = 'dmattnt-common';
angular.module(moduleName, ['ui.router']).component('dmattntProgress', new __WEBPACK_IMPORTED_MODULE_0__components_progress_progress_component__["a" /* default */]()).component('dmattntAdresse', new __WEBPACK_IMPORTED_MODULE_1__components_adresse_adresse_component__["a" /* default */]()).component('dmattntEmetteurtnt', new __WEBPACK_IMPORTED_MODULE_2__components_emetteurtnt_emetteurtnt_component__["a" /* default */]()).component('dmattntComplementAdresse', new __WEBPACK_IMPORTED_MODULE_3__components_complement_adresse_complement_adresse_component__["a" /* default */]()).component('dmattntTypeDefaut', new __WEBPACK_IMPORTED_MODULE_4__components_type_defaut_type_defaut_component__["a" /* default */]()).component('dmattntTypePerturbation', new __WEBPACK_IMPORTED_MODULE_5__components_type_perturbation_type_perturbation_component__["a" /* default */]()).component('dmattntPrerequis', new __WEBPACK_IMPORTED_MODULE_6__components_prerequis_prerequis_component__["a" /* default */]()).component('dmattntPrequisConclusion', new __WEBPACK_IMPORTED_MODULE_7__components_prerequis_prerequis_conclusion_component__["a" /* default */]()).filter('labelModeRaccordement', __WEBPACK_IMPORTED_MODULE_13__filters_mode_raccordement_filter__["a" /* default */]).filter('labelOuiNon', __WEBPACK_IMPORTED_MODULE_14__filters_oui_non_filter__["a" /* default */]).filter('labelOuiNonNsp', __WEBPACK_IMPORTED_MODULE_15__filters_oui_non_nsp_filter__["a" /* default */]).filter('labelMauvaiseInstableBonneExcellente', __WEBPACK_IMPORTED_MODULE_8__filters_mauvaise_instable_bonne_excellente_filter__["a" /* default */]).filter('labelNaturePerturbation', __WEBPACK_IMPORTED_MODULE_11__filters_nature_perturbation_filter__["a" /* default */]).filter('labelConstructions', __WEBPACK_IMPORTED_MODULE_9__filters_type_construction_filter__["a" /* default */]).filter('labelNatureDysfonctionnement', __WEBPACK_IMPORTED_MODULE_12__filters_nature_dysfonctionnement_filter__["a" /* default */]).filter('labelPerturbations', __WEBPACK_IMPORTED_MODULE_10__filters_perturbations_filter__["a" /* default */]).filter('labelTypeLogement', __WEBPACK_IMPORTED_MODULE_16__filters_type_logement_filter__["a" /* default */]).service('UrlResolverService', __WEBPACK_IMPORTED_MODULE_17__services_url_resolver_service__["a" /* default */]).factory('UrlResolverInterceptor', __WEBPACK_IMPORTED_MODULE_18__interceptors_url_resolver_interceptor__["a" /* default */]).config( /* @ngInject */function ($httpProvider) {
  $httpProvider.interceptors.push('UrlResolverInterceptor');
});

/* harmony default export */ __webpack_exports__["a"] = {
  moduleName: moduleName
};

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_lte_interface_1_lte_interface_1_component__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_lte_interface_2_lte_interface_2_component__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(529);




__webpack_require__(260);

var moduleName = 'dmattnt-lte';
angular.module(moduleName, ['ui.router']).component('dmattntLteInterface1', new __WEBPACK_IMPORTED_MODULE_0__components_lte_interface_1_lte_interface_1_component__["a" /* default */]()).component('dmattntLteInterface2', new __WEBPACK_IMPORTED_MODULE_1__components_lte_interface_2_lte_interface_2_component__["a" /* default */]()).config(__WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = {
  moduleName: moduleName
};

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_prtv_interface_1_prtv_interface_1_component__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prtv_interface_2_prtv_interface_2_component__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_prtv_interface_3_prtv_interface_3_component__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_prtv_interface_4_prtv_interface_4_component__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_prtv_interface_5_prtv_interface_5_component__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_prtv_interface_6_prtv_interface_6_component__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_prtv_depot_facture_prtv_depot_facture_component__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_prtv_depot_facture_2_prtv_depot_facture_2_component__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_prtv_depot_facture_3_prtv_depot_facture_3_component__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filters_type_perturbateur_filter__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_filters_oui_non_filter__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__base_filters_civilite_filter__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__routes__ = __webpack_require__(540);















__webpack_require__(270);

var moduleName = 'dmattnt-prtv';
angular.module(moduleName, ['ui.router']).component('dmattntPrtvInterface1', new __WEBPACK_IMPORTED_MODULE_0__components_prtv_interface_1_prtv_interface_1_component__["a" /* default */]()).component('dmattntPrtvInterface2', new __WEBPACK_IMPORTED_MODULE_1__components_prtv_interface_2_prtv_interface_2_component__["a" /* default */]()).component('dmattntPrtvInterface3', new __WEBPACK_IMPORTED_MODULE_2__components_prtv_interface_3_prtv_interface_3_component__["a" /* default */]()).component('dmattntPrtvInterface4', new __WEBPACK_IMPORTED_MODULE_3__components_prtv_interface_4_prtv_interface_4_component__["a" /* default */]()).component('dmattntPrtvInterface5', new __WEBPACK_IMPORTED_MODULE_4__components_prtv_interface_5_prtv_interface_5_component__["a" /* default */]()).component('dmattntPrtvInterface6', new __WEBPACK_IMPORTED_MODULE_5__components_prtv_interface_6_prtv_interface_6_component__["a" /* default */]()).component('dmattntPrtvDepotFacture', new __WEBPACK_IMPORTED_MODULE_6__components_prtv_depot_facture_prtv_depot_facture_component__["a" /* default */]()).component('dmattntPrtvDepotFacture2', new __WEBPACK_IMPORTED_MODULE_7__components_prtv_depot_facture_2_prtv_depot_facture_2_component__["a" /* default */]()).component('dmattntPrtvDepotFacture3', new __WEBPACK_IMPORTED_MODULE_8__components_prtv_depot_facture_3_prtv_depot_facture_3_component__["a" /* default */]()).filter('labelTypePerturbateur', __WEBPACK_IMPORTED_MODULE_9__filters_type_perturbateur_filter__["a" /* default */]).filter('labelOuiNon', __WEBPACK_IMPORTED_MODULE_10__common_filters_oui_non_filter__["a" /* default */]).filter('labelCivilite', __WEBPACK_IMPORTED_MODULE_11__base_filters_civilite_filter__["a" /* default */]).config(__WEBPACK_IMPORTED_MODULE_12__routes__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = {
  moduleName: moduleName
};

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_suivie_authent_suivie_authent_component__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_suivie_resultat_suivie_resultat_component__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(543);





__webpack_require__(273);

var moduleName = 'dmattnt-suivie-dossier';
angular.module(moduleName, ['ui.router']).component('dmattntSuivieAuthent', new __WEBPACK_IMPORTED_MODULE_0__components_suivie_authent_suivie_authent_component__["a" /* default */]()).component('dmattntSuivieResultat', new __WEBPACK_IMPORTED_MODULE_1__components_suivie_resultat_suivie_resultat_component__["a" /* default */]()).config(__WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = {
  moduleName: moduleName
};

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_reducer__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__demande_reducer__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__multiplex_reducer__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_defaut_reducer__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_perturbation_reducer__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(104);








var reducers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_redux__["combineReducers"])({
  demande: __WEBPACK_IMPORTED_MODULE_1__demande_reducer__["a" /* default */],
  multiplex: __WEBPACK_IMPORTED_MODULE_2__multiplex_reducer__["a" /* default */],
  typeDefaut: __WEBPACK_IMPORTED_MODULE_3__type_defaut_reducer__["a" /* default */],
  typePerturbation: __WEBPACK_IMPORTED_MODULE_4__type_perturbation_reducer__["a" /* default */],
  general: __WEBPACK_IMPORTED_MODULE_0__general_reducer__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = reducers;

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-anfr.3bdea994e933db0d870d9136efc2e889.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-anfr-reclamation.db59653a84a7deec4da9e7b731d1dc3c.png";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "marianne.59060fc2fdc690c2b3dedbaa87e1ce2c.png";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "antenniste.140b0636eaeed0371439148005bfcf51.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "particulier.9a0f7b652480767e8f8ba8c57dd3af5b.png";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "syndic.01e30706a3f8d88db8577dc360425519.png";

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1 ng-if=\"$ctrl.typePersonne !== 'GEST_SYNDIC'\">Vous recevez la télévision par antenne râteau</h1>\n  <div ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\">\n  <h1>La ou les résidences collectives concernées reçoivent la télévision par antenne râteau collective</h1>\n    <p>A noter que si la TNT est distribuée collectivement par le câble ou le satellite, veuillez contactez directement l’opérateur concerné.</p>\n  </div>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-block\">\n          <dmattnt-prerequis parentForm=\"form\"\n                             prefix=\"prerequis\"\n                             initial-data= \"$ctrl.prerequis\"\n                             type-personne= \"$ctrl.typePersonne\"\n                             on-prerequis-change=\"$ctrl.onPrerequisChange(prerequis)\"></dmattnt-prerequis>\n                             <div class=\"form-block\">Afin de faire un diagnostic précis de votre situation, nous vous conseillons de vérifier au préalable\n                              les chaînes concernées par les perturbations.</div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"submit\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Suivant</button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n";

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1 ng-if=\"$ctrl.typePersonne!=='PRO'\">Localisation du problème</h1>\n  <h1 ng-if=\"$ctrl.typePersonne==='PRO'\">Localisation du problème et date de constat</h1>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-blocks\">\n          <div  class=\"form-block\">\n            <div class=\"dark-grey triangle-before text\">Adresse :</div>\n            <dmattnt-adresse  adresse=\"$ctrl.adresse\" parent-form=\"form\" prefix=\"habitation\" on-adresse-change=\"$ctrl.onAdresseChange(adresse)\"></dmattnt-adresse>\n            <dmattnt-complement-adresse complement-adresse=\"$ctrl.data.complementAdresse\" prefix=\"habitation\" on-complement-adresse-change=\"$ctrl.onComplementAdresseChange(complementAdresse)\"></dmattnt-complement-adresse>\n          </div>\n          <div  class=\"form-block\">\n            <div class=\"dark-grey triangle-before text label-required\">Depuis quand avez-vous constaté la perturbation ? :</div>\n            <datepicker class=\"ng-isolate-scope\" date-format=\"dd/MM/yyyy\" date-week-start-day=\"1\" date-max-limit=\"{{$ctrl.dateMax}}\">\n              <input type=\"text\" class=\"input-text-200\" required id=\"datePerturbationInput\" name=\"datePerturbation\" ng-model=\"$ctrl.data.datePerturbation\" maxlength=\"20\" ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"\" placeholder=\"JJ/MM/AAAA\" model-view-value=\"true\"\n                     ui-mask=\"99/99/9999\" ng-change=\"$ctrl.onDatePerturbationChange()\">\n              <div class=\"input-error-messages\" ng-messages=\"form.datePerturbation.$error\" role=\"alert\" ng-show=\"form.datePerturbation.$dirty\">\n                <div ng-message=\"mask\">Le format de la date n'est pas valide ('JJ/MM/AAAA' attendu).</div>\n              </div>\n              <div class=\"input-error-messages\" role=\"alert\" ng-if=\"!$ctrl.datePerturbationIsvalid\">\n                <div>La date saisie n'est pas valide.</div>\n              </div>\n            </datepicker>\n          </div>\n        </div>\n        <div>\n          <hr>\n          <div class=\"form-actions\">\n            <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n            <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Suivant</button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n";

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Adresse indiquée non confirmée</h1>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text \">Confirmez-vous l'adresse suivante : <i>{{$ctrl.data.adresse.numero || ''}} {{$ctrl.data.adresse.voie}} {{$ctrl.data.adresse.codePostal.codepostal}} {{$ctrl.data.adresse.commune.nom}}</i></div>\n          <div class=\"center\">\n          <button type=\"submit\" ng-disabled=\"\" class=\"btn\" ng-click=\"$ctrl.nextStep(true)\">OUI</button>\n          <button type=\"submit\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.prevStep()\">Non</button>\n            </div>\n        </div>\n          <hr>\n          <div class=\"form-actions\">\n            <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n";

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <div class=\"dmattnt__content-page formulaire\">\n      <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n      <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n        <form name=\"form\">\n          <div class=\"form-block\">\n            <div class=\"dark-grey triangle-before text label-required \">Pouvez-vous donner l’accès à l’antenne du toit de votre habitation ?</div>\n            <div class=\"center\">\n            <button type=\"submit\" ng-disabled=\"\" class=\"btn\" ng-click=\"$ctrl.nextStep(true)\">OUI</button>\n            <button type=\"submit\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep(false)\">Non</button>\n              </div>\n          </div>\n            <hr>\n            <div class=\"form-actions\">\n              <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n            </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n  </section>\n  \n  ";

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Aucun incident n'a été détecté pour l'adresse indiquée</h1>\n  <p>Aucune difficulté connue de l’ANFR n’a été détectée pour l’adresse indiquée.</p>\n  <p>Une étude peut permettre de déterminer l’origine des perturbations signalées.</p>\n  <p>Si vous choisissez de lancer l’étude, nous vous adresserons un formulaire à imprimer et à nous retourner par voie postale.</p>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text label-required \">Souhaitez-vous lancer une étude approfondie ?</div>\n          <div class=\"center\">\n          <button type=\"submit\" ng-disabled=\"\" class=\"btn\" ng-click=\"$ctrl.nextStep(true)\">OUI</button>\n          <button type=\"submit\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep(false)\">Non</button>\n            </div>\n        </div>\n          <hr>\n          <div class=\"form-actions\">\n            <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n\n";

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <div ng-if=\"$ctrl.termine !== 'fin'\" class=\"reponse\">\n  <p>Merci d’avoir pris le temps de nous répondre.</p>\n  <p>Consultez notre site internet pour vous tenir informé et suivre l’évolution de l’actualité dans votre zone en <a href=\"https://www.recevoirlatnt.fr/particuliers/dans-votre-region/\" target=\"_blank\" ng-if=\"$ctrl.typePersonne !== 'PRO'\" >cliquant ici</a><a href=\"https://www.recevoirlatnt.fr/?id=278\" target=\"_blank\" ng-if=\"$ctrl.typePersonne === 'PRO'\" >cliquant ici</a>.</p>\n  </div>\n  <div ng-if=\"$ctrl.termine === 'fin'\" class=\"reponse\">\n    <p>Merci d'avoir utilisé notre service d'assistance TNT.</p>\n  </div>\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n          <div class=\"form-actions\">\n            <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n            <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Retourner à l'accueil</button>\n          </div>\n      </form>\n    </div>\n</section>\n\n";

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <div class=\"dmattnt__content-page formulaire\">\n      <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n      <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n        <form name=\"form\">\n          <div class=\"form-block\">\n            <div class=\"dark-grey triangle-before text label-required \">Le dysfonctionnement est-il permanent ou aléatoire ?</div>\n            <div class=\"input-container\">\n                <div ng-repeat=\"mode in $ctrl.PERMANENT_ALEATOIRE.VALUES\">\n                  <p>\n                    <input required type=\"radio\" name=\"natureDysfonctionnement\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.natureDysfonctionnement\">{{ mode | labelNatureDysfonctionnement }}\n                  </p>\n                </div>\n            </div>\n          </div>\n            <hr>\n            <div class=\"form-actions\">\n              <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n              <button type=\"submit\" ng-disabled=\"$ctrl.data.natureDysfonctionnement === ''\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Suivant</button>\n            </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n  </section>\n  \n  ";

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Description du problème</h1>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-block\">\n          <div ng-if=\"$ctrl.typePersonne !== 'GEST_SYNDIC'\" class=\"dark-grey triangle-before text label-required \">Recevez-vous encore certaines chaînes ?</div>\n          <div ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\" class=\"dark-grey triangle-before text label-required \">Certaines chaînes sont-elles encore reçues ?</div>\n          <div class=\"center\">\n          <button type=\"button\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep('oui')\">Oui</button>\n          <button type=\"button\" ng-disabled=\"$ctrl.disableNext\" class=\"btn btn-secondary\" ng-click=\"$ctrl.nextStep('non')\">Non</button>\n            </div>\n        </div>\n          <hr>\n          <div class=\"form-actions\">\n            <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n\n";

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <div ng-if=\"$ctrl.fin\">\n        <div class=\"reponse\">\n            <p>Nous vous invitons à vous rapprocher de votre propriétaire ou syndic, afin de lui demander de nous contacter,\n                pour que nous puissions faire le point avec lui sur votre situation. L’ANFR vous remercie.</p>\n            <p>Merci d'avoir utilisé notre service d'assistance TNT.</p>\n        </div>\n      <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n      <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n        <form name=\"form\">\n            <div class=\"form-actions\">\n              <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n              <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Retourner à l'accueil</button>\n            </div>\n        </form>\n      </div>\n  </section>";

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Un incident a été détecté pour l'adresse indiquée précédemment.</h1>\n  <div ng-repeat =\"message in $ctrl.data.message\">\n    <p>{{message.message}}</p>\n  </div>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text \">Si vos difficultés sont différentes de celles décrites ci-dessus\n            (autres chaînes, autre émetteur, etc.), vous avez la\n            possibilité de continuer et demander une étude\n            approfondie en cliquant sur le bouton <i>suivant</i>.</div>\n        </div>\n          <hr>\n          <div class=\"form-actions\">\n            <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n            <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep(true)\">Suivant</button>\n          </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n\n";

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <div class=\"dmattnt__content-page formulaire\">\n      <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n      <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n        <form name=\"form\">\n          <div class=\"form-block\">\n            <div class=\"dark-grey triangle-before text label-required \">Un antenniste est-il intervenu dans les 12 mois pour vérifier votre installation ?</div>\n            <div class=\"center\">\n            <button type=\"submit\" ng-disabled=\"\" class=\"btn\" ng-click=\"$ctrl.nextStep(true)\">OUI</button>\n            <button type=\"submit\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep(false)\">Non</button>\n              </div>\n          </div>\n            <hr>\n            <div class=\"form-actions\">\n              <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n            </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n  </section>\n  \n  ";

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Changement de fréquences</h1>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-block\">\n          <div class=\"e_phase\">\n            <div class=\"bloc_phase_b_before_message\">\n              <p ng-bind-html=\"$ctrl.data.phases.message\"></p>\n            </div>\n            <div class = \"bloc_phase_message\" ng-class=\"{'bloc_phase_message bloc_accordeon': $ctrl.data.phases.multiArray.length > 1}\"\n                 ng-repeat=\"array in $ctrl.data.phases.multiArray\" name=\"phase-{{$index}}\">\n              <h2 ng-click=\"$ctrl.clickPhase($index)\"><span ng-if=\"$ctrl.data.phases.multiArray.length > 1\">Soit</span> le\n                <strong>{{array.dateText}}</strong>\n              </h2>\n              <div class=\"content\">\n                <span></span><p style=\"text-align: justify; margin-top: 10px; \" ng-bind-html=\"array.message\"></p>\n              </div>\n            </div>\n\n            <div class=\"bloc_phase_b_before_message\">\n              <p>Si cette information répond à votre problème, cliquez sur le bouton TERMINER, sinon cliquez sur le bouton SUIVANT.</p>\n            </div>\n          </div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"button\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep('fin')\">Terminer</button>\n          <button type=\"button\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep('oui')\">Suivant</button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n\n";

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <div class=\"dmattnt__content-page formulaire\">\n      <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n      <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n        <form name=\"form\">\n          <div class=\"form-block\">\n            <div class=\"dark-grey triangle-before text label-required \">Quelle est la nature de la perturbation signalée par l’antenniste ?</div>\n            <div class=\"input-container\">\n                <label ng-repeat=\"mode in $ctrl.NATURE_PERTURBATION.VALUES\">\n                  <p>\n                    <input required type=\"radio\" required name=\"natureProbleme\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.natureProbleme\">{{ mode | labelNaturePerturbation }}</label>\n                  </p>\n                </div>\n            </div>\n          </div>\n            <hr>\n            <div class=\"form-actions\">\n              <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n              <button type=\"button\" ng-disabled=\"$ctrl.data.natureProbleme === ''\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Suivant</button>\n            </div>\n        </form>\n      </div>\n    </div>\n    <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n  </section>\n  \n  ";

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Etape 2 - Description du problème :</h1>\n  <p>Communiquez-nous les éléments nécessaires pour qualifier la difficulté de réception, tels que l’émetteur, les multiplex impactés, le type de problème, etc.\n  </p>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n          <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text label-required\">De quel émetteur s'agit-il ?</div>\n          <dmattnt-emetteurtnt emetteurtnt=\"$ctrl.data.emetteurtnt\" parent-form=\"form\" prefix=\"infocompl\" on-emetteurtnt-change=\"$ctrl.onEmetteurtntChange(emetteurtnt)\"></dmattnt-emetteurtnt>\n          </div>\n          <div class=\"form-block multiplex-concernes\">\n          <div class=\"input-container\">\n            <div class=\"dark-grey triangle-before text label-required\">Sélectionnez le ou les multiplex concerné(s) :</div>\n            <div class=\"warning-message\" ng-if=\"$ctrl.multiplexFailure\">Une erreur est survenue à la récupération des listes des multiplex. Merci de réessayer d'ici quelques minutes.</div>\n            <div ng-if=\"!$ctrl.multiplexFailure\">\n              <div ng-if=\"$ctrl.multiplex\"  class=\"multiplex-block\">\n                <div ng-repeat=\"multiplex in $ctrl.multiplex | orderBy: 'id' track by multiplex.id \" ng-if=\"multiplex.chainesActives.length\">\n                  <p class=\"multiplex\">\n                    <input id={{multiplex.code}} name=\"multiplex\" type=\"checkbox\" ng-model=\"$ctrl.multiplexCode[multiplex.id]\" value=\"true\" ng-change=\"$ctrl.onChangeSelected(multiplex)\">\n                    <label for={{multiplex.code}} class={{multiplex.code}}></label>\n                  </p>\n                </div>\n              </div>\n              <div ng-if=\"!$ctrl.multiplex\" class=\"warning-message\">Une erreur est survenue à la récupération des listes des multiplex. Merci de réessayer d'ici quelques minutes.</div>\n            </div>\n          </div>\n          </div>\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text label-required\">Le problème est-il ?</div>\n          <div  class=\"input-container\">\n            <div ng-repeat=\"mode in $ctrl.TYPE_PROBLEME.VALUES\">\n              <input required type=\"radio\" name=\"typeProbleme\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.typeProbleme\">{{ mode | labelTypeProbleme }}</div>\n            </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text label-required\">Quel est le problème constaté ?</div>\n          <dmattnt-type-perturbation origine=\"antenniste\" parent-form=\"form\" type-perturbation=\"$ctrl.data.typePerturbation\" on-type-perturbation-change=\"$ctrl.onTypePerturbationChange(typePerturbation)\"></dmattnt-type-perturbation>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text\">Que pensez-vous de ce problème ?</div>\n          <div class=\"input-container\">\n            <label for=\"impactSupposeInput\">Impact supposé</label>\n            <textarea name=\"impactSuppose\" id=\"impactSupposeInput\" ng-model=\"$ctrl.data.impactSuppose\" class=\"input-text-400\"></textarea>\n          </div>\n          <div class=\"input-container\">\n            <label for=\"descriptifInput\">Descriptif du problème</label>\n            <textarea name=\"descriptif\" id=\"descriptifInput\" ng-model=\"$ctrl.data.descriptif\" class=\"input-text-400\"></textarea>\n          </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text label-required\">Êtes-vous déjà inscrit à la charte \"professionnel partenaire\" de l'ANFR ?</div>\n          <div class=\"input-container\">\n            <label ng-repeat=\"mode in $ctrl.OUI_NON.VALUES\">\n              <input type=\"radio\" required name=\"inscriptionCharte\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.inscriptionCharte\">{{ mode | labelOuiNon }}</label>\n          </div>\n          <div ng-if=\"$ctrl.data.inscriptionCharte === 'NON'\" class=\"reponse\"><h5>Information</h5>\n            Dans le cas où vous ne seriez pas encore inscrit, ou si vous ne connaissez pas cette charte, nous vous conseillons de vous renseigner sur le site suivant :\n            <a href=\"http://www.recevoirlatnt.fr/professionnels/antennistes-et-distributeurs/la-bande-700-mhz/la-charte-professionnelle/\">la bande 700MHz : La charte professionnelle</a>\n          </div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Valider</button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n";

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Etape 1 - vos coordonnées :</h1>\n  <p><span ng-if =\"$ctrl.messagePerturbation=== null\">Aucun incident de diffusion n’a été détecté à l’adresse indiquée. </span>En 2 étapes, vous allez pouvoir nous signaler les difficultés de réception que vous rencontrez.</p>\n  <p>Laissez-nous vos coordonnées professionnelles afin que nous puissions vous contacter si nous avons besoin d’informations techniques supplémentaires pour qualifier le problème.</p>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-blocks\">\n          <div class=\"form-block\">\n            <div class=\"dark-grey triangle-before text\">Vous êtes... :</div>\n            <div  class=\"input-container\">\n              <div class=\"label-required civilite\">\n            <span ng-repeat=\"mode in $ctrl.CIVILITE.VALUES\">\n              <input  required type=\"radio\" name=\"civilite\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.civilite\">{{ mode | labelCivilite }}</span>\n              </div>\n            </div>\n            <div class=\"input-container\" ng-class=\"{'has-error': form.nom.$dirty && form.nom.$invalid}\">\n              <label for=\"nomInput\" class=\"label-required\">Nom</label>\n              <input type=\"text\" required name=\"nom\" id=\"nomInput\" ng-model=\"$ctrl.data.nom\" class=\"input-text-400\" maxlength=\"100\" ng-pattern=\"$ctrl.regex\">\n              <div class=\"input-error-messages\" ng-messages=\"form.nom.$error\" role=\"alert\" ng-show=\"form.nom.$dirty\">\n                <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                <div ng-message=\"pattern\">Ce champ ne doit pas contenir de caractères spéciaux.</div>\n              </div>\n            </div>\n            <div class=\"input-container\" ng-class=\"{'has-error': form.prenom.$dirty && form.prenom.$invalid}\">\n              <label for=\"prenomInput\" class=\"label-required\">Prénom</label>\n              <input type=\"text\" required name=\"prenom\" id=\"prenomInput\" ng-model=\"$ctrl.data.prenom\" class=\"input-text-400\" maxlength=\"100\" ng-pattern=\"$ctrl.regex\">\n              <div class=\"input-error-messages\" ng-messages=\"form.prenom.$error\" role=\"alert\" ng-show=\"form.prenom.$dirty\">\n                <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                <div ng-message=\"pattern\">Ce champ ne doit pas contenir de caractères spéciaux.</div>\n              </div>\n            </div>\n            <div class=\"input-container\">\n              <label for=\"telephone1Input\" class=\"label-required\">Téléphone</label>\n              <input type=\"tel\" required name=\"telephone1\" id=\"telephone1Input\" ng-model=\"$ctrl.data.telephone1\" class=\"input-text-200\" ng-pattern=\"$ctrl.telephonePattern\" maxlength=\"10\" minlength=\"10\">\n              <div class=\"input-error-messages\" ng-messages=\"form.telephone1.$error\" role=\"alert\" ng-show=\"form.telephone1.$dirty\">\n                <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                <div ng-message=\"pattern\">Le numéro de téléphone n'est pas valide, il doit contenir 10 chiffres.</div>\n              </div>\n            </div>\n            <div class=\"input-container\" ng-class=\"{'has-error': form.courriel.$dirty && form.courriel.$invalid}\">\n              <label for=\"courrielInput\"  class=\"label-required\" >Courriel</label>\n              <input type=\"email\" required name=\"courriel\" id=\"courrielInput\" ng-model=\"$ctrl.data.courriel\" class=\"input-text-400\" placeholder=\"nom@domaine.com\" ng-pattern=\"$ctrl.emailPattern\">\n              <div class=\"input-error-messages\" ng-messages=\"form.courriel.$error\" role=\"alert\" ng-show=\"form.courriel.$dirty\">\n                <div ng-message=\"email\">Le format du courriel n'est pas valide.</div>\n                <div ng-message=\"pattern\">Le format du courriel n'est pas valide. Il doit être de la forme 'nom@domaine.com'</div>\n              </div>\n            </div>\n              <div class=\"input-container\" ng-class=\"{'has-error': form.courriel2.$dirty && form.courriel2.$invalid}\">\n                <label for=\"courrielInput2\"  class=\"label-required\" >Confirmez votre courriel</label>\n                <input type=\"email\" required name=\"courriel2\" id=\"courrielInput2\" ng-model=\"$ctrl.data.courriel2\" class=\"input-text-400\" placeholder=\"nom@domaine.com\" ng-pattern=\"$ctrl.data.courriel\">\n                <div class=\"input-error-messages\" ng-messages=\"form.courriel2.$error\" role=\"alert\" ng-show=\"form.courriel2.$dirty\">\n                  <div ng-message=\"pattern\">Les deux courriels doivent être identiques</div>\n                </div>\n              </div>\n          </div>\n          <div class=\"form-block\">\n            <div class=\"dark-grey triangle-before text\">Votre société :</div>\n            <div class=\"input-container\" ng-class=\"{'has-error': form.societe.$dirty && form.societe.$invalid}\">\n              <label for=\"societeInput\" class=\"label-required\">Nom de la société</label>\n              <input type=\"text\" required name=\"societe\" id=\"societeInput\" ng-model=\"$ctrl.data.societe\" class=\"input-text-400\" maxlength=\"100\">\n              <div class=\"input-error-messages\" ng-messages=\"form.societe.$error\" role=\"alert\" ng-show=\"form.societe.$dirty\">\n                <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n              </div>\n            </div>\n            <div class=\"input-container\">\n              <label for=\"siretInput\" class=\"label-required\">SIRET</label>\n              <input type=\"text\" required name=\"siret\" id=\"siretInput\" ng-model=\"$ctrl.data.siret\" class=\"input-text-400\" maxlength=\"100\">\n              <div class=\"input-error-messages\" ng-messages=\"form.siret.$error\" role=\"alert\" ng-show=\"form.siret.$dirty\">\n                <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n              </div>\n            </div>\n          <div class=\"input-container\">\n            <div class=\"dark-grey triangle-before text \">Adresse de votre société :</div>\n            <dmattnt-adresse adresse=\"$ctrl.data.adresse\" parent-form=\"form\" prefix=\"habitation\" on-adresse-change=\"$ctrl.onAdresseChange(adresse)\"></dmattnt-adresse>\n            <dmattnt-complement-adresse complement-adresse=\"$ctrl.data.complementAdresse\" prefix=\"habitation\" on-complement-adresse-change=\"$ctrl.onComplementAdresseChange(complementAdresse)\"></dmattnt-complement-adresse>\n          </div>\n        </div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Valider</button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n";

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <div class=\"reponse\" ng-if=\"$ctrl.numeroAnfr === null\">\n  <p>\n    Merci d’avoir pris le temps de nous répondre.\n  </p>\n  <p>\n    Consultez notre site internet pour vous tenir informé et suivre l’évolution de l’actualité dans votre zone en <a href=\"https://www.recevoirlatnt.fr/?id=278\" target=\"_blank\"> cliquant ici</a>.\n  </p>\n  </div>\n  <div class=\"reponse\" ng-if=\"$ctrl.numeroAnfr !== null\">\n    <p>\n      Merci d’avoir pris le temps de nous répondre. Vous allez recevoir un courriel de confirmation.<br>\n      Votre signalement va être pris en compte dans les meilleurs délais. Nous serons susceptibles de vous appeler si d’autres informations sont nécessaires afin de mieux qualifier le problème.\n    </p>\n    <p>\n      Pour vous tenir informé d’éventuels dysfonctionnements dans votre zone, vous pouvez consulter notre site internet en <a href=\"https://www.recevoirlatnt.fr/?id=278\" target=\"_blank\"> cliquant ici</a>.\n    </p>\n  </div>\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n          <div class=\"form-actions\">\n            <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn right\" ng-click=\"$ctrl.nextStep()\">Retourner à l'accueil</button>\n          </div>\n      </form>\n    </div>\n</section>\n\n";

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Un incident de diffusion a été détecté à l’adresse indiquée</h1>\n  <div ng-repeat =\"message in $ctrl.data.message\">\n    <p>{{message.message}}</p>\n  </div>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text label-required \">L’incident correspond-t-il aux difficultés rencontrées, ou avez-vous un signalement différent à nous communiquer ?</div>\n          <div class=\"center\">\n            <button type=\"button\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep('oui')\">Oui</button>\n            <button type=\"button\" ng-disabled=\"$ctrl.disableNext\" class=\"btn btn-secondary\" ng-click=\"$ctrl.nextStep('non')\">Non</button>\n          </div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n\n";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<footer class=\"dmattnt__footer\">\n  <div class=\"dmattnt__footer__content\">\n    <aside class=\"dmattnt__footer__lien\" style=\"border-right: 1px solid #fff;\">\n      <div class=\"dmattnt__footer__lien__inside\">\n        <ul class=\"pan\">\n          <li class=\"dmattnt__footer__lien__chevron icon-chevron-right\"><a class=\"dmattnt__footer__lien__link\" href=\"#!/mentions-legales\" target=\"_blank\">Mentions légales</a></li>\n      </div>\n    </aside>\n    <aside class=\"dmattnt__footer__lien\" style=\"border-right: 1px solid #fff;\">\n      <div class=\"dmattnt__footer__lien__inside\">\n        <p class=\"dmattnt__footer__lien__texte\">Suivre l'Agence nationale des fréquences</p>\n        <ul class=\"pan\" style=\"margin: 0 auto; display: table;\">\n          <li class=\"dmattnt__footer__lien__chevron icon-chevron-right\"><a class=\"dmattnt__footer__lien__link\" href=\"http://www.anfr.fr\" target=\"_blank\">www.anfr.fr</a></li>\n        </ul>\n        <div class=\"dmattnt__footer__lien__icons\">\n          <a class=\"dmattnt__footer__lien__icon__facebook dmattnt__footer__lien__icon\" href=\"https://www.facebook.com/agencenationaledesfrequences/\" title=\"Facebook\" target=\"_blank\"></a>\n          <a class=\"dmattnt__footer__lien__icon__twitter dmattnt__footer__lien__icon\" href=\"https://twitter.com/anfr\" title=\"Twitter\" target=\"_blank\"></a>\n          <a class=\"dmattnt__footer__lien__icon__flickr dmattnt__footer__lien__icon\" href=\"https://www.flickr.com/anfr/\" title=\"Flickr\" target=\"_blank\"></a>\n          <a class=\"dmattnt__footer__lien__icon__linkedin dmattnt__footer__lien__icon\" href=\"https://www.linkedin.com/company/anfr/\" title=\"LinkedIn\" target=\"_blank\"></a>\n        </div>\n      </div>\n    </aside>\n    <aside class=\"dmattnt__footer__lien\">\n      <div class=\"dmattnt__footer__lien__inside\">\n        <p class=\"dmattnt__footer__lien__texte\">Un site web de l'ANFR</p>\n        <a href=\"http://www.recevoirlatnt.fr\" target=\"_blank\"><img src=\"" + __webpack_require__(274) + "\" alt=\"SMO\" class=\"dmattnt__footer__lien__texte\"></a>\n\n      </div>\n    </aside>\n  </div>\n</footer>\n";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"dmattnt__header\">\n  <div class=\"dmattnt__header__visuel-site\">\n    <div class=\"dmattnt__header__bandeau-visuel\"></div>\n  </div>\n  <div class=\"dmattnt__header__content\">\n    <div class=\"dmattnt__header__titre-site\">\n      <a class=\"dmattnt__header__titre-site__a dmattnt__header__titre-no_pointer\"><img src=\"" + __webpack_require__(276) + "\" alt=\"Marianne logo\" class=\"dmattnt__header__titre-site__img\"></a>\n      <a href=\"http://www.recevoirlatnt.fr\" target=\"_blank\" class=\"dmattnt__header__titre-site__a\"><img src=\"" + __webpack_require__(275) + "\" alt=\"ANFR\" class=\"dmattnt__header__titre-site__img\"></a>\n    </div>\n    <div class=\"dmattnt__header__logos-partenaires\">\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<section class=\"formulaire\">\n  <h1>Bienvenue sur la plateforme d’assistance TNT de l'ANFR</h1>\n  <p>Cette plateforme vous guide dans les démarches à suivre en cas de difficultés de réception de la TNT. Elle vous informe d'éventuels dysfonctionnements de la diffusion dans votre zone.\n  </p>\n  <div ng-if=\"!$ctrl.saisieReclamation\" class=\"home_buttons\">\n    <div class=\"inner-div\">\n      <h4>Vous souhaitez : </h4>\n      <div class=\"home_actions\">\n        <div><button type=\"button\" class=\"btn home_btn\" ng-click=\"$ctrl.saisirReclamation()\">Saisir une réclamation</button></div>\n        <div><button type=\"button\" class=\"btn home_btn\" ng-click=\"$ctrl.suivreDossier()\">Suivre votre dossier</button></div>\n      </div>\n\t</div>\n  </div>\n  <div ng-if=\"$ctrl.saisieReclamation\">\n    <div class=\"dmattnt__title2\">Qui êtes-vous ? </div>\n    <div class=\"trio\">\n      <div class=\"content_page\">\n        <img src=\"" + __webpack_require__(278) + "\" alt=\"Particulier\">\n        <div class=\"dmattnt__type\">Particulier</div>\n        <p class=\"quite-little texteprofil\">Vous êtes un particulier, locataire ou propriétaire, et vous recevez la télévision par une antenne râteau.</p>\n        <hr>\n        <div class=\"form-actions\">\n          <div><button type=\"button\" class=\"btn\" ng-disabled=\"$ctrl.working\" ng-click=\"$ctrl.startDemande('PART')\">Saisir ma réclamation</button></div>\n        </div>\n      </div>\n      <div class=\"content_page\">\n        <img src=\"" + __webpack_require__(277) + "\" alt=\"Antenniste\">\n        <div class=\"dmattnt__type\">Antenniste</div>\n        <p class=\"quite-little texteprofil\">Vous êtes un professionnel antenniste, vous souhaitez nous signaler un dysfonctionnement constaté sur le terrain.</p>\n\n        <hr>\n        <div class=\"form-actions\">\n          <div><button type=\"button\" class=\"btn\" ng-disabled=\"$ctrl.working\" ng-click=\"$ctrl.startDemande('PRO')\">Saisir ma réclamation</button></div>\n        </div>\n      </div>\n      <div class=\"content_page\">\n        <img src=\"" + __webpack_require__(279) + "\" alt=\"Syndic ou bailleur\">\n        <div class=\"dmattnt__type\">Syndic ou bailleur</div>\n        <p class=\"quite-little texteprofil\">Vous êtes syndic ou bailleur, vous rencontrez des difficultés de réception de la TNT dans une copropriété que vous gérez.</p>\n        <hr>\n        <div class=\"form-actions\">\n          <div><button type=\"button\" class=\"btn\" ng-disabled=\"$ctrl.working\" ng-click=\"$ctrl.startDemande('GEST_SYNDIC')\">Saisir ma réclamation</button></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-actions ml_20\">\n      <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n    </div>\n  </div>\n</section>\n";

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "<h1>Mentions légales</h1>\n\n<div class=\"content\">\n  <p>L'Agence nationale des fréquences (ANFR) est un établissement public de l’Etat à caractère administratif placé auprès du ministre en charge des communications électroniques. Son siège est situé au 78, avenue du Général de Gaulle, 94704 MAISONS-ALFORT\n    CEDEX.\n  </p>\n  <p>Le responsable de la publication du présent site Internet, édité par l’ANFR, est Monsieur Gilles Brégant en qualité de représentant légal de l'ANFR.</p>\n  <ul>\n    <li>La rédaction est placée sous la responsabilité du Service de la Communication et des Relations institutionnelles ;</li>\n    <li>Ce site a été réalisé par la société ATOL Conseils & Développements située au ZAE Les Terres d'or, Route de Saint-Philibert, 21220 Gevrey-Chambertin,</li>\n    <li>La maintenance de ce site est assurée par la société ATOL Conseils & Développements située au ZAE Les Terres d'or, Route de Saint-Philibert, 21220 Gevrey-Chambertin</li>\n    <li>Ce site est hébergé par la société OVH située 2 rue Kellermann - 59100 ROUBAIX.</li>\n  </ul>\n\n  <h5>Traitement des données à caractère personnel</h5>\n  <p>Les informations à caractère personnel recueillies dans le cadre des différents formulaires et bases de données du site {{ctrl.domain}} font l’objet d’un traitement informatique destiné à l’accomplissement des missions de service public de l’Agence.\n    Conformément aux dispositions de la loi n° 78-17 du 6 janvier 1978 modifiée relative à l’informatique, aux fichiers et aux libertés, vous disposez d’un droit d’accès et de rectification aux informations qui vous concernent. Si vous souhaitez exercer\n    ce droit, vous pouvez vous adresser :\n  </p>\n  <ul>\n    <li>par voie postale à : Agence nationale des fréquences - Dispositif Mesure - 78 avenue du général de Gaulle - 94704 MAISONS-ALFORT CEDEX ;</li>\n    <li>par <a href=\"http://www.anfr.fr/contact/envoyer-un-message-electronique/donnees-personnelles/\" target=\"_blank\">courrier électronique</a> ;</li>\n    <li>aux adresses postales et électroniques spécifiques mentionnées dans chaque formulaire ou base de données.</li>\n  </ul>\n\n  <h5>Traces de connexion</h5>\n  <p>L'utilisateur est informé que des informations relatives aux traces de connexion sont extraites aux seules fins de la gestion du site par la mission Communication de l’ANFR : il s’agit de l'origine géographique des requêtes ainsi que de la date et de\n    l'heure de la connexion. Les données relatives à ces traces sont conservées pendant une durée maximale d’un an.</p>\n\n  <h5>Proprieté intellectuelle</h5>\n  <p>Le site de l’ANFR est une œuvre de création, propriété exclusive de l’ANFR, protégé par la législation française et internationale sur le droit de la propriété intellectuelle. Aucune reproduction ou représentation ne peut être réalisée en contravention\n    avec les droits de l’ANFR issus des législations susvisées.</p>\n\n  <h5>Informations publiques et droit de reproduction</h5>\n  <p>Le site {{ctrl.domain}} contient des informations publiques au sens de la loi n° 78-753 du 17 juillet 1978 modifiée portant diverses mesures d'amélioration des relations entre l'administration et le public et diverses dispositions d'ordre administratif,\n    social et fiscal.</p>\n  <p>Ces informations sont protégées par la Convention de Berne sur la Protection des œuvres littéraires et artistiques, par d'autres conventions internationales et par les législations nationales sur le droit d'auteur et les droits dérivés.</p>\n  <p>Elles peuvent être reproduites sous réserve de :</p>\n  <ol>\n    <li>n'être ni altérées ni modifiées,</li>\n    <li>comporter la mention du nom de l'ANFR en tant que source</li>\n    <li>préciser la date de leur mise à jour,</li>\n    <li>faire figurer un lien renvoyant vers la page originale ou le document diffusé sur le site {{ctrl.domain}}.</li>\n  </ol>\n  <p>Toute information provenant du site {{ctrl.domain}} doit être reprise intégralement, sans modification ni ajout, sans adjonction publicitaire et doit être téléchargeable gratuitement. A aucun moment, la réutilisation des données ne doit donner l'impression\n    que l'ANFR participe à ou cautionne l'action de l'utilisateur.</p>\n\n  <h5>Liens hypertextes</h5>\n  <p>La mise en place de liens hypertextes par des tiers vers des pages ou des documents diffusés sur le site {{ctrl.domain}}, est autorisée sous réserve que les liens ne contreviennent pas aux intérêts de l’ANFR, et qu'ils garantissent la possibilité pour\n    l'utilisateur d'identifier l'origine et l'auteur du document.</p>\n\n  <h5>Clause de non responsabilité</h5>\n  <p>La responsabilité de l’ANFR ne peut, en aucune manière, être engagée en raison de l’utilisation ou de l’interprétation par un tiers des informations figurant sur le site. Ainsi, les sites Internet d’autres institutions ou organismes, accessibles à partir\n    de liens hypertextes figurant sur le site {{ctrl.domain}}, n'engagent pas la responsabilité de l'ANFR quant à leur contenu.</p>\n\n  <h5>CNIL</h5>\n  <p>La dispense n°7 (délibération n°2006-138 du 9 mai 2006) qui concerne les traitements de données personnelles mis en œuvre par tout organisme privé ou public à des fins d’information et de communication externe s’applique à notre site internet {{ctrl.domain}}.</p>\n  <p>Ce traitement permettant la gestion des demandes ...</p>\n</div>\n";

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dmattnt__container\">\n  <ol class=\"dmattnt__container breadcrumb\" ng-if=\"!$ctrl.onlyHome\">\n    <li  ng-repeat=\"step in $ctrl.steps track by step.name\" ng-class=\"{active: $last}\" ng-switch=\"$last || !!step.abstract\" class=\"ng-scope\">\n      <a ng-switch-when=\"false\" ui-sref=\"{{step.name}}\">{{step.data.label}}</a>\n      <span ng-switch-when=\"true\">{{step.data.label}}</span>\n    </li>\n  </ol>\n</div>\n<dmattnt-progress progress-disabled=\"!$ctrl.working\"></dmattnt-progress>";

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-container\">\n  <label for=\"{{$ctrl.prefix}}numeroInput\">Numéro</label>\n  <input type=\"text\" name=\"{{$ctrl.prefix}}numero\" id=\"{{$ctrl.prefix}}numeroInput\" maxlength=\"15\" ng-model=\"$ctrl.data.numero\" ng-change=\"$ctrl.onChange()\" class=\"input-text-100\">\n</div>\n<div class=\"input-container\" ng-class=\"{'has-error': $ctrl.parentForm[$ctrl.prefix + 'voie'].$dirty && $ctrl.parentForm[$ctrl.prefix + 'voie'].$invalid}\">\n  <label for=\"{{$ctrl.prefix}}voieInput\" class=\"label-required\">Voie ou lieu-dit</label>\n  <input type=\"text\" required name=\"{{$ctrl.prefix}}voie\" id=\"{{$ctrl.prefix}}voieInput\" maxlength=\"150\" ng-model=\"$ctrl.data.voie\" ng-change=\"$ctrl.onChange()\" class=\"input-text-400\">\n  <div class=\"input-error-messages\" ng-messages=\"$ctrl.parentForm[$ctrl.prefix + 'voie'].$error\" role=\"alert\" ng-show=\"$ctrl.parentForm[$ctrl.prefix + 'voie'].$dirty\">\n    <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n  </div>\n</div>\n<div class=\"input-container\" ng-class=\"{'has-error': $ctrl.parentForm[$ctrl.prefix + 'commune'].$dirty && $ctrl.parentForm[$ctrl.prefix + 'commune'].$invalid}\">\n  <label for=\"communeInput\" class=\"label-required\">Commune</label>\n  <ui-select required name=\"{{$ctrl.prefix}}commune\" id=\"communeInput\" ng-model=\"$ctrl.data.commune\" theme=\"selectize\" on-select=\"$ctrl.onCommuneSelect($item, $model)\" class=\"input-text-400\">\n    <ui-select-match placeholder=\"{{$select.open ? 'Saisissez le nom ou le code insee de la commune' : ''}}\" allow-clear=\"true\">\n      {{$select.selected.nom}} ({{$select.selected.numeroDep}}) <button type=\"button\" ng-if=\"$select.allowClear\" class=\"ui-select-clear btn btn-xsmall btn-secondary\" ng-click=\"$select.clear($event)\">Effacer</button>\n    </ui-select-match>\n    <ui-select-choices repeat=\"commune as commune in $ctrl.communes.data track by $index\" refresh=\"$ctrl.refreshCommunes($select.search)\" refresh-delay=\"10\">\n      <div ng-bind-html=\"(commune.nom + ' (' + commune.numeroDep + ')') | highlight: $select.search\"></div>\n    </ui-select-choices>\n    <ui-select-no-choice ng-show=\"$select.search &&\">\n      <span ng-hide=\"$ctrl.communes.loading\">Aucune commune n'a été trouvée.</span>\n    </ui-select-no-choice>\n  </ui-select>\n  <div class=\"input-error-messages\" ng-messages=\"$ctrl.parentForm[$ctrl.prefix + 'commune'].$error\" role=\"alert\" ng-show=\"$ctrl.parentForm[$ctrl.prefix + 'commune'].$dirty\">\n    <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n  </div>\n</div>\n<div class=\"input-container\" ng-class=\"{'has-error': $ctrl.parentForm[$ctrl.prefix + 'codePostal'].$dirty && $ctrl.parentForm[$ctrl.prefix + 'codePostal'].$invalid}\">\n  <label for=\"codePostalInput\" class=\"label-required\">Code postal</label>\n  <ui-select required name=\"{{$ctrl.prefix}}codePostal\" id=\"codePostalInput\" ng-model=\"$ctrl.data.codePostal\" theme=\"selectize\" on-select=\"$ctrl.onCodePostalSelect($item)\" class=\"input-text-200\">\n    <ui-select-match placeholder=\"{{$select.open ? 'Saisissez le code postal' : ''}}\" allow-clear=\"true\">\n      {{$select.selected.codepostal}} <button type=\"button\" ng-if=\"$select.allowClear\" class=\"ui-select-clear btn btn-xsmall btn-secondary\" ng-click=\"$select.clear($event)\">Effacer</button>\n    </ui-select-match>\n    <ui-select-choices repeat=\"cp as cp in $ctrl.communecps.data track by $index\" refresh=\"$ctrl.refreshCps($select.search)\" refresh-delay=\"10\">\n      <div ng-bind-html=\"cp.codepostal + ' ' + cp.nom| highlight: $select.search\"></div>\n    </ui-select-choices>\n    <ui-select-no-choice ng-show=\"$select.search &&\">\n      <span ng-hide=\"$ctrl.communecps.loading\">Aucun code postal n'a été trouvée</span>\n    </ui-select-no-choice>\n  </ui-select>\n  <div class=\"input-error-messages\" ng-messages=\"$ctrl.parentForm[$ctrl.prefix + 'codePostal'].$error\" role=\"alert\" ng-show=\"$ctrl.parentForm[$ctrl.prefix + 'codePostal'].$dirty\">\n    <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n  </div>\n</div>\n";

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-container\">\n  <label for=\"{{$ctrl.prefix}}complementInput\">Complément</label>\n  <input type=\"text\" name=\"{{$ctrl.prefix}}complement\" id=\"{{$ctrl.prefix}}complementInput\" ng-model=\"$ctrl.data.complement\" ng-change=\"$ctrl.onChange()\" maxlength=\"150\" class=\"input-text-400\">\n</div>\n";

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-container\" ng-class=\"{'has-error': $ctrl.parentForm[$ctrl.prefix + 'emetteurtnt'].$dirty && $ctrl.parentForm[$ctrl.prefix + 'emetteurtnt'].$invalid}\">\n  <ui-select required name=\"{{$ctrl.prefix}}emetteurtnt\" id=\"emetteurtntInput\" ng-model=\"$ctrl.data.emetteurtnt\" theme=\"selectize\" on-select=\"$ctrl.onEmetteurtntSelect($item, $model)\" class=\"input-text-400\">\n    <ui-select-match placeholder=\"{{$select.open ? 'Saisissez le nom de l\\'emetteur TNT' : ''}}\" allow-clear=\"true\">\n      {{$select.selected.nom}}<button type=\"button\" ng-if=\"$select.allowClear\" class=\"ui-select-clear btn btn-xsmall btn-secondary\" ng-click=\"$select.clear($event)\">Effacer</button>\n    </ui-select-match>\n    <ui-select-choices repeat=\"emetteurtnt as emetteurtnt in $ctrl.emetteurtnts.data track by $index\" refresh=\"$ctrl.refreshEmetteurtnts($select.search)\" refresh-delay=\"10\">\n      <div ng-bind-html=\"(emetteurtnt.nom) | highlight: $select.search\"></div>\n    </ui-select-choices>\n    <ui-select-no-choice ng-show=\"$select.search &&\">\n      <span ng-hide=\"$ctrl.emetteurtnts.loading\">Aucun émetteur TNT n'a été trouvée.</span>\n    </ui-select-no-choice>\n  </ui-select>\n  <div class=\"input-error-messages\" ng-messages=\"$ctrl.parentForm[$ctrl.prefix + 'emetteurtnt'].$error\" role=\"alert\" ng-show=\"$ctrl.parentForm[$ctrl.prefix + 'emetteurtnt'].$dirty\">\n    <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n  </div>\n</div>\n";

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "<form>\n  <div class=\"dark-grey triangle-before text\" ng-if=\"$ctrl.typePersonne === 'PART'\">Votre logement utilise une antenne râteau.<switch ng-model=\"$ctrl.data.antenne\" ng-change=\"$ctrl.onChange()\" class=\"small green\"></switch>\n    <div class=\"info\">\n      <span>La réception de la TNT par une box ADSL, la fibre ou le satellite relève de votre opérateur. Contactez-le directement.\n      </span>\n    </div>\n  </div>\n  <div class=\"dark-grey triangle-before text\" ng-if=\"$ctrl.typePersonne === 'PART'\">Vos voisins sont affectés de la meme manière.<switch ng-model=\"$ctrl.data.voisins\" ng-change=\"$ctrl.onChange()\" class=\"small green\"></switch>\n    <div class=\"info\">\n      <span>Si votre voisinage reçoit correctement la TNT par le râteau, mais qu’il n’est pas affecté comme vous, il \n        est possible qu’un défaut sur votre installation soit à l’origine de vos difficultés de réception. \n        Dans ce cas, nous vous invitons à faire vérifier votre installation par un professionnel.\n      </span> \n    </div>\n  </div>\n</form>\n";

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "<form>\n  <div  class=\"dark-grey triangle-before text\" ng-if=\"$ctrl.typePersonne !== 'GEST_SYNDIC'\">Votre logement utilise une antenne râteau.<switch name=\"{{$ctrl.prefix}}antenne\" ng-model=\"$ctrl.data.antenne\" ng-change=\"$ctrl.onChange()\" class=\"small green\"></switch>\n    <div class=\"info\">\n      <span>La réception de la TNT par une box ADSL, la fibre ou le satellite relève de votre opérateur. Contactez-le directement.</span>\n    </div>\n  </div>\n  <div  class=\"dark-grey triangle-before text\" ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\">Le(s) logement(s) concerné(s) utilise(nt) l’antenne râteau collective.<switch name=\"{{$ctrl.prefix}}antenne\" ng-model=\"$ctrl.data.antenne\" ng-change=\"$ctrl.onChange()\" class=\"small green\"></switch>\n    <div class=\"info\">\n      <span>La réception individuelle de la TNT par une box ADSL ou la fibre relève de l’opérateur auquel l’usager est abonné.\n        Il doit le contacter directement s’il n’utilise pas l’antenne collective et qu’il a des difficultés pour recevoir la TNT.</span>\n    </div>\n  </div>\n  <div class=\"dark-grey triangle-before text\" ng-if=\"$ctrl.typePersonne !== 'GEST_SYNDIC'\">Votre problème concerne tous les téléviseurs raccordés à l'antenne râteau.<switch name=\"{{$ctrl.prefix}}logement\" ng-model=\"$ctrl.data.logement\" ng-change=\"$ctrl.onChange()\" class=\"small green\"></switch>\n    <div class=\"info\">\n      <span>Si vous avez plusieurs téléviseurs reliés à l'antenne râteau, mais que le problème de réception ne les concerne pas tous, votre installation est défectueuse. Contactez un professionnel.</span>\n    </div>\n  </div>\n  <div class=\"dark-grey triangle-before text\" ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\">Le problème concerne tous les téléviseurs raccordés à l’antenne râteau collective.<switch name=\"{{$ctrl.prefix}}logement\" ng-model=\"$ctrl.data.logement\" ng-change=\"$ctrl.onChange()\" class=\"small green\"></switch>\n    <div class=\"info\">\n      <span>Si le problème de réception ne concerne pas tous les téléviseurs reliés à l'antenne râteau collective, l’installation est peut-être défectueuse.\n        Contactez directement le professionnel en charge de la maintenance des équipements collectifs.</span>\n    </div>\n  </div>\n  <div  class=\"dark-grey triangle-before text\" ng-if=\"$ctrl.typePersonne !== 'GEST_SYNDIC'\">Votre antenne râteau n’a pas été récemment endommagée (orage, vent violent, etc.).<switch name=\"{{$ctrl.prefix}}orage\" ng-model=\"$ctrl.data.orage\" ng-change=\"$ctrl.onChange()\" class=\" small green\"></switch>\n    <div class=\"info\">\n      <span>De fortes intempéries peuvent endommager votre antenne ou changer son alignement. Contactez un professionnel pour la faire vérifier.</span>\n    </div>\n  </div>\n  <div class=\"dark-grey triangle-before text\" ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\">L'installation collective n’a pas été récemment endommagée (orage, vent violent, etc.).<switch name=\"{{$ctrl.prefix}}orage\" ng-model=\"$ctrl.data.orage\" ng-change=\"$ctrl.onChange()\" class=\"small green\"></switch>\n    <div class=\"info\">\n      <span>De fortes intempéries peuvent endommager l'antenne collective ou changer son alignement. Contactez le professionnel en charge de la maintenance pour la faire vérifier. </span>\n    </div>\n  </div>\n</form>";

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "<!-- TODO: gestion de la couleur -->\n<div class=\"dmattnt__progress-container dmattnt__progress-container--linear\" ng-class=\"{ 'progress-container__determinate': $ctrl.value,\n                 'dmattnt__progress-container__indeterminate': !$ctrl.value, 'dmattnt__progress__disabled': $ctrl.disabled}\">\n  <div class=\"dmattnt__progress-linear\">\n    <div class=\"dmattnt__progress-linear__background\"></div>\n    <div class=\"dmattnt__progress-linear__bar dmattnt__progress-linear__bar--first\" ng-style=\"$ctrl.getLinearProgressValue()\"></div>\n    <div class=\"dmattnt__progress-linear__bar dmattnt__progress-linear__bar--second\"></div>\n  </div>\n</div>";

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-container\">\n  <label for=\"typeDefautInput\" class=\"label-required\">Type de défaut</label>\n  <label ng-repeat=\"typedefautVal in $ctrl.typesDefaut.data | orderBy: 'id' track by typedefautVal.id\">\n    <input type=\"radio\" required name=\"typedefaut\" value=\"{{typedefautVal.id}}\" ng-model=\"$ctrl.data.typeDefaut\" ng-change=\"$ctrl.onChange({{typedefautVal.id}})\">{{typedefautVal.nomSitePublic}}\n  </label>\n</div>\n";

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-container\" ng-class=\"{'has-error': $ctrl.parentForm.typePerturbation.$dirty && $ctrl.parentForm.typePerturbation.$invalid}\">\n  <div ng-if=\"$ctrl.origine !== 'antenniste' \" class=\"typeperturbation\">\n  <div class = \"typeperturbation-vignettes\">\n    <div ng-repeat=\"typePerturbation in $ctrl.typesPerturbation.data | orderBy: 'id' track by typePerturbation.id\">\n      <p class=\"typeperturbation-vignette\">\n        <input id=\"radio{{typePerturbation.id}}\" type=\"radio\" name=\"typePerturbation\" ng-click=\"$ctrl.onChange(typePerturbation.id)\">\n        <label class=\"typeperturbation{{typePerturbation.id}}\"  for=\"radio{{typePerturbation.id}}\"><div class=\"perturbation\">{{typePerturbation.nom}}</div></label>\n      </p>\n    </div>\n  </div>\n  <div class=\"input-error-messages\" ng-messages=\"$ctrl.parentForm.typePerturbation.$error\" role=\"alert\" ng-show=\"$ctrl.parentForm.typePerturbation.$dirty\">\n    <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n  </div>\n  <div class=\"warning-message\" ng-if=\"$ctrl.typesPerturbation.failure\">Une erreur est survenue à la récupération des listes des types de perturbation. Merci de réessayer d'ici quelques minutes.</div>\n</div>\n  <div ng-if=\"$ctrl.origine === 'antenniste' \">\n    <label ng-repeat=\"typePerturbation in $ctrl.typesPerturbation.data | orderBy: 'id' track by typePerturbation.id\">\n      <input type=\"radio\" required name=\"typePerturbation\" value=\"{{typePerturbation.id}}\" ng-model=\"$ctrl.data.typePerturbation\" ng-change=\"$ctrl.onChange({{typePerturbation.id}})\">{{typePerturbation.nom}}\n    </label>\n  </div>\n</div>\n";

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Le problème pourrait provenir d’un relais 4G dans le voisinage</h1>\n  <p ng-if=\"$ctrl.typePersonne !== 'GEST_SYNDIC'\">Indiquez-nous les coordonnées de la personne à contacter pour accéder à votre antenne (pour un immeuble, il s'agit du syndic).</p>\n  <p ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\">Indiquez-nous les coordonnées de la personne à contacter pour accéder à l’antenne collective.</p>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n      <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"dark-grey triangle-before label-required text\">Personne à contacter</div>\n        <div ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\" class=\"form-block\">\n          <label for=\"societeInput\" class=\"label-required\">Raison sociale du syndic ou du bailleur</label>\n          <input type=\"text\" required name=\"societe\" id=\"societeInput\" ng-model=\"$ctrl.data.societe\" class=\"input-text-400\" maxlength=\"100\">\n          <div class=\"input-error-messages\" ng-messages=\"form.societe.$error\" role=\"alert\" ng-show=\"form.societe.$dirty\">\n            <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n          </div>\n        </div>\n        <div  class=\"input-container\">\n          <div class=\"civilite flex-center\">\n            <span ng-repeat=\"mode in $ctrl.CIVILITE.VALUES\">\n              <p>\n                <input  required type=\"radio\" name=\"civilite\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.civilite\">{{ mode | labelCivilite }}\n              </p>\n            </span>\n          </div>\n        </div>\n        <div class=\"form-block\">\n        <div class=\"input-container\" ng-class=\"{'has-error': form.nom.$dirty && form.nom.$invalid}\">\n          <label for=\"nomInput\" class=\"label-required\">Nom</label>\n          <input type=\"text\" required name=\"nom\" id=\"nomInput\" ng-model=\"$ctrl.data.nom\" class=\"input-text-400\" maxlength=\"100\" ng-pattern=\"$ctrl.regex\">\n          <div class=\"input-error-messages\" ng-messages=\"form.nom.$error\" role=\"alert\" ng-show=\"form.nom.$dirty\">\n            <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n            <div ng-message=\"pattern\">Ce champ ne doit pas contenir de caractères spéciaux.</div>\n          </div>\n        </div>\n        </div>\n        <div class=\"form-block\">\n        <div class=\"input-container\" ng-class=\"{'has-error': form.prenom.$dirty && form.prenom.$invalid}\">\n          <label for=\"prenomInput\" class=\"label-required\">Prénom</label>\n          <input type=\"text\" required name=\"prenom\" id=\"prenomInput\" ng-model=\"$ctrl.data.prenom\" class=\"input-text-400\" maxlength=\"100\" ng-pattern=\"$ctrl.regex\">\n          <div class=\"input-error-messages\" ng-messages=\"form.prenom.$error\" role=\"alert\" ng-show=\"form.prenom.$dirty\">\n            <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n            <div ng-message=\"pattern\">Ce champ ne doit pas contenir de caractères spéciaux.</div>\n          </div>\n        </div>\n        </div>\n        <div class=\"form-block\">\n        <div class=\"input-container\">\n          <label for=\"telephone1Input\" class=\"label-required\">Téléphone</label>\n          <input type=\"tel\" required name=\"telephone1\" id=\"telephone1Input\" ng-model=\"$ctrl.data.telephone1\" class=\"input-text-200\" ng-pattern=\"$ctrl.telephonePattern\" maxlength=\"10\" minlength=\"10\">\n          <div class=\"input-error-messages\" ng-messages=\"form.telephone1.$error\" role=\"alert\" ng-show=\"form.telephone1.$dirty\">\n            <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n            <div ng-message=\"pattern\">Le numéro de téléphone n'est pas valide, il doit contenir 10 chiffres.</div>\n          </div>\n        </div>\n        </div>\n        <div class=\"form-block\">\n        <div class=\"input-container\" ng-class=\"{'has-error': form.courriel.$dirty && form.courriel.$invalid}\">\n          <label for=\"courrielInput\"  class=\"label-required\" >Courriel</label>\n          <input type=\"email\" required name=\"courriel\" id=\"courrielInput\" ng-model=\"$ctrl.data.courriel\" class=\"input-text-400\" placeholder=\"nom@domaine.com\" ng-pattern=\"$ctrl.emailPattern\">\n          <div class=\"input-error-messages\" ng-messages=\"form.courriel.$error\" role=\"alert\" ng-show=\"form.courriel.$dirty\">\n            <div ng-message=\"email\">Le format du courriel n'est pas valide.</div>\n            <div ng-message=\"pattern\">Le format du courriel n'est pas valide. Il doit être de la forme 'nom@domaine.com'</div>\n          </div>\n        </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"input-container\" ng-class=\"{'has-error': form.courriel2.$dirty && form.courriel2.$invalid}\">\n            <label for=\"courrielInput2\"  class=\"label-required\" >Confirmez votre courriel</label>\n            <input type=\"email\" required name=\"courriel2\" id=\"courrielInput2\" ng-model=\"$ctrl.data.courriel2\" class=\"input-text-400\" placeholder=\"nom@domaine.com\" ng-pattern=\"$ctrl.data.courriel\">\n            <div class=\"input-error-messages\" ng-messages=\"form.courriel2.$error\" role=\"alert\" ng-show=\"form.courriel2.$dirty\">\n              <div ng-message=\"pattern\">Les deux courriels doivent être identiques</div>\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"$ctrl.typePersonne !== 'GEST_SYNDIC'\">\n        <div class=\"dark-grey triangle-before text label-required\">Votre installation est-elle raccordée à une antenne collective ? (appartenant au propriétaire ou à vous-même)</div>\n        <div class=\"form-block\">\n          <div class=\"input-container\">\n            <label ng-repeat=\"mode in $ctrl.MODE_RACCORDEMENT.VALUES\">\n              <p>\n                <input type=\"radio\" required name=\"modeRaccordement\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.modeRaccordement\">{{ mode | labelModeRaccordement }}\n              </p>\n            </label>\n          </div>\n        </div>\n        <div ng-if=\"$ctrl.data.modeRaccordement === $ctrl.MODE_RACCORDEMENT.NSP\">\n        <div class=\"dark-grey triangle-before text label-required\">Dans quel type de logement habitez-vous ?</div>\n        <div class=\"form-block\">\n          <div class=\"input-container\">\n            <label ng-repeat=\"mode in $ctrl.TYPE_LOGEMENT.VALUES\">\n              <p>\n                <input type=\"radio\" required name=\"typeLogement\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.typeLogement\">{{ mode | labelTypeLogement }}\n              </p>\n            </label>\n          </div>\n        </div>\n        </div>\n          <div class=\"form-block\" ng-if=\"$ctrl.typePersonne === 'PART'\">\n            <div class=\"dark-grey triangle-before text label-required\">Vos voisins ont-ils le même problème ?</div>\n            <div class=\"input-container\">\n              <label ng-repeat=\"mode in $ctrl.OUI_NON_NSP.VALUES\">\n                <p>\n                <input type=\"radio\" required name=\"voisinsImpactes\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.voisinsImpactes\">{{ mode | labelOuiNonNsp }}</p></label>\n            </div>\n          </div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Valider</button>\n        </div>\n      </form>\n      </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n";

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <div ng-if=\"$ctrl.typePersonne !== 'GEST_SYNDIC'\" class=\"reponse\">\n    <p>Les difficultés que vous rencontrez semblent liées à un relais du réseau de téléphonie mobile de très haut débit à proximité de votre domicile.</p>\n    <p>Vous allez recevoir un courriel de confirmation.</p>\n    <p>Les informations fournies seront transmises à l'opérateur de téléphonie mobile qui vous adressera un professionnel pour la pose d’un filtre. L’intervention est gratuite et entièrement prise en charge par l’opérateur.</p>\n    <p>L'antenniste prendra contact avec vous dans les prochains jours pour convenir d'une date d'intervention.</p>\n  </div>\n  <div ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\" class=\"reponse\">\n    <p>Les difficultés rencontrées semblent liées à un relais 4G à proximité de l’adresse que vous avez indiqué.</p>\n    <p>Vous allez recevoir un courriel de confirmation.</p>\n    <p>Les informations fournies seront transmises à l’opérateur mobile qui vous adressera un professionnel pour la pose d’un filtre 4G (l’intervention est prise en charge par l’opérateur).</p>\n    <p>L’antenniste prendra contact avec vous dans les prochains jours pour convenir d’une date d’intervention.</p>\n  </div>\n  <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n  <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n    <form name=\"form\">\n      <div class=\"form-actions\">\n        <!--<button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>-->\n        <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn right\"  ng-click=\"$ctrl.nextStep()\">Retourner à l'accueil</button>\n      </div>\n    </form>\n  </div>\n</section>";

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <h1>Confirmation des informations de l’antenniste</h1>\n    <div ng-if = \"$ctrl.demandeEnquetePapier===true\">\n        <form name=\"form\">\n            <p class=\"informations-dossier\">Dossier n° {{$ctrl.demande.numeroAnfr}} -\n                {{($ctrl.nom | uppercase)}}\n                {{$ctrl.prenom}}</p>\n            <div class=\"form-block\">\n                <p>Si vous confirmez ce choix, celui-ci sera contacté par l’ANFR afin qu’il accepte de traiter votre dossier.\n                </p>\n            </div>\n            <div class=\"dmattnt__content-page formulaire\">\n                <div class=\"form-block\">\n                    <div class=\"dark-grey triangle-before text\">\n                        Rappel des informations sur l'antenniste :\n                    </div>\n                    <div class=\"content-to-margin\" style=\"margin-top:1em\">\n                        <p>Dénomination commerciale : <b>{{$ctrl.demande.prtvDepotFacture.denomination}}</b></p>\n                        <p>Nom contact : <b>{{$ctrl.demande.prtvDepotFacture.nomContact}}</b></p>\n                        <p>Adresse : <b>{{$ctrl.demande.prtvDepotFacture.adresseContact}}</b></p>\n                        <p>Numéro de téléphone : <b>{{$ctrl.demande.prtvDepotFacture.telContact}}</b></p>\n                        <p>Email : <b>{{$ctrl.demande.prtvDepotFacture.mailContact}}</b></p>\n                        <p>Nom de la facture : <b>{{$ctrl.demande.prtvDepotFacture.factureFileName}}</b></p>\n                        <div ng-if=\"$ctrl.demande.prtvDepotFacture.autresFactures.length>0\"><p>Nom des pièces jointes secondaires supplémentaires :\n                            <span ng-repeat=\"file in $ctrl.demande.prtvDepotFacture.autresFactures track by file.id\"><b>\n                                {{file.name}} </b></span></p>\n                        </div>\n                    </div>\n                </div>\n                <hr>\n                <div class=\"form-actions buttons-to-flex text\">\n                    Confirmez-vous les coordonnées de cet antenniste ?\n                    <button type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Corriger</button>\n                    <button type=\"submit\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Valider</button>\n                </div>\n            </div>\n        </form>\n    </div>\n    </div>\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n  </section>\n  \n";

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <h1>Informations transmises</h1>\n    <div ng-if = \"$ctrl.demandeEnquetePapier===true\"></div>\n        <p class=\"informations-dossier\">Dossier n° {{$ctrl.demande.numeroAnfr}} - \n            {{($ctrl.nom | uppercase)}} \n            {{$ctrl.prenom}}</p>\n        <div class=\"dmattnt__content-page formulaire\">\n            <div>\n                <p>\n                    <p>Votre choix a été pris en compte.</p>\n                    <p>Nous vous rappelons que, l’installation de réception étant sous votre responsabilité, l’intervention de l’antenniste à votre domicile est payante et à votre charge.</p>\n                    <p>Il sera contacté pour lui demander de traiter votre demande d’enquête.\n                    Quand il l’aura accepté, nous vous enverrons un message pour vous signaler que votre demande d’enquête est en\n                    cours de traitement par le professionnel.</p>\n                    <p>Si le professionnel n’est pas en mesure de traiter votre demande d’enquête, ou s’il met plus de 2 semaines pour répondre, vous serez averti par courriel et vous aurez la possibilité de choisir à nouveau un autre professionnel en vous reconnectant à cet outil.</p>\n                    <!--TODO seulement dans le cas ou il y a eu une facture fournie-->\n                    <p ng-if = \"$ctrl.factureFileName != null\">Merci pour ces documents. Ils seront examinés par l'ANFR dans le cadre de l'étude de votre demande d’enquête. Si toutefois, ces documents s'avèrent insuffisants pour permettre une conclusion définitive,\n                    l'ANFR se réserve le droit de vous demander de faire intervenir à nouveau un antenniste.</p>\n                </p>\n            </div>\n            <hr>\n            <div id=\"RetourAccueil\">\n                <button type=\"button\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Retourner à l'accueil</button>\n            </div>\n        </div>\n    </div>\n<div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n</section>\n  ";

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <h1>Depôt de facture</h1>\n    <div ng-if=\"$ctrl.demande.codeStatut=='PRTV_DE_EN_COURS_SAISIE_PAR_LE_TSP'\">\n        <p class=\"informations-dossier\">Dossier n° {{$ctrl.demande.numeroAnfr}} - \n            {{($ctrl.nom | uppercase)}} \n            {{$ctrl.prenom}}</p>\n        <div class=\"dmattnt__content-page formulaire\">\n            <div class=\"form-block\">\n                <div class=\"dark-grey triangle-before text label-required\">\n                    Disposez-vous d’une facture de moins d'un an justifiant le contrôle de votre installation par un antenniste ?\n                    <switch ng-model=\"$ctrl.data.isFactureOk\" class=\"small green\"></switch>\n                </div>\n            </div>\n            <div ng-if = \"$ctrl.data.isFactureOk\">\n                <form name=\"form\">\n                    <div class=\"form-block\">\n                        <div class=\"dark-grey triangle-before text label-required\">\n                            Sélectionner une copie de la facture attestant du contrôle de l’installation par l’antenniste.\n                        </div>\n                        <div class=\"content-to-margin fileLimitSize\">\n                            <input style=\"margin-bottom:1em\" type=\"file\" id=\"factureFile\" ng-model=\"$ctrl.data.factureFile\"\n                            onchange=\"angular.element(this).scope().factureFileChanged(this)\" accept=\".jpg, .png, .pdf, .docx\"/>\n                            <div ng-show=\"$ctrl.data.factureFileName !== ''\" id=\"removableFacture\">\n                                Fichier sélectionné : <input id=\"duplicataFacture\" ng-model=\"$ctrl.data.factureFileName\" disabled></input>\n                                <button ng-click=\"$ctrl.onClickRemoveFactureFile()\" id=\"removeFactureFileBtn\">Retirer</button>\n                            </div>\n                            <div class=\"input-error-messages\" ng-messages=\"form.factureFile.$error\" role=\"alert\" ng-show=\"form.factureFile.$dirty\">\n                                <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-if=\"$ctrl.data.factureFileName !== ''\" class=\"form-block\">\n                        <div class=\"dark-grey triangle-before text \">Si vous avez d’autres documents complémentaires relatifs au problème constaté \n                            (résultats de mesures, descriptif, etc.), déposez-les ci-dessous. Ces documents seront très utiles à l’ANFR et peuvent conditionner la qualité de \n                            son étude. N’hésitez pas à les demander à votre antenniste.\n                        </div>\n                        <div class=\"content-to-margin\">\n                            <div style=\"display:flex; gap:2em;\">\n                                <div style=\"width:50%\" class=\"fileLimitSize\">\n                                    <input style=\"margin-bottom:1em\" type=\"file\" id=\"otherFile\" ng-model=\"$ctrl.data.otherFile\"\n                                    onchange=\"angular.element(this).scope().otherFileChanged(this)\" accept=\".jpg, .png, .pdf, .docx\"/>\n                                </div>\n                                <div id=\"otherFiles\" ng-show=\"$ctrl.data.autresFactures.length>0\">\n                                    <u>Autre(s) fichier(s) sélectionné(s) :</u> <p ng-repeat=\"file in $ctrl.data.autresFactures track by file.id\">\n                                        {{file.name}} <button deleteId=\"{{file.id}}\" ng-click=\"$ctrl.onClickRemoveOtherFiles($event)\">Retirer</button></p>\n                                </div>\n                            </div>\n                            <div>\n                                <button style=\"margin-top:1em;\" ng-click=\"$ctrl.onClickAddOtherFile()\" id=\"addOtherFileBtn\">Ajouter ce fichier supplémentaire</button>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-block\">\n                        <div class=\"dark-grey triangle-before text \">\n                            Saisissez les coordonnées de l’antenniste qui est intervenu\n                        </div>\n                        <div class=\"form-block champs\">\n                            <div class=\"input-container\">\n                            <label for=\"denominationInput\" class=\"label-required\">Dénomination commerciale</label>\n                            <input type=\"text\" required name=\"denominationInput\" id=\"denominationInput\" ng-model=\"$ctrl.data.denomination\" class=\"input-text-200\" maxlength=\"150\">\n                            <div class=\"input-error-messages\" ng-messages=\"form.denominationInput.$error\" role=\"alert\" ng-show=\"form.denominationInput.$dirty\">\n                                <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                                </div>\n                            </div>\n                            <div class=\"input-container\">\n                                <label for=\"nomContactInput\" class=\"label-required\">Nom contact</label>\n                                <input type=\"text\" required name=\"nomContactInput\" id=\"nomContactInput\" ng-model=\"$ctrl.data.nomContact\" class=\"input-text-200\" maxlength=\"150\">\n                                <div class=\"input-error-messages\" ng-messages=\"form.nomContactInput.$error\" role=\"alert\" ng-show=\"form.nomContactInput.$dirty\">\n                                    <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                                </div>\n                            </div>\n                            <div class=\"input-container\">\n                                <label for=\"adresseContactInput\" class=\"label-required\">Adresse contact</label>\n                                <input type=\"text\" required name=\"adresseContact\" id=\"adresseContactInput\" ng-model=\"$ctrl.data.adresseContact\" class=\"input-text-200\" maxlength=\"250\">\n                                <div class=\"input-error-messages\" ng-messages=\"form.adresseContact.$error\" role=\"alert\" ng-show=\"form.adresseContact.$dirty\">\n                                    <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                                </div>\n                            </div>\n                            <div class=\"input-container\">\n                                <label for=\"telContactInput\" class=\"label-required\">N° Téléphone contact</label>\n                                <input type=\"text\" required name=\"telContact\" id=\"telContactInput\" ng-model=\"$ctrl.data.telContact\" class=\"input-text-200\" ng-pattern=\"$ctrl.telephonePattern\" maxlength=\"10\" minlength=\"10\">\n                                <div class=\"input-error-messages\" ng-messages=\"form.telContact.$error\" role=\"alert\" ng-show=\"form.telContact.$dirty\">\n                                    <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                                    <div ng-message=\"pattern\">Le numéro de téléphone n'est pas valide, il doit contenir 10 chiffres.</div>\n                                </div>\n                            </div>\n                            <div class=\"input-container\" ng-class=\"{'has-error': form.mailContact.$dirty && form.mailContact.$invalid}\">\n                                <label for=\"mailContactInput\"  class=\"label-required\" >Mail Contact</label>\n                                <input type=\"email\" required name=\"mailContact\" id=\"mailContactInput\" ng-model=\"$ctrl.data.mailContact\" placeholder=\"nom@domaine.com\" class=\"input-text-200\" ng-pattern=\"$ctrl.emailPattern\">\n                                <div class=\"input-error-messages\" ng-messages=\"form.mailContact.$error\" role=\"alert\" ng-show=\"form.mailContact.$dirty\">\n                                    <div ng-message=\"email\">Le format du courriel n'est pas valide.</div>\n                                    <div ng-message=\"pattern\">Le format du courriel n'est pas valide. Il doit être de la forme 'nom@domaine.com'</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n                <hr>\n                <div class=\"form-actions withoutPrev\">\n                    <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working || !$ctrl.data.isFactureOk\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Suivant</button>\n                </div>\n            </div>\n            <div ng-if = \"!$ctrl.data.isFactureOk\">\n                <p>Avant de poursuivre votre démarche, il convient de prendre rendez-vous avec un antenniste pour faire vérifier votre installation. \n                Vous trouverez ci-dessous une liste de professionnels partenaires de l’ANFR proches de chez vous. \n                Une fois le rendez-vous pris, revenez sur ce site pour poursuivre votre réclamation.</p>\n                <div class=\"form-block\">\n                    <div class=\"form-block flex-center\">\n                        <div class=\"distance-text\">Distance par rapport à votre adresse pour la prise en compte des antennistes dans la liste : </div>\n                        <div>\n                            <input id=\"distance-range-input\" type=\"range\" min=\"5000\" max=\"50000\" step=\"1000\" ng-model=\"$ctrl.rayonMax\" ng-change=\"$ctrl.onChangeRayonMax($event)\">{{$ctrl.rayonMax/1000}} km\n                        </div>\n                    </div>\n                    <div ng-show=\"!$ctrl.nbOfAntennistes > 0 && !$ctrl.loadingWebService\">Il n'y a aucun antenniste charté dans un rayon de {{$ctrl.rayonMax/1000}} km autour de votre adresse.</div>\n                    <div ng-show=\"$ctrl.nbOfAntennistes > 0 && !$ctrl.loadingWebService\" class=\"form-block loading-table\">\n                        <div style=\"margin-bottom:1em\">Il y a {{$ctrl.nbOfAntennistes}} antenniste(s) à moins de {{$ctrl.rayonMax/1000}} km de votre adresse.</div>\n                        <div class=\"cadre-table-scroll\">\n                            <table ng-style=\"tableStyle\" id=\"liste_des_antennistes\">\n                                <thead>\n                                    <tr>\n                                        <th>Dénomination</th>\n                                        <th>Nom</th>\n                                        <th>Prénom</th>\n                                        <th>Téléphone</th>\n                                        <th>Mail</th>\n                                        <th >Adresse</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <tr id=\"{{antenniste.id}}\" ng-repeat=\"antenniste in $ctrl.allAntennistes.data\">\n                                        <td>{{antenniste.denomination}}</td>\n                                        <td>{{antenniste.antennisteContacts[0].idcontact.nom }}</td>\n                                        <td>{{antenniste.antennisteContacts[0].idcontact.prenom }}</td>\n                                        <td>{{antenniste.tel}}</td>\n                                        <td>{{antenniste.courriel}}</td>\n                                        <td>{{antenniste.idadresse.adresseStructuree}}</td>\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                        <div class=\"caption\">La liste ci-dessus est représentative des professionnels partenaires de l’ANFR et situés à proximité de chez vous, \n                            mais n’est pas exhaustive. D’autres professionnels sont disponibles sur les plateformes de recherche habituelles (moteur de recherche, \n                            pages jaunes, etc.).\n                        </div>\n                    </div>\n                    <div ng-show=\"$ctrl.loadingWebService\">\n                        <div id=\"loading-spinner\" class=\"spinner\">\n                            <div class=\"spinner-circle\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n  </section>\n  \n";

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1 ng-if=\"$ctrl.suspicionLte.message==='0'\">Nous ne pouvons pas vous donner de diagnostic immédiat. Laissez-nous vos coordonnées pour que nous puissions vous contacter</h1>\n  <h1 ng-if=\"$ctrl.suspicionLte.message!=='0'\">Nous ne pouvons pas vous donner de diagnostic immédiat. Laissez-nous vos coordonnées pour que nous puissions éventuellement vous contacter</h1>\n  <p ng-if=\"$ctrl.suspicionLte.message==='0'\"></p>\n  <p ng-if=\"$ctrl.suspicionLte.message!=='0'\"></p>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n    <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n      <form name=\"form\">\n        <div class=\"form-block\" ng-if=\"$ctrl.suspicionLte.message==='0'\">\n          <div class=\"dark-grey triangle-before text\">Un antenniste a-t-il confirmé un brouillage par un relais 4G ?</div>\n          <div  class=\"input-container\">\n            <label ng-repeat=\"mode in $ctrl.OUI_NON.VALUES\">\n              <p>\n              <input type=\"radio\" required name=\"stationLteConfirmee\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.stationLteConfirmee\">{{ mode | labelOuiNon }}</label>\n              </p>\n            </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text label-required\">Quel est le problème constaté ?</div>\n          <dmattnt-type-perturbation parent-form=\"form\" type-perturbation=\"$ctrl.data.typePerturbation\" on-type-perturbation-change=\"$ctrl.onTypePerturbationChange(typePerturbation)\"></dmattnt-type-perturbation>\n        </div>\n        <div class=\"form-block\" ng-if=\"$ctrl.isAdresseDomCom\">\n          <div class=\"dark-grey triangle-before text\">Recevez-vous encore les chaînes de télévision ?</div>\n          <div class=\"input-container\">\n            <label ng-repeat=\"mode in $ctrl.OUI_NON.VALUES\">\n              <p>\n                <input type=\"radio\" required name=\"chainesRecues\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.chainesRecues\">{{ mode | labelOuiNon }}</label>\n              </p>\n          </div>\n        </div>\n        <div class=\"form-block chaines-intactes\" ng-if=\"!$ctrl.isAdresseDomCom\">\n          <div class=\"dark-grey triangle-before text\">Quelles sont les chaînes encore bien reçues ?</div>\n          <div class=\"warning-message\" ng-if=\"$ctrl.multiplexFailure\">Une erreur est survenue à la récupération des listes des chaînes. Merci de réessayer d'ici quelques minutes.</div>\n          <div class=\"important-msg\">Afin d'améliorer la qualité de notre réponse, nous nous permettons d'insister sur l'importance de bien sélectionner précisément toutes les chaînes encore bien reçues,\n            afin que cette information soit exhaustive et puisse être utilisée au mieux.\n          </div>\n          <div ng-if=\"!$ctrl.multiplexFailure\" class=\"chaines\">\n            <div ng-if=\"$ctrl.multiplex\">\n              <div class = \"chaines-tab\">\n                <div ng-repeat=\"chaine in $ctrl.data.allChaines | orderBy: 'id' track by chaine.id\">\n                  <p class=\"chaine\">\n                    <input id=\"{{chaine.code}}\" type=\"checkbox\" name=\"chaine\" ng-model=\"$ctrl.chainesCode[chaine.id]\" value=\"true\" ng-change=\"$ctrl.onChangeSelected(chaine)\">\n                    <label class=\"chaine{{chaine.code}}\" for=\"{{chaine.code}}\" title=\"{{chaine.nom}}\"></label>\n                  </p>\n                </div>\n                <div>\n                  <p class=\"chaine\">\n                    <input id=\"{{0}}\" type=\"checkbox\" name=\"chaine\" ng-model=\"$ctrl.chainesCode[0]\" value=\"true\" ng-change=\"$ctrl.onChangeSelected(null)\">\n                    <label class=\"chaine{{0}}\" for=\"{{0}}\" title=\"{{local}}\"></label>\n                  </p>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"!$ctrl.multiplex\" class=\"warning-message\">Une erreur est survenue à la récupération des listes des chaînes. Merci de réessayer d'ici quelques minutes.</div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before label-required text\">Personne à contacter</div>\n          <div ng-if=\"$ctrl.typePersonne === 'GEST_SYNDIC'\" class=\"form-block\">\n            <label for=\"societeInput\">Raison sociale du syndic ou du bailleur</label>\n            <input type=\"text\" required name=\"societe\" id=\"societeInput\" ng-model=\"$ctrl.data.societe\" class=\"input-text-400\" maxlength=\"100\">\n            <div class=\"input-error-messages\" ng-messages=\"form.societe.$error\" role=\"alert\" ng-show=\"form.societe.$dirty\">\n              <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n            </div>\n          </div>\n          <div  class=\"input-container\">\n            <div class=\"civilite flex-center\">\n              <span ng-repeat=\"mode in $ctrl.CIVILITE.VALUES\">\n                <p>\n                <input required type=\"radio\" name=\"civilite\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.civilite\">{{ mode | labelCivilite }}</span>\n                </p>\n            </div>\n          </div>\n        </div>\n        <div class=\"input-container\" ng-class=\"{'has-error': form.nom.$dirty && form.nom.$invalid}\">\n          <label for=\"nomInput\" class=\"label-required\">Nom</label>\n          <input type=\"text\" required name=\"nom\" id=\"nomInput\" ng-model=\"$ctrl.data.nom\" class=\"input-text-400\" maxlength=\"100\" ng-pattern=\"$ctrl.regex\">\n          <div class=\"input-error-messages\" ng-messages=\"form.nom.$error\" role=\"alert\" ng-show=\"form.nom.$dirty\">\n            <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n              <div ng-message=\"pattern\">Ce champ ne doit pas contenir de caractères spéciaux.</div>\n          </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"input-container\" ng-class=\"{'has-error': form.prenom.$dirty && form.prenom.$invalid}\">\n            <label for=\"prenomInput\" class=\"label-required\">Prénom</label>\n            <input type=\"text\" required name=\"prenom\" id=\"prenomInput\" ng-model=\"$ctrl.data.prenom\" class=\"input-text-400\" maxlength=\"100\" ng-pattern=\"$ctrl.regex\">\n            <div class=\"input-error-messages\" ng-messages=\"form.prenom.$error\" role=\"alert\" ng-show=\"form.prenom.$dirty\">\n              <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n                <div ng-message=\"pattern\">Ce champ ne doit pas contenir de caractères spéciaux.</div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"input-container\">\n            <label for=\"telephone1Input\" class=\"label-required\">Téléphone</label>\n            <input type=\"tel\" required name=\"telephone1\" id=\"telephone1Input\" ng-model=\"$ctrl.data.telephone1\" class=\"input-text-200\" ng-pattern=\"$ctrl.telephonePattern\" maxlength=\"10\" minlength=\"10\">\n            <div class=\"input-error-messages\" ng-messages=\"form.telephone1.$error\" role=\"alert\" ng-show=\"form.telephone1.$dirty\">\n              <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n              <div ng-message=\"pattern\">Le numéro de téléphone n'est pas valide, il doit contenir 10 chiffres.</div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"input-container\" ng-class=\"{'has-error': form.courriel.$dirty && form.courriel.$invalid}\">\n            <label for=\"courrielInput\"  class=\"label-required\" >Courriel</label>\n            <input type=\"email\" required name=\"courriel\" id=\"courrielInput\" ng-model=\"$ctrl.data.courriel\" class=\"input-text-400\" placeholder=\"nom@domaine.com\" ng-pattern=\"$ctrl.emailPattern\">\n            <div class=\"input-error-messages\" ng-messages=\"form.courriel.$error\" role=\"alert\" ng-show=\"form.courriel.$dirty\">\n              <div ng-message=\"email\">Le format du courriel n'est pas valide.</div>\n              <div ng-message=\"pattern\">Le format du courriel n'est pas valide. Il doit être de la forme 'nom@domaine.com'</div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"input-container\" ng-class=\"{'has-error': form.courriel2.$dirty && form.courriel2.$invalid}\">\n            <label for=\"courrielInput2\"  class=\"label-required\" >Confirmez votre courriel</label>\n            <input type=\"email\" required name=\"courriel2\" id=\"courrielInput2\" ng-model=\"$ctrl.data.courriel2\" class=\"input-text-400\" placeholder=\"nom@domaine.com\" ng-pattern=\"$ctrl.data.courriel\">\n            <div class=\"input-error-messages\" ng-messages=\"form.courriel2.$error\" role=\"alert\" ng-show=\"form.courriel2.$dirty\">\n              <div ng-message=\"pattern\">Les deux courriels doivent être identiques</div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"dark-grey triangle-before text\">Avez-vous des informations complémentaires ou d'autres détails à nous fournir ?</div>\n          <div class=\"input-container\">\n            <textarea name=\"complement\" id=\"complementInput\" ng-model=\"$ctrl.data.complement\" class=\"input-text-400\" placeholder=\"1000 caractères maximum\" maxlength=\"1000\"></textarea>\n          </div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Valider</button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"pts\">Les champs suivis de <label class=\"label-helper label-required\"></label> sont obligatoires.</div>\n</section>\n";

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Demande d'enquête</h1>\n  <p class=\"informations-dossier\">Dossier n° {{$ctrl.demande.numeroAnfr}} - \n    {{($ctrl.nom | uppercase)}} \n    {{$ctrl.prenom}}</p>\n  <div class=\"dmattnt__content-page formulaire\">\n    <div ng-if = \"$ctrl.demandeEnquetePapier===true\">\n      <p>\n        Nous vous prions de bien vouloir répondre aux questions suivantes, puis de demander à un antenniste de contrôler la qualité de votre installation et \n        de vérifier qu'elle n'est pas à l'origine des difficultés de réception que vous rencontrez.\n        Ce professionnel devra également répondre à un questionnaire qui permettra à l'Agence nationale des fréquences (ANFR) de déterminer si l'ouverture \n        d'une enquête technique se révèle nécessaire.\n      </p>\n      <p>\n        L'ANFR n'intervient en effet que lorsque les dysfonctionnements ont une cause extérieure à l'installation de réception individuelle ou collective. \n        Ainsi, les équipements qui se situent chez les téléspectateurs ou dans les parties communes des habitats collectifs, de l'antenne jusqu'aux prises \n        murales de raccordement, relèvent de la responsabilité, respectivement, \n        des téléspectateurs, ou des gestionnaires de ces collectifs, qui doivent en assurer la vérification.\n      </p>\n      <p>En outre, veuillez au préalable vérifier si :</p>\n      <div ng-if=\"!$ctrl.failure && !$ctrl.fetching\">\n        <form name=\"form\">\n          <div class=\"form-block\">\n            <dmattnt-prequis-conclusion parentForm=\"form\"\n            prefix=\"prerequis\"\n            initial-data= \"$ctrl.prerequis\"\n            type-personne= \"$ctrl.typePersonne\"\n            on-prerequis-change=\"$ctrl.onPrerequisChange(prerequis)\">\n            </dmattnt-prerequis-conclusion>\n          </div>\n            <hr>\n            <div class=\"form-actions withoutPrev\">\n              <button type=\"submit\" ng-disabled=\"$ctrl.disableNext\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Suivant</button>\n            </div>\n        </form>\n      </div>\n    </div>\n    <div  ng-if = \"$ctrl.demandeEnquetePapier===false\">\n      <p>\n        Merci d’avoir pris le temps de nous répondre. Vous allez recevoir un courriel de confirmation.\n      </p>\n      <p>\n        Une étude va être menée sur la base des informations fournies. Nous sommes susceptibles de vous rappeler si d’autres informations précises sont nécessaires.\n      </p>\n      <p>\n        Pour vous tenir informé d’éventuels dysfonctionnements dans votre zone, vous pouvez consulter notre site internet en <a href=\"https://www.recevoirlatnt.fr/particuliers/dans-votre-region/\" target=\"_blank\">cliquant ici</a>.\n      </p>\n      <hr>\n      <div class=\"form-actions\">\n        <button type=\"submit\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Retour à l'accueil</button>\n      </div>\n    </div>\n  </div>\n  <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n</section>\n";

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Contrôles à effectuer par vous-même</h1>\n  <div ng-if = \"$ctrl.demandeEnquetePapier===true\">\n    <p class=\"informations-dossier\">Dossier n° {{$ctrl.demande.numeroAnfr}} - \n      {{($ctrl.nom | uppercase)}} \n      {{$ctrl.prenom}}</p>\n    <div class=\"dmattnt__content-page formulaire\">\n      <form name=\"form\">\n        <div ng-if=\"$ctrl.typePersonne === 'PART'\">\n          <div class=\"form-block\">\n            <div class=\"dark-grey triangle-before label-required text\">\n              Avant les difficultés que vous rencontrez actuellement, diriez-vous que la qualité de votre réception était...\n            </div>\n            <div class=\"radio-container flex-center\">\n              <label ng-repeat=\"mode in $ctrl.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.VALUES\">\n              <p>\n                <input class=\"\" type=\"radio\" required name=\"connexionQuality\" ng-change=\"$ctrl.onChangeConnexionQuality()\" value=\"{{ mode }}\" ng-model=\"$ctrl.data.connexionQuality\">{{ mode | labelMauvaiseInstableBonneExcellente }}\n              </p>\n              </label>\n            </div>\n            <div ng-if=\"$ctrl.data.connexionQuality === $ctrl.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.MAUVAISE\n                      || $ctrl.data.connexionQuality === $ctrl.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.INSTABLE\">\n              <p style=\"margin-top:1em;margin-left:1em\">Vous semblez être dans une zone limite pour la réception de la TNT.</p>\n              <div class=\"form-block\">\n                <div class=\"dark-grey triangle-before text\">\n                  Souhaitez-vous continuer la demande d'enquête ? \n                  <switch ng-model=\"$ctrl.data.isContinue\" class=\"small green\"></switch>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"$ctrl.data.isContinue || $ctrl.data.connexionQuality === $ctrl.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.BONNE \n          || $ctrl.data.connexionQuality === $ctrl.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.EXCELLENTE\">\n            <div ng-show=\"$ctrl.containsStations\" class=\"form-block\">\n              <div class=\"dark-grey triangle-before text\">\n                Sur les chaînes n°30 à 39 composées sur la télécommande de votre téléviseur, quelles chaînes locales recevez-vous ?\n              </div>\n              <div class=\"content-to-margin\">\n                <label ng-repeat=\"chaine in $ctrl.data.channels.station\">\n                  <p>{{chaine.name}}<switch ng-model=\"chaine.switchValue\" ng-change=\"$ctrl.onChangeChaineRecue(chaine)\"></switch></p>   \n                </label>\n              </div>\n            </div>\n            <div class=\"form-block\">\n              <div class=\"dark-grey triangle-before label-required text\">\n                Orientation de l’antenne\n              </div>\n              <div class=\"content-to-margin\">\n                <p>Voici le ou les émetteurs qui couvrent normalement la zone. Veuillez choisir celui vers lequel votre antenne semble être orientée.\n                  Si vous avez des raisons de penser que votre antenne est orientée vers un émetteur qui ne fait pas partie de cette liste, nous vous invitons à faire vérifier votre installation par un professionnel.\n                </p>\n                <label ng-repeat=\"station in $ctrl.data.channels.site\">\n                  <p><input id=\"button-station-style\" type=\"radio\" class=\"\" required name=\"receivedStation\" ng-value=\"station.name\" ng-model=\"$ctrl.data.receivedStation\" ng-click=\"$ctrl.onClickStationButton()\">{{station.name}}</p>\n                </label>\n                <div class=\"flex-center\">\n                  <div>\n                    <label id=\"margin-top-remover\">\n                      <input type=\"radio\" class=\"radioButton3\" ng-value=\"$ctrl.OTHER_VALUE\" required name=\"receivedStation\" ng-model=\"$ctrl.data.receivedStation\">\n                      Autre\n                    </label>\n                  </div>\n                  <div style=\"margin-left:1em\" ng-if=\"$ctrl.data.receivedStation == $ctrl.OTHER_VALUE\">\n                    <input style=\"margin:0\" type=\"text\" ng-change=\"$ctrl.onChangeInputOtherStation()\" ng-model=\"$ctrl.data.otherSelectedStationName\" maxlength=\"100\">\n                  </div>\n                  <div style=\"margin-left:1em\" ng-if=\"$ctrl.data.receivedStation == $ctrl.OTHER_VALUE\">\n                    Je ne connais pas mon orientation\n                  </div>\n                  <div style=\"margin-left:1em\" ng-if=\"$ctrl.data.receivedStation == $ctrl.OTHER_VALUE\">\n                    <switch style=\"margin-bottom:1em\" ng-if=\"$ctrl.data.receivedStation == $ctrl.OTHER_VALUE\" ng-model=\"$ctrl.data.isNoOrientation\" ng-change=\"$ctrl.onChangeButtonNoOrientation()\" class=\"small green\"></switch>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-block\">\n              <div class=\"dark-grey triangle-before label-required text\">\n                Description de la perturbation\n              </div>\n              <div class=\"radio-container flex-center\">\n                <div><p>Les perturbations sont :</p></div>\n                <label ng-repeat=\"perturbation in $ctrl.PERTURBATIONS.VALUES\">\n                    <p>\n                    <input class=\"\" type=\"radio\" required name=\"perturbations\" value=\"{{ perturbation }}\" ng-model=\"$ctrl.data.perturbationsValue\">{{ perturbation | labelPerturbations }}\n                    </p>\n                </label>\n              </div>\n            </div>\n          </div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <!--XOR test to submit about the OTHER value-->\n          <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working || !$ctrl.data.isContinue \n          || ($ctrl.data.receivedStation==$ctrl.OTHER_VALUE && (!$ctrl.data.otherSelectedStationName!='' != $ctrl.data.isNoOrientation) )\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Suivant</button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n</section>\n";

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Informations complémentaires</h1>\n  <div ng-if = \"$ctrl.demandeEnquetePapier===true\">\n    <p class=\"informations-dossier\">Dossier n° {{$ctrl.demande.numeroAnfr}} - \n      {{($ctrl.nom | uppercase)}} \n      {{$ctrl.prenom}}</p>\n    <div class=\"dmattnt__content-page formulaire\">\n      <form name=\"form\">\n        <div class=\"form-block\" ng-if=\"$ctrl.typePersonne === 'PART'\">\n          <div class=\"form-block\">\n            <div class=\"dark-grey triangle-before text\">\n              Avez-vous connaissance d’une construction édifiée dans l’axe de votre antenne ?\n              <switch ng-model=\"$ctrl.data.isConstructionKnowledge\" ng-change=\"$ctrl.onChangeIsConstructionKnowledge()\" class=\"small green\"></switch>\n            </div>\n          </div>\n\n          <div ng-if=\"$ctrl.data.isConstructionKnowledge\">\n            <div class=\"form-block\">\n              <div class=\"dark-grey triangle-before label-required text\">\n                Il s'agit d'un(e) :\n              </div>\n              <div class=\"radio-container flex-center\">\n                <label ng-repeat=\"construction in $ctrl.TYPE_CONSTRUCTION.VALUES\">\n                  <p>\n                    <input type=\"radio\" required name=\"constructionType\" value=\"{{ construction }}\" ng-model=\"$ctrl.data.constructionType\">{{ construction | labelConstructions }}\n                  </p>\n                </label>\n              </div>\n            </div>\n            <div class=\"form-block\">\n              <div class=\"dark-grey triangle-before text\">\n                La construction est-elle située à moins de 5 km du domicile ?\n                <switch ng-model=\"$ctrl.data.is5KmAround\" class=\"small green\"></switch>\n              </div>\n            </div>\n\n            <div style=\"margin-bottom:2em\"class=\"form-block\">\n              <div class=\"dark-grey triangle-before label-required text dateClass\">Depuis quand avez-vous constaté la perturbation ? :</div>\n              <datepicker class=\"ng-isolate-scope\" date-format=\"dd/MM/yyyy\" date-week-start-day=\"1\" date-max-limit=\"{{$ctrl.dateMax}}\">\n                <input type=\"text\" class=\"input-text-200\" required name=\"firstPerturbationDate\" ng-model=\"$ctrl.data.firstPerturbationDate\" maxlength=\"20\" \n                  ui-mask-placeholder=\"\" ui-mask-placeholder-char=\"\" placeholder=\"JJ/MM/AAAA\" model-view-value=\"true\"\n                  ui-mask=\"99/99/9999\" ng-change=\"$ctrl.onChangeFirstPertubationDate()\">\n                <div class=\"input-error-messages\" ng-messages=\"form.firstPerturbationDate.$error\" role=\"alert\" ng-show=\"form.firstPerturbationDate.$dirty\">\n                  <div ng-message=\"mask\">Le format de la date n'est pas valide ('JJ/MM/AAAA' attendu).</div>\n                </div>\n                <div class=\"input-error-messages\" role=\"alert\" ng-if=\"!$ctrl.firstPerturbationDateIsvalid\">\n                  <div>La date saisie n'est pas valide.</div>\n                </div>\n              </datepicker>\n            </div>\n\n          </div>\n        </div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Suivant</button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n</section>\n";

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <h1>Informations complémentaires</h1>\n    <div ng-if = \"$ctrl.demandeEnquetePapier===true\">\n        <form name=\"form\">\n            <div class=\"form-block\">\n                <p class=\"informations-dossier\">Dossier n° {{$ctrl.demande.numeroAnfr}} - \n                    {{($ctrl.nom | uppercase)}} \n                    {{$ctrl.prenom}}</p>\n                <p>Pour valider la demande d’enquête, il convient de confirmer que votre installation de réception n’est pas en cause : antenne-râteau placée sous le toit, et/ou pointée sur un émetteur qui n’est plus optimal, câbles défectueux (humidité, rongeurs ou obsolescence), jeu dans des connexions, etc. Ces équipements étant sous votre responsabilité, il vous appartient de faire intervenir un antenniste pour procéder à leur maintenance et écarter tous les effets sur les perturbations rencontrées.\n                </p>\n            </div>\n            <div class=\"dmattnt__content-page formulaire\">\n                <div class=\"form-block\" ng-if=\"$ctrl.typePersonne === 'PART'\">\n                    <div class=\"form-block\">\n                        <div class=\"dark-grey triangle-before label-required text\">\n                            Contrôles à effectuer par vous-même\n                        </div>\n                        <div class=\"content-to-margin\">\n                            <p>Avant les difficultés que vous rencontrez actuellement, diriez-vous que la qualité de votre réception était : \n                                <b>{{$ctrl.handleAnswer($ctrl.demande.prtvInterface3.connexionQuality)}}</b></p>\n                            <p>Souhaitez-vous continuer la demande d'enquête ? :\n                                <b>{{$ctrl.handleAnswer($ctrl.demande.prtvInterface3.isContinue)}}</b></p>\n                            <p>Sur les chaînes n°30 à 39 composées sur la télécommande de votre téléviseur, quelles chaînes locales recevez-vous ? :\n                                <b>{{$ctrl.handleAnswer($ctrl.channels)}}</b></p>\n                            <p>Voici le ou les émetteurs qui couvrent normalement la zone :\n                                <b>{{$ctrl.handleAnswer($ctrl.demande.prtvInterface3.validStation)}}</b></p>\n                            <p>Les perturbations sont :\n                                <b>{{$ctrl.handleAnswer($ctrl.demande.prtvInterface3.perturbationsValue)}}</b></p>\n                        </div>\n                    </div>\n                    <div class=\"form-block\">\n                        <div class=\"dark-grey triangle-before label-required text\">\n                            Informations complémentaires\n                        </div>\n                        <div class=\"content-to-margin\">\n                            <p>Avez-vous connaissance d’une construction édifiée dans l’axe de votre antenne ? :\n                                <b>{{$ctrl.handleAnswer($ctrl.demande.prtvInterface4.isConstructionKnowledge)}}</b></p>\n                            <div ng-show=\"$ctrl.dataPrtv4.isConstructionKnowledge\">\n                                <p>Il s'agit de :\n                                    <b>{{$ctrl.handleAnswerConstruction($ctrl.demande.prtvInterface4.constructionType)}}</b></p>\n                                <p>La construction est-elle située à moins de 5 km du domicile ? :\n                                    <b>{{$ctrl.handleAnswerConstruction($ctrl.demande.prtvInterface4.is5KmAround)}}</b></p>\n                                <p>Depuis quand avez-vous constaté la perturbation ? :\n                                    <b>{{$ctrl.handleAnswerConstruction($ctrl.demande.prtvInterface4.firstPerturbationDate)}}</b></p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <hr>\n                <div class=\"form-block\">\n                    <p>Vous devez valider les informations renseignées. Une fois cette étape réalisée,\n                         vous ne pourrez plus revenir sur la saisie de ses informations.</p>\n                </div>\n                <div class=\"form-actions text buttons-to-flex\">\n                    Validez-vous ces informations ? :\n                    <button type=\"button\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Corriger</button>\n                    <button type=\"button\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Valider</button>\n                </div>\n            </div>\n        </form>\n        \n    </div>\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n</section>";

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <h1>Informations Validées</h1>\n    <div ng-if = \"$ctrl.demandeEnquetePapier===true\">\n        <p class=\"informations-dossier\">Dossier n° {{$ctrl.demande.numeroAnfr}} - \n            {{($ctrl.nom | uppercase)}} \n            {{$ctrl.prenom}}</p>\n        <div class=\"dmattnt__content-page formulaire\">\n            <div>\n                <p>\n                    <p>Votre demande est désormais validée.</p>\n                    <p>Vous pouvez dès à présent choisir et prendre rendez-vous avec un antenniste.\n                    Il devra impérativement vérifier si votre installation de réception n’est pas à l’origine des difficultés que vous rencontrez actuellement.</p>\n                    <p>Veuillez noter que cette prestation est payante et à votre charge.</p>\n                    <p>Si vous disposez de la facture d’une intervention d’antenniste datant de moins d'un an, vous pouvez soumettre votre demande pour \n                    une étude préliminaire, réalisée par l’ANFR, qui tentera de déterminer l’origine des perturbations. Si l’étude n’est pas concluante, \n                    le choix d’un professionnel pour vérifier votre installation pourra vous être demandé.</p>\n                </p>\n            </div>\n            <hr>\n            <div class=\"form-actions\" id=\"Transmettre\" >\n                <button type=\"button\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Transmettre une facture</button>\n            </div>\n        </div>\n    </div>\n    <div class=\"warning-message\" ng-if=\"$ctrl.failure\">Une erreur est survenue. <a ui-sref=\"home\">Retour à l'accueil</a>.</div>\n  </section>\n  ";

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <h1>Bienvenue sur la plateforme d’assistance TNT de l'ANFR</h1>\n  <p>Cette plateforme vous guide dans les démarches à suivre en cas de difficultés de réception de la TNT. Elle vous informe d'éventuels dysfonctionnements de la diffusion dans votre zone.\n  </p>\n  <div class=\"dmattnt__content-page formulaire\" style=\"max-width:600px;\">\n    <form name=\"form\">\n      <div class=\"form-blocks\">\n        <div class=\"form-block\">\n          <div class=\"input-container\">\n            <label for=\"{{$ctrl.prefix}}identifiantInput\" class=\"label-required\">N° de dossier : </label>\n            <input type=\"text\" required name=\"{{$ctrl.prefix}}identifiant\" id=\"{{$ctrl.prefix}}identifiantInput\" ng-model=\"$ctrl.data.identifiant\">\n          </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"input-container\" ng-class=\"{'has-error': form.nom.$dirty && form.nom.$invalid}\">\n            <label for=\"nomInput\" class=\"label-required\">Nom</label>\n            <input type=\"text\" required name=\"nom\" id=\"nomInput\" ng-model=\"$ctrl.data.nom\" class=\"input-text-400\" maxlength=\"100\" ng-pattern=\"$ctrl.regex\">\n            <div class=\"input-error-messages\" ng-messages=\"form.nom.$error\" role=\"alert\" ng-show=\"form.nom.$dirty\">\n              <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n              <div ng-message=\"pattern\">Ce champ ne doit pas contenir de caractères spéciaux.</div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-block\">\n          <div class=\"input-container\" ng-class=\"{'has-error': form.prenom.$dirty && form.prenom.$invalid}\">\n            <label for=\"prenomInput\" class=\"label-required\">Prénom</label>\n            <input type=\"text\" required name=\"prenom\" id=\"prenomInput\" ng-model=\"$ctrl.data.prenom\" class=\"input-text-400\" maxlength=\"100\" ng-pattern=\"$ctrl.regex\">\n            <div class=\"input-error-messages\" ng-messages=\"form.prenom.$error\" role=\"alert\" ng-show=\"form.prenom.$dirty\">\n              <div ng-message=\"required\">Ce champ ne doit pas être laissé vide.</div>\n              <div ng-message=\"pattern\">Ce champ ne doit pas contenir de caractères spéciaux.</div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"submit\" ng-disabled=\"form.$invalid || $ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Valider</button>\n        </div>\n      </div>\n    </form>\n  </div>\n\n</section>";

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <div class=\"dmattnt__content-page formulaire\">\n    <form name=\"form\">\n        <div >\n\t\t  <p ng-if=\"!!$ctrl.dateStatut\"><span>Date de mise à jour : </span><span ng-bind-html=\"$ctrl.dateStatut\"></span></p>\n          <p ng-bind-html=\"$ctrl.commentaire\">\n          </p>\n          <div ng-if=\"!$ctrl.statutFactureTransmise\" class=\"form-block\">\n              <div class=\"center\"><button type=\"button\" class=\"btn btn-download\" ng-click=\"$ctrl.download()\" ng-disabled=\"$ctrl.working || $ctrl.fetching\">Télécharger</button></div>\n          </div>\n        </div>\n      <div>\n        <hr>\n        <div class=\"form-actions\">\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn btn-secondary\" ng-click=\"$ctrl.prevStep()\">Précédent</button>\n          <button type=\"button\" ng-disabled=\"$ctrl.working\" class=\"btn\" ng-click=\"$ctrl.nextStep()\">Retourner à l'accueil</button>\n        </div>\n      </div>\n    </form>\n  </div>\n\n</section>";

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(225);




var AccueilInterface1Component = function AccueilInterface1Component() {
  _classCallCheck(this, AccueilInterface1Component);

  this.controller = AccueilInterface1Controller;
  this.template = __webpack_require__(280);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = AccueilInterface1Component;

var AccueilInterface1Controller = function () {
  function AccueilInterface1Controller($scope, $ngRedux) {
    _classCallCheck(this, AccueilInterface1Controller);

    this.data = {};
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  _createClass(AccueilInterface1Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_1));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.accueilInterface1 ? state.demande.data.accueilInterface1.asMutable({ deep: true }) : _this.data,
          typePersonne: state.demande.data.typePersonne
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.prerequis = { antenne: false, orage: false, logement: false };
      this.disableNext = true;
    }
  }, {
    key: 'onPrerequisChange',
    value: function onPrerequisChange(prerequis) {
      this.disableNext = prerequis.antenne && prerequis.logement && prerequis.orage === true ? false : true;
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateAccueilInterface1(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateAccueilInterface1(this.data));
    }
  }]);

  return AccueilInterface1Controller;
}();

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_multiplex_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date_util__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_includes__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(226);









var AccueilInterface2Component = function AccueilInterface2Component() {
  _classCallCheck(this, AccueilInterface2Component);

  this.controller = AccueilInterface2Controller;
  this.template = __webpack_require__(281);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = AccueilInterface2Component;

var AccueilInterface2Controller = function () {
  function AccueilInterface2Controller($scope, $ngRedux) {
    _classCallCheck(this, AccueilInterface2Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    // Valeurs par défaut
    this.dateMax = new Date().toString();
    this.data = { multiplex: [] };
    this.adresse = {};
    this.datePerturbationIsvalid = true;
    this.multiplexCode = {};
    this.muxExclus = ['R15', 'ROM1', 'ROML', 'ROM2'];
    this.muxExclusAntenniste = ['ROM1', 'ROML', 'ROM2'];
  }

  _createClass(AccueilInterface2Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_2__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_2));
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_multiplex_actions__["d" /* default */].loadData());

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          multiplexFailure: state.multiplex.failure,
          fetching: state.demande.fetching || state.multiplex.fetching,
          data: _this.prepareAfterGet(state.demande.data.accueilInterface2 ? state.demande.data.accueilInterface2.asMutable({ deep: true }) : _this.data),
          multiplex: state.multiplex.data ? state.multiplex.data.data : state.multiplex.data,
          multiplexAll: state.multiplex.data ? state.multiplex.data.data : state.multiplex.data,
          typePersonne: state.demande.data.typePersonne,
          adresse: _this.data.adresse
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'onComplementAdresseChange',
    value: function onComplementAdresseChange(complementAdresse) {
      this.data.complementAdresse = complementAdresse;
    }
  }, {
    key: 'onAdresseChange',
    value: function onAdresseChange(adresse) {
      this.data.adresse = adresse;
    }
  }, {
    key: 'onDatePerturbationChange',
    value: function onDatePerturbationChange() {
      this.datePerturbationIsvalid = __WEBPACK_IMPORTED_MODULE_3__utils_date_util__["a" /* default */].validate(this.data.datePerturbation);
    }
  }, {
    key: 'prepareAfterGet',
    value: function prepareAfterGet(data) {
      var res = __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(data);
      if (res.datePerturbation) {
        res.datePerturbation = __WEBPACK_IMPORTED_MODULE_3__utils_date_util__["a" /* default */].dateToMask(res.datePerturbation);
      }
      return res;
    }
  }, {
    key: 'prepareBeforeSend',
    value: function prepareBeforeSend(data) {
      var _this2 = this;

      var res = __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(data);
      if (res.datePerturbation) {
        res.datePerturbation = __WEBPACK_IMPORTED_MODULE_3__utils_date_util__["a" /* default */].dateFromMask(res.datePerturbation);
      }
      // On passe les multiplex pour les traitements à réaliser pour passer à l'étape suivante
      //on exclue les multiplex de domtom
      this.multiplex = __WEBPACK_IMPORTED_MODULE_5_lodash_filter___default()(this.multiplex, function (m) {
        return !__WEBPACK_IMPORTED_MODULE_6_lodash_includes___default()(_this2.typePersonne === 'PRO' ? _this2.muxExclusAntenniste : _this2.muxExclus, m.code);
      });
      res.multiplex = this.multiplex;
      res.multiplexAll = this.multiplexAll;
      return res;
    }
    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["d" /* default */].updateAccueilInterface2({}, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["d" /* default */].updateAccueilInterface2(this.prepareBeforeSend(this.data)));
    }
  }]);

  return AccueilInterface2Controller;
}();

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_cloneDeep__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_cloneDeep__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(227);





var AccueilInterface3Component = function AccueilInterface3Component() {
  _classCallCheck(this, AccueilInterface3Component);

  this.controller = AccueilInterface3Controller;
  this.template = __webpack_require__(282);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = AccueilInterface3Component;

var AccueilInterface3Controller = function () {
  function AccueilInterface3Controller($scope, $ngRedux) {
    _classCallCheck(this, AccueilInterface3Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  _createClass(AccueilInterface3Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_3));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: _this.prepareAfterGet(state.demande.data.accueilInterface2 ? state.demande.data.accueilInterface2.asMutable({ deep: true }) : _this.data)
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'prepareAfterGet',
    value: function prepareAfterGet(data) {
      var res = __WEBPACK_IMPORTED_MODULE_2_lodash_cloneDeep___default()(data);
      return res;
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateAccueilInterface3(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateAccueilInterface3(this.data));
    }
  }]);

  return AccueilInterface3Controller;
}();

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(228);




var AntenneAccessibleComponent = function AntenneAccessibleComponent() {
  _classCallCheck(this, AntenneAccessibleComponent);

  this.controller = AntenneAccessibleController;
  this.template = __webpack_require__(283);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = AntenneAccessibleComponent;

var AntenneAccessibleController = function () {
  function AntenneAccessibleController($scope, $ngRedux) {
    _classCallCheck(this, AntenneAccessibleController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(AntenneAccessibleController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].ANTENNE_ACCESSIBLE));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.antenneAccessible ? state.demande.data.antenneAccessible.asMutable({ deep: true }) : _this.data
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateAntenneAccessible(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep(source) {
      this.data.source = source;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateAntenneAccessible(this.data));
    }
  }]);

  return AntenneAccessibleController;
}();

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(229);




var AucunIncidentDetecteComponent = function AucunIncidentDetecteComponent() {
  _classCallCheck(this, AucunIncidentDetecteComponent);

  this.controller = AucunIncidentDetecteController;
  this.template = __webpack_require__(284);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = AucunIncidentDetecteComponent;

var AucunIncidentDetecteController = function () {
  function AucunIncidentDetecteController($scope, $ngRedux) {
    _classCallCheck(this, AucunIncidentDetecteController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  _createClass(AucunIncidentDetecteController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].AUCUN_INCIDENT_DETECTE));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.aucunIncidentDetecte ? state.demande.data.aucunIncidentDetecte.asMutable({ deep: true }) : _this.data
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateAucunIncidentDetecte(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep(continuerPrtv) {
      this.data.continuerPrtv = continuerPrtv;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateAucunIncidentDetecte(this.data));
    }
  }]);

  return AucunIncidentDetecteController;
}();

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(230);




var ConclusionComponent = function ConclusionComponent() {
  _classCallCheck(this, ConclusionComponent);

  this.controller = ConclusionController;
  this.template = __webpack_require__(285);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = ConclusionComponent;

var ConclusionController = function () {
  function ConclusionController($scope, $ngRedux) {
    _classCallCheck(this, ConclusionController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(ConclusionController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].CONCLUSION));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.conclusion ? state.demande.data.conclusion.asMutable({ deep: true }) : _this.data,
          typePersonne: state.demande.data.typePersonne,
          termine: state.demande.data.reamenagement ? state.demande.data.reamenagement.source : null
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateConclusion(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateConclusion(this.data));
    }
  }]);

  return ConclusionController;
}();

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_model__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(231);





var DysfonctionnementInterfaceComponent = function DysfonctionnementInterfaceComponent() {
  _classCallCheck(this, DysfonctionnementInterfaceComponent);

  this.controller = DysfonctionnementInterfaceController;
  this.template = __webpack_require__(286);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = DysfonctionnementInterfaceComponent;

var DysfonctionnementInterfaceController = function () {
  function DysfonctionnementInterfaceController($scope, $ngRedux) {
    _classCallCheck(this, DysfonctionnementInterfaceController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.PERMANENT_ALEATOIRE = __WEBPACK_IMPORTED_MODULE_2__common_model__["a" /* PERMANENT_ALEATOIRE */];
    this.data = {
      natureDysfonctionnement: ''
    };
  }

  _createClass(DysfonctionnementInterfaceController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].DYSFONCTIONNEMENT_INTERFACE));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.dysfonctionnementInterface ? state.demande.data.dysfonctionnementInterface.asMutable({ deep: true }) : _this.data
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateDysfonctionnementInterface(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateDysfonctionnementInterface(this.data));
    }
  }]);

  return DysfonctionnementInterfaceController;
}();

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(232);




var EtatChainesComponent = function EtatChainesComponent() {
  _classCallCheck(this, EtatChainesComponent);

  this.controller = EtatChainesController;
  this.template = __webpack_require__(287);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = EtatChainesComponent;

var EtatChainesController = function () {
  function EtatChainesController($scope, $ngRedux) {
    _classCallCheck(this, EtatChainesController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(EtatChainesController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].ETAT_CHAINES));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.etatChaines ? state.demande.data.etatChaines.asMutable({ deep: true }) : _this.data,
          typePersonne: state.demande.data.typePersonne
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateEtatChaines({}, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep(source) {
      this.data.source = source;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateEtatChaines(this.data));
    }
  }]);

  return EtatChainesController;
}();

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(233);




var FinAccueilComponent = function FinAccueilComponent() {
  _classCallCheck(this, FinAccueilComponent);

  this.controller = FinAccueilController;
  this.template = __webpack_require__(288);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = FinAccueilComponent;

var FinAccueilController = function () {
  function FinAccueilController($scope, $ngRedux) {
    _classCallCheck(this, FinAccueilController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(FinAccueilController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].FIN_ACCUEIL));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.finAccueil ? state.demande.data.finAccueil.asMutable({ deep: true }) : _this.data,
          typePersonne: state.demande.data.typePersonne,
          fin: state.demande.data.antenneAccessible ? !state.demande.data.antenneAccessible.source : null
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateFinAccueil(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateFinAccueil(this.data));
    }
  }]);

  return FinAccueilController;
}();

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(234);




var IncidentDetecteComponent = function IncidentDetecteComponent() {
  _classCallCheck(this, IncidentDetecteComponent);

  this.controller = IncidentDetecteController;
  this.template = __webpack_require__(289);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = IncidentDetecteComponent;

var IncidentDetecteController = function () {
  function IncidentDetecteController($scope, $ngRedux) {
    _classCallCheck(this, IncidentDetecteController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  _createClass(IncidentDetecteController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].INCIDENT_DETECTE));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.incidentDetecte ? state.demande.data.incidentDetecte.asMutable({ deep: true }) : _this.data
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateIncidentDetecte(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep(continuerPrtv) {
      //On vérifie si on cotinue en prtv ou pas
      this.data.continuerPrtv = continuerPrtv;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateIncidentDetecte(this.data));
    }
  }]);

  return IncidentDetecteController;
}();

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(235);




var InterventionAntennisteComponent = function InterventionAntennisteComponent() {
  _classCallCheck(this, InterventionAntennisteComponent);

  this.controller = InterventionAntennisteController;
  this.template = __webpack_require__(290);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = InterventionAntennisteComponent;

var InterventionAntennisteController = function () {
  function InterventionAntennisteController($scope, $ngRedux) {
    _classCallCheck(this, InterventionAntennisteController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(InterventionAntennisteController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].INTERVENTION_ANTENNISTE));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.interventionAntenniste ? state.demande.data.interventionAntenniste.asMutable({ deep: true }) : _this.data
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateInterventionAntenniste(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep(source) {
      this.data.source = source;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateInterventionAntenniste(this.data));
    }
  }]);

  return InterventionAntennisteController;
}();

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_indexOf__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_indexOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_indexOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(236);





var ReamenagementComponent = function ReamenagementComponent() {
  _classCallCheck(this, ReamenagementComponent);

  this.controller = ReamenagementController;
  this.template = __webpack_require__(291);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = ReamenagementComponent;

var ReamenagementController = function () {
  function ReamenagementController($scope, $ngRedux) {
    _classCallCheck(this, ReamenagementController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(ReamenagementController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_2__utils_routes_util__["c" /* STEPS */].Reamenagement));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.reamenagement ? state.demande.data.reamenagement.asMutable({ deep: true }) : _this.data,
          typePersonne: state.demande.data.typePersonne
        };
      })(this);

      // Déconnexion du state à la suppression du Reamenagement
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["d" /* default */].updateReamenagement({}, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep(source) {
      this.data.source = source;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["d" /* default */].updateReamenagement(this.data));
    }
  }, {
    key: 'clickPhase',
    value: function clickPhase(index) {
      var phase = angular.element(document.getElementsByName('phase-' + index));
      if (__WEBPACK_IMPORTED_MODULE_0_lodash_indexOf___default()(phase[0].classList, 'open') === -1) {
        phase.addClass('open');
      } else {
        phase.removeClass('open');
      }
    }
  }]);

  return ReamenagementController;
}();

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_model__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(237);





var SignalementAntennisteComponent = function SignalementAntennisteComponent() {
  _classCallCheck(this, SignalementAntennisteComponent);

  this.controller = SignalementAntennisteController;
  this.template = __webpack_require__(292);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = SignalementAntennisteComponent;

var SignalementAntennisteController = function () {
  function SignalementAntennisteController($scope, $ngRedux) {
    _classCallCheck(this, SignalementAntennisteController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.NATURE_PERTURBATION = __WEBPACK_IMPORTED_MODULE_2__common_model__["b" /* NATURE_PERTURBATION */];
    this.data = {
      natureProbleme: ''
    };
  }

  _createClass(SignalementAntennisteController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].SIGNALEMENT_ANTENNISTE));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.signalementAntenniste ? state.demande.data.signalementAntenniste.asMutable({ deep: true }) : _this.data
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateSignalementAntenniste(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateSignalementAntenniste(this.data));
    }
  }]);

  return SignalementAntennisteController;
}();

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(61);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RECEPTION */].ANTENNE_RATEAU:
        return 'Antenne râteau';
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RECEPTION */].ANTENNE_INTERIEURE:
        return 'Antenne intérieure';
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RECEPTION */].ADSL_FIBRE:
        return 'ADSL/Fibre';
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RECEPTION */].PARABOLE:
        return 'Parabole satellite';
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RECEPTION */].CABLE:
        return 'Câble';
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RECEPTION */].AUTRE:
        return 'Autre';
      default:
        return '';
    }
  };
}

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(61);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* RAISON_DEMANDE */].DEFAUT_RECEPTION:
        return 'Défaut de réception de la TNT';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* RAISON_DEMANDE */].DEMANDE_AIDE:
        return 'Demande d\'aide à la réception ou demande de remboursement de travaux éligibles sur facture';
      default:
        return '';
    }
  };
}

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(61);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* TYPE_PERSONNE */].PARTICULIER:
        return 'Particulier';
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION:
        return 'Professionnel de la réception';
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* TYPE_PERSONNE */].SYNDIC_BAILLEUR:
        return 'Syndic ou bailleur';
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* TYPE_PERSONNE */].ELU:
        return 'Élu';
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* TYPE_PERSONNE */].JOURNALISTE:
        return 'Journaliste';
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* TYPE_PERSONNE */].AUTRE:
        return 'Autre';
      default:
        return '';
    }
  };
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_routes_util__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_1, {
    url: '/accueil-interface-1',
    template: '<dmattnt-accueil-interface-1></dmattnt-accueil-interface-1>',
    //on a joute un label pour afficher dans le fil d'ariane
    data: { label: 'Pré-requis' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_2, {
    url: '/accueil-interface-2',
    template: '<dmattnt-accueil-interface-2></dmattnt-accueil-interface-2>',
    data: { label: 'Adresse impactée' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].ACCUEIL_INTERFACE_3, {
    url: '/accueil-interface-3',
    template: '<dmattnt-accueil-interface-3></dmattnt-accueil-interface-3>',
    data: { label: 'Adresse non confirmée' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].ETAT_CHAINES, {
    url: '/etat-chaines',
    template: '<dmattnt-etat-chaines></dmattnt-etat-chaines>',
    data: { label: 'Etat des chaînes' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].REAMENAGEMENT, {
    url: '/reamenagement',
    template: '<dmattnt-reamenagement></dmattnt-reamenagement>',
    data: { label: 'Changement de fréquences' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].ANTENNE_ACCESSIBLE, {
    url: '/antenne-accessible',
    template: '<dmattnt-antenne-accessible></dmattnt-antenne-accessible>',
    data: { label: 'Antenne accessible' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].FIN_ACCUEIL, {
    url: '/fin-accueil',
    template: '<dmattnt-fin-accueil></dmattnt-fin-accueil>',
    data: { label: 'Conclusion accueil' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].INTERVENTION_ANTENNISTE, {
    url: '/intervention-antenniste',
    template: '<dmattnt-intervention-antenniste></dmattnt-intervention-antenniste>',
    data: { label: 'Intervention antenniste' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].SIGNALEMENT_ANTENNISTE, {
    url: '/signalement-antenniste',
    template: '<dmattnt-signalement-antenniste></dmattnt-signalement-antenniste>',
    data: { label: 'Signalement antenniste' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].INCIDENT_DETECTE, {
    url: '/incident-detecte',
    template: '<dmattnt-incident-detecte></dmattnt-incident-detecte>',
    data: { label: 'Incident détecté' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].AUCUN_INCIDENT_DETECTE, {
    url: '/aucun-incident-detecte',
    template: '<dmattnt-aucun-incident-detecte></dmattnt-aucun-incident-detecte>',
    data: { label: 'Aucun incident détecté' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].DYSFONCTIONNEMENT_INTERFACE, {
    url: '/dysfonctionnement-interface',
    template: '<dmattnt-dysfonctionnement-interface></dmattnt-dysfonctionnement-interface>',
    data: { label: 'Type du Dysfonctionnement' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].CONCLUSION, {
    url: '/conclusion',
    template: '<dmattnt-conclusion></dmattnt-conclusion>',
    data: { label: 'À bientôt' }
  });
}

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_multiplex_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_type_defaut_actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_model__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_filter__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_some__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(239);












var ConstatComponent = function ConstatComponent() {
  _classCallCheck(this, ConstatComponent);

  this.controller = ConstatController;
  this.template = __webpack_require__(293);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = ConstatComponent;

var ConstatController = function () {
  function ConstatController($scope, $ngRedux) {
    _classCallCheck(this, ConstatController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.OUI_NON = __WEBPACK_IMPORTED_MODULE_3__common_model__["d" /* OUI_NON */];
    this.TYPE_PROBLEME = __WEBPACK_IMPORTED_MODULE_3__common_model__["j" /* TYPE_PROBLEME */];
    // Valeurs par défaut
    this.data = { multiplex: [], typePerturbation: [], typeDefaut: [] };
    this.multiplexCode = {};
  }

  _createClass(ConstatController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_4__utils_routes_util__["c" /* STEPS */].CONSTAT));
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_1__actions_multiplex_actions__["d" /* default */].loadData());
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_type_defaut_actions__["d" /* default */].loadData());

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          multiplexFailure: state.multiplex.failure,
          typeDefautFailre: state.typeDefaut.failure,
          fetching: state.demande.fetching || state.multiplex.fetching || state.typeDefaut.fetching,
          data: state.demande.data.constat ? state.demande.data.constat.asMutable({ deep: true }) : _this.data,
          multiplex: state.demande.data.accueilInterface2 ? state.demande.data.accueilInterface2.multiplex : state.multiplex.data,
          typeDefaut: state.typeDefaut.data

        };
      })(function (selectedState) {
        __WEBPACK_IMPORTED_MODULE_5_lodash_assign___default()(_this, selectedState);
        _this.handleMultiplexLoaded();
      });
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'onEmetteurtntChange',
    value: function onEmetteurtntChange(emetteurtnt) {
      this.data.emetteurtnt = emetteurtnt;
    }
  }, {
    key: 'onTypeDefautChange',
    value: function onTypeDefautChange(typeDefaut) {
      this.data.typeDefaut = typeDefaut;
    }
  }, {
    key: 'onTypePerturbationChange',
    value: function onTypePerturbationChange(typePerturbation) {
      this.data.typePerturbation = typePerturbation;
    }
  }, {
    key: 'handleMultiplexLoaded',
    value: function handleMultiplexLoaded() {
      var _this2 = this;

      if (this.fetching) {
        return;
      }
      if (!this.multiplex.length) {
        return;
      }
      this.data.multiplex = __WEBPACK_IMPORTED_MODULE_6_lodash_filter___default()(this.data.multiplex, function (multiplex) {
        return __WEBPACK_IMPORTED_MODULE_8_lodash_some___default()(_this2.multiplex, function (m) {
          return m.id === multiplex.id;
        });
      });
      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(this.data.multiplex, function (multiplex) {
        _this2.multiplexCode[multiplex.id] = true;
      });
    }
  }, {
    key: 'onChangeSelected',
    value: function onChangeSelected(multiplex) {
      if (this.multiplexCode[multiplex.id]) {
        // Sélection du multiplex
        this.data.multiplex.push(multiplex);
      } else {
        // Déselection du multiplex
        this.data.multiplex = __WEBPACK_IMPORTED_MODULE_6_lodash_filter___default()(this.data.multiplex, function (m) {
          return m.id !== multiplex.id;
        });
      }
    }
  }, {
    key: 'prepareBeforeSend',
    value: function prepareBeforeSend(data) {
      var res = __WEBPACK_IMPORTED_MODULE_9_lodash_cloneDeep___default()(data);
      res.typeDefaut = this.typeDefaut;
      return res;
    }
    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateConstat(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {

      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateConstat(this.prepareBeforeSend(this.data)));
    }
  }]);

  return ConstatController;
}();

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_model__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pattern_util__ = __webpack_require__(62);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(240);







var ContactComponent = function ContactComponent() {
  _classCallCheck(this, ContactComponent);

  this.controller = ContactController;
  this.template = __webpack_require__(294);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = ContactComponent;

var ContactController = function () {
  function ContactController($scope, $ngRedux) {
    _classCallCheck(this, ContactController);

    this.CIVILITE = __WEBPACK_IMPORTED_MODULE_1__base_model__["a" /* CIVILITE */];
    this.regex = new RegExp(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/, 'u');
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.emailPattern = __WEBPACK_IMPORTED_MODULE_3__utils_pattern_util__["a" /* EMAIL_PATTERN */];
    this.telephonePattern = __WEBPACK_IMPORTED_MODULE_3__utils_pattern_util__["b" /* TELEPHONE_PATTERN */];
  }

  _createClass(ContactController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_2__utils_routes_util__["c" /* STEPS */].CONTACT));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.contact ? state.demande.data.contact.asMutable({ deep: true }) : _this.data,
          messagePerturbation: state.demande.data.zonePerturbe ? state.demande.data.zonePerturbe.message : null
        };
      })(this);
      this.data = { civilite: __WEBPACK_IMPORTED_MODULE_1__base_model__["a" /* CIVILITE */].DEFAULT_VALUE };
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'onComplementAdresseChange',
    value: function onComplementAdresseChange(complementAdresse) {
      this.data.complementAdresse = complementAdresse;
    }
  }, {
    key: 'onAdresseChange',
    value: function onAdresseChange(adresse) {
      this.data.adresse = adresse;
    }
    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateContact(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateContact(this.data));
    }
  }]);

  return ContactController;
}();

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(241);




var FinAntennisteComponent = function FinAntennisteComponent() {
  _classCallCheck(this, FinAntennisteComponent);

  this.controller = FinAntennisteController;
  this.template = __webpack_require__(295);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = FinAntennisteComponent;

var FinAntennisteController = function () {
  function FinAntennisteController($scope, $ngRedux) {
    _classCallCheck(this, FinAntennisteController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(FinAntennisteController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].FINANTENNISTE));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.finAntenniste ? state.demande.data.finAntenniste.asMutable({ deep: true }) : _this.data,
          numeroAnfr: state.demande.data.numeroAnfr
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateFinAntenniste(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateFinAntenniste(this.data));
    }
  }]);

  return FinAntennisteController;
}();

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(242);




var ZonePerturbeComponent = function ZonePerturbeComponent() {
  _classCallCheck(this, ZonePerturbeComponent);

  this.controller = ZonePerturbeController;
  this.template = __webpack_require__(296);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = ZonePerturbeComponent;

var ZonePerturbeController = function () {
  function ZonePerturbeController($scope, $ngRedux) {
    _classCallCheck(this, ZonePerturbeController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  _createClass(ZonePerturbeController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].ZONE_PERTURBE));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.zonePerturbe ? state.demande.data.zonePerturbe.asMutable({ deep: true }) : _this.data
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateZonePerturbe(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep(source) {
      this.data.source = source;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateZonePerturbe(this.data));
    }
  }]);

  return ZonePerturbeController;
}();

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_routes_util__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].ZONE_PERTURBE, {
    url: '/zone-perturbe',
    template: '<dmattnt-zone-perturbe></dmattnt-zone-perturbe>',
    data: { label: 'Incident détecté' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].CONTACT, {
    url: '/contact',
    template: '<dmattnt-contact></dmattnt-contact>',
    data: { label: 'Contact' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].CONSTAT, {
    url: '/constat',
    template: '<dmattnt-constat></dmattnt-constat>',
    data: { label: 'Constat' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].FIN_ANTENNISTE, {
    url: '/fin-antenniste',
    template: '<dmattnt-fin-antenniste></dmattnt-fin-anteniste>',
    data: { label: 'À bientôt' }
  });
}

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(244);

var FooterComponent = function FooterComponent() {
  _classCallCheck(this, FooterComponent);

  this.controller = FooterController;
  this.template = __webpack_require__(297);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = FooterComponent;

var FooterController = function FooterController() {
  _classCallCheck(this, FooterController);
};

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HeaderComponent;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(245);

function HeaderComponent() {
  return {
    controller: HeaderController,
    template: __webpack_require__(298)
  };
}

// @ngInject

var HeaderController = function () {
  function HeaderController($ngRedux, $scope) {
    _classCallCheck(this, HeaderController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  _createClass(HeaderController, [{
    key: '$onInit',
    value: function $onInit() {
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working
        };
      })(this); // Permet d'avoir les propriétés de l'objet retourné dans this (ici working)

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }]);

  return HeaderController;
}();

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(246);





var HomeComponent = function HomeComponent() {
  _classCallCheck(this, HomeComponent);

  this.controller = HomeController;
  this.template = __webpack_require__(299);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = HomeComponent;

var HomeController = function () {
  function HomeController($scope, $ngRedux) {
    _classCallCheck(this, HomeController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
    this.saisieReclamation = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_2__utils_routes_util__["e" /* FROM_RECLAMATION */]);
  }

  _createClass(HomeController, [{
    key: '$onInit',
    value: function $onInit() {
      // Connexion au state récupérer les données modifiées
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].reset());
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          demande: state.demande.data
        };
      })(this);
      //Au premier chargement on nettoie le localstorage pour afficher  la page "Vous souhaitez :"
      window.localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_2__utils_routes_util__["e" /* FROM_RECLAMATION */]);
      // En cas de redirection de l'appli antenniste
      if (window.location.href.endsWith('antenniste=true')) {
        this.saisieReclamation = true;
        this.startDemande('PRO');
      }
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Action

  }, {
    key: 'saisirReclamation',
    value: function saisirReclamation() {
      this.saisieReclamation = true;
    }
  }, {
    key: 'suivreDossier',
    value: function suivreDossier() {
      this.data.suivieAuthent = true;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].startSuivieDossier(this.data));
    }
  }, {
    key: 'startDemande',
    value: function startDemande(type) {
      if (type === __WEBPACK_IMPORTED_MODULE_1__model__["b" /* TYPE_PERSONNE */].PARTICULIER) {
        this.data.typePersonne = __WEBPACK_IMPORTED_MODULE_1__model__["b" /* TYPE_PERSONNE */].PARTICULIER;
      } else if (type === __WEBPACK_IMPORTED_MODULE_1__model__["b" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION) {
        this.data.typePersonne = __WEBPACK_IMPORTED_MODULE_1__model__["b" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION;
      } else {
        this.data.typePersonne = __WEBPACK_IMPORTED_MODULE_1__model__["b" /* TYPE_PERSONNE */].SYNDIC_BAILLEUR;
      }
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].startNewDemande(this.data));
    }
  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.saisieReclamation = false;
    }
  }]);

  return HomeController;
}();

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MentionsLegalesComponent;
__webpack_require__(247);

function MentionsLegalesComponent() {
  return {
    controller: MentionsLegalesController,
    controllerAs: 'ctrl',
    template: __webpack_require__(300)
  };
}

function MentionsLegalesController() {
  var ctrl = this;
  ctrl.domain = window.location.hostname;
  window.scroll(0, 0);
}

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = MenuComponent;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








__webpack_require__(248);

function MenuComponent() {
  return {
    controller: MenuController,
    template: __webpack_require__(301)
  };
}

// @ngInject

var MenuController = function () {
  function MenuController($scope, $ngRedux, $state) {
    _classCallCheck(this, MenuController);

    this.$scope = $scope;
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.steps = [];
  }

  _createClass(MenuController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          demande: state.demande.data
        };
      })(function (selectedState) {
        __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default()(_this, selectedState);
        _this.steps = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["f" /* allPrevSteps */])(_this.demande, _this.$state.current.name).reverse(), function (s) {
          if (s !== 'home') {
            return _this.$state.get(s);
          }
          var res = _this.$state.get(s);
          res.data.label = _this.computeHomeLabel(_this.demande.typePersonne);
          return res;
        });
        _this.onlyHome = _this.steps.length <= 1;
      });
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'computeHomeLabel',
    value: function computeHomeLabel(typePersonne) {
      switch (typePersonne) {
        case __WEBPACK_IMPORTED_MODULE_2__model__["b" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION:
          return 'Antenniste';
        case __WEBPACK_IMPORTED_MODULE_2__model__["b" /* TYPE_PERSONNE */].SYNDIC_BAILLEUR:
          return 'Syndic ou bailleur';
        case __WEBPACK_IMPORTED_MODULE_2__model__["b" /* TYPE_PERSONNE */].PARTICULIER:
          return 'Particulier';
        default:
          return 'Accueil';
      }
    }
  }]);

  return MenuController;
}();

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(17);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* TYPE_PERSONNE */].PARTICULIER:
        return 'Particulier';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* TYPE_PERSONNE */].PROFESSIONNEL_RECEPTION:
        return 'Professionnel de la réception';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* TYPE_PERSONNE */].SYNDIC_BAILLEUR:
        return 'Syndic ou bailleur';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* TYPE_PERSONNE */].ELU:
        return 'Élu';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* TYPE_PERSONNE */].JOURNALISTE:
        return 'Journaliste';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* TYPE_PERSONNE */].AUTRE:
        return 'Autre';
      default:
        return '';
    }
  };
}

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state('home', {
    url: '/',
    template: '<dmattnt-home></dmattnt-home>',
    data: { label: 'Accueil' }
  }).state('mentions_legales', {
    url: '/mentions-legales',
    template: '<dmattnt-mentions-legales></dmattnt-mentions-legales>'
  });
}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_commune_repository__ = __webpack_require__(552);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



__webpack_require__(250);

var AdresseComponent = function AdresseComponent() {
  _classCallCheck(this, AdresseComponent);

  this.controller = AdresseController;
  this.template = __webpack_require__(302);
  this.bindings = {
    prefix: '@',
    adresse: '<',
    parentForm: '<',
    onAdresseChange: '&'
  };
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = AdresseComponent;

var AdresseController = function () {
  function AdresseController() {
    _classCallCheck(this, AdresseController);

    this.communes = {
      loading: false,
      data: []
    };
    this.communecps = {
      loading: false,
      data: []
    };
  }

  _createClass(AdresseController, [{
    key: '$onInit',
    value: function $onInit() {
      this.prefix = this.prefix ? this.prefix : '';
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      if (changes.adresse) {
        this.data = this.adresse ? this.adresse : { commune: null, codePostal: null };
        if (this.data.commune) {
          this.communes.data = [this.data.commune];
        }
      }
    }
  }, {
    key: 'refreshCommunes',
    value: function refreshCommunes(search) {
      var _this = this;

      if (!search) {
        return;
      }
      this.communes.loading = true;
      return __WEBPACK_IMPORTED_MODULE_0__repositories_commune_repository__["a" /* default */].searchCommune(search).then(function (response) {
        _this.communes.data = [];
        var communes = response.data;
        for (var i = 0; i < communes.length; i++) {
          var commune = communes[i];
          _this.communes.data.push({ codepostal: commune.codePostals[0] ? commune.codePostals[0].code : '',
            nom: commune.nom, numeroDep: commune.numeroDep, insee: commune.insee,
            id: commune.id, codePostals: commune.codePostals });
        }
      }).finally(function () {
        return _this.communes.loading = false;
      });
    }
  }, {
    key: 'refreshCps',
    value: function refreshCps(search) {
      var _this2 = this;

      if (!search) {
        return;
      }
      this.communecps.loading = true;
      return __WEBPACK_IMPORTED_MODULE_0__repositories_commune_repository__["a" /* default */].searchCodePostal(search).then(function (response) {
        _this2.communecps.data = [];
        var communes = response.data;
        for (var i = 0; i < communes.length; i++) {
          _this2.communecps.data.push({ codepostal: search, nom: communes[i].nom, numeroDep: communes[i].numeroDep, insee: communes[i].insee,
            id: communes[i].id, codePostals: communes[i].codePostals });
        }
      }).finally(function () {
        return _this2.communecps.loading = false;
      });
    }
  }, {
    key: 'onCodePostalSelect',
    value: function onCodePostalSelect($item) {
      if ($item) {
        this.communes.data = [];
        this.communes.data.push($item);
        this.data.commune = $item;
      } else {
        this.data.codePostal = null;
      }
      this.onChange();
    }
  }, {
    key: 'onCommuneSelect',
    value: function onCommuneSelect($item) {
      if ($item) {
        this.communecps.data = [];
        for (var i = 0; i < $item.codePostals.length; i++) {
          this.communecps.data.push({ codepostal: $item.codePostals[i].code, nom: $item.nom, numeroDep: $item.numeroDep, insee: $item.insee,
            id: $item.id, codePostals: $item.codePostals });
        }
        this.data.codePostal = $item;
      } else {
        this.data.codePostal = null;
      }
      this.onChange();
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      this.onAdresseChange({ adresse: this.data });
    }
  }]);

  return AdresseController;
}();

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(251);

var ComplementAdresseComponent = function ComplementAdresseComponent() {
  _classCallCheck(this, ComplementAdresseComponent);

  this.controller = ComplementAdresseController;
  this.template = __webpack_require__(303);
  this.bindings = {
    prefix: '@',
    complementAdresse: '<',
    parentForm: '<',
    onComplementAdresseChange: '&'
  };
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = ComplementAdresseComponent;

var ComplementAdresseController = function () {
  function ComplementAdresseController() {
    _classCallCheck(this, ComplementAdresseController);
  }

  _createClass(ComplementAdresseController, [{
    key: '$onInit',
    value: function $onInit() {
      this.communes = {
        loading: false,
        data: []
      };
      this.prefix = this.prefix ? this.prefix : '';
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      if (changes.complementAdresse) {
        this.data = this.complementAdresse ? this.complementAdresse : {};
      }
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      this.onComplementAdresseChange({ complementAdresse: this.data });
    }
  }]);

  return ComplementAdresseController;
}();

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_emetteurtnt_repository__ = __webpack_require__(165);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



__webpack_require__(252);

var EmetteurtntComponent = function EmetteurtntComponent() {
  _classCallCheck(this, EmetteurtntComponent);

  this.controller = EmetteurtntController;
  this.template = __webpack_require__(304);
  this.bindings = {
    prefix: '@',
    emetteurtnt: '<',
    parentForm: '<',
    onEmetteurtntChange: '&'
  };
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = EmetteurtntComponent;

var EmetteurtntController = function () {
  function EmetteurtntController() {
    _classCallCheck(this, EmetteurtntController);

    this.emetteurtnts = {
      loading: false,
      data: []
    };
  }

  _createClass(EmetteurtntController, [{
    key: '$onInit',
    value: function $onInit() {
      this.prefix = this.prefix ? this.prefix : '';
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      if (changes.emetteurtnt) {
        this.data = this.emetteurtnt ? this.emetteurtnt : { emetteurtnt: null };
        if (this.data.emetteurtnt) {
          this.emetteurtnts.data = [this.data.emetteurtnt];
        }
      }
    }
  }, {
    key: 'refreshEmetteurtnts',
    value: function refreshEmetteurtnts(search) {
      var _this = this;

      if (!search) {
        return;
      }
      this.emetteurtnts.loading = true;

      return __WEBPACK_IMPORTED_MODULE_0__repositories_emetteurtnt_repository__["a" /* default */].searchEmetteurtnt(search).then(function (response) {
        _this.emetteurtnts.data = response.data;
      }).finally(function () {
        return _this.emetteurtnts.loading = false;
      });
    }
  }, {
    key: 'onEmetteurtntSelect',
    value: function onEmetteurtntSelect($item) {
      if ($item) {
        this.emetteurtnts.data = [this.data.emetteurtnt];
      } else {
        this.emetteurtnts.data = [];
        this.data.emetteurtnt = null;
      }
      this.onChange();
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      this.onEmetteurtntChange({ emetteurtnt: this.data });
    }
  }]);

  return EmetteurtntController;
}();

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(253);

var PrerequisConclusionComponent = function PrerequisConclusionComponent() {
  _classCallCheck(this, PrerequisConclusionComponent);

  this.controller = PrerequisConclusionController;
  this.template = __webpack_require__(305);
  this.bindings = {
    prefix: '@',
    initialData: '<',
    onPrerequisChange: '&',
    typePersonne: '<'
  };
};

/* harmony default export */ __webpack_exports__["a"] = PrerequisConclusionComponent;

var PrerequisConclusionController = function () {
  function PrerequisConclusionController() {
    _classCallCheck(this, PrerequisConclusionController);
  }

  _createClass(PrerequisConclusionController, [{
    key: '$onInit',
    value: function $onInit() {
      this.data = this.initialData || {};
      this.prefix = this.prefix ? this.prefix : '';
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      this.onPrerequisChange({ prerequis: this.data });
    }
  }]);

  return PrerequisConclusionController;
}();

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(254);

var PrerequisComponent = function PrerequisComponent() {
  _classCallCheck(this, PrerequisComponent);

  this.controller = PrerequisController;
  this.template = __webpack_require__(306);
  this.bindings = {
    prefix: '@',
    initialData: '<',
    onPrerequisChange: '&',
    typePersonne: '<'
  };
};

/* harmony default export */ __webpack_exports__["a"] = PrerequisComponent;

var PrerequisController = function () {
  function PrerequisController() {
    _classCallCheck(this, PrerequisController);
  }

  _createClass(PrerequisController, [{
    key: '$onInit',
    value: function $onInit() {
      this.data = this.initialData || {};
      this.prefix = this.prefix ? this.prefix : '';
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      this.onPrerequisChange({ prerequis: this.data });
    }
  }]);

  return PrerequisController;
}();

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProgressComponent;
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(255);

function ProgressComponent() {
  return {
    controller: ProgressController,
    template: __webpack_require__(307),
    bindings: {
      disabled: '<progressDisabled',
      value: '<',
      color: '@'
    }
  };
}

// @ngInject

var ProgressController = function () {
  function ProgressController() {
    _classCallCheck(this, ProgressController);
  }

  _createClass(ProgressController, [{
    key: '$onInit',
    value: function $onInit() {
      this.color = angular.isDefined(this.color) ? this.color : 'primary';
    }
  }, {
    key: 'getLinearProgressValue',
    value: function getLinearProgressValue() {
      if (angular.isDefined(this.value)) {
        return {
          'transform': 'scale(' + this.value / 100 + ', 1)'
        };
      }
    }
  }]);

  return ProgressController;
}();

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_type_defaut_actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






__webpack_require__(256);

var TypeDefautComponent = function TypeDefautComponent() {
  _classCallCheck(this, TypeDefautComponent);

  this.controller = TypeDefautController;
  this.template = __webpack_require__(308);
  this.bindings = {
    typeDefaut: '<',
    parentForm: '<',
    onTypeDefautChange: '&'
  };
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = TypeDefautComponent;

var TypeDefautController = function () {
  function TypeDefautController($scope, $ngRedux) {
    _classCallCheck(this, TypeDefautController);

    this.$scope = $scope;
    this.$ngRedux = $ngRedux;

    this.data = {};
    this.typesDefaut = {};
  }

  _createClass(TypeDefautController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_type_defaut_actions__["d" /* default */].loadData());
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          typesDefaut: state.typeDefaut
        };
      })(function (selectedState) {
        __WEBPACK_IMPORTED_MODULE_1_lodash_assign___default()(_this, selectedState);
        _this.validateTypeDefaut();
      });

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'validateTypeDefaut',
    value: function validateTypeDefaut() {
      if (!this.typeDefaut || this.typesDefaut.fetching || !this.typesDefaut.data) {
        return;
      }

      this.data.typeDefaut = this.typeDefaut.id;
    }
  }, {
    key: 'onChange',
    value: function onChange(value) {
      this.onTypeDefautChange({ typeDefaut: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.typesDefaut.data, { 'id': value }) });
    }
  }]);

  return TypeDefautController;
}();

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_type_perturbation_actions__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_clone__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_clone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_some__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








__webpack_require__(257);

var TypePerturbationComponent = function TypePerturbationComponent() {
  _classCallCheck(this, TypePerturbationComponent);

  this.controller = TypePerturbationController;
  this.template = __webpack_require__(309);
  this.bindings = {
    typePerturbation: '<',
    origine: '@',
    parentForm: '<',
    onTypePerturbationChange: '&'
  };
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = TypePerturbationComponent;

var TypePerturbationController = function () {
  function TypePerturbationController($scope, $ngRedux) {
    _classCallCheck(this, TypePerturbationController);

    this.$scope = $scope;
    this.$ngRedux = $ngRedux;

    this.data = {};
    this.typesPerturbation = {};
  }

  _createClass(TypePerturbationController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_type_perturbation_actions__["d" /* default */].loadData());
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          typesPerturbation: state.typePerturbation
        };
      })(function (selectedState) {
        __WEBPACK_IMPORTED_MODULE_2_lodash_assign___default()(_this, selectedState);
        _this.validateTypePerturbation();
      });

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'validateTypePerturbation',
    value: function validateTypePerturbation() {
      var _this2 = this;

      if (!this.typePerturbation || this.typesPerturbation.fetching || !this.typesPerturbation.data) {
        return;
      }
      // Vérifier que la valeur est bien dans la liste
      if (__WEBPACK_IMPORTED_MODULE_3_lodash_some___default()(this.typesPerturbation.data, function (t) {
        return t.id === _this2.typePerturbation.id;
      })) {
        this.data.typePerturbation = __WEBPACK_IMPORTED_MODULE_1_lodash_clone___default()(this.typePerturbation);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(typePerturbation) {
      this.onTypePerturbationChange({ typePerturbation: __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(this.typesPerturbation.data, { 'id': typePerturbation }) });
    }
  }]);

  return TypePerturbationController;
}();

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["f" /* MAUVAISE_INSTABLE_BONNE_EXCELLENTE */].MAUVAISE:
        return 'Mauvaise';
      case __WEBPACK_IMPORTED_MODULE_0__model__["f" /* MAUVAISE_INSTABLE_BONNE_EXCELLENTE */].INSTABLE:
        return 'Instable';
      case __WEBPACK_IMPORTED_MODULE_0__model__["f" /* MAUVAISE_INSTABLE_BONNE_EXCELLENTE */].BONNE:
        return 'Bonne';
      case __WEBPACK_IMPORTED_MODULE_0__model__["f" /* MAUVAISE_INSTABLE_BONNE_EXCELLENTE */].EXCELLENTE:
        return 'Excellente';
      default:
        return '';
    }
  };
}

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RACCORDEMENT */].INDIVIDUEL:
        return 'Raccordement individuel';
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RACCORDEMENT */].COLLECTIF:
        return 'Raccordement collectif';
      case __WEBPACK_IMPORTED_MODULE_0__model__["c" /* MODE_RACCORDEMENT */].NSP:
        return 'Je ne sais pas ';
      default:
        return '';
    }
  };
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* PERMANENT_ALEATOIRE */].PERMANENT:
        return 'Permanent';
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* PERMANENT_ALEATOIRE */].ALEATOIRE:
        return 'Aléatoire';
      default:
        return '';
    }
  };
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* NATURE_PERTURBATION */].ANTENNE_EN_PANNE:
        return 'Antenne en panne';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* NATURE_PERTURBATION */].SIGNAL_ABSENT_OU_FAIBLE:
        return 'Signal TNT absent ou faible';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* NATURE_PERTURBATION */].PROBLEME_PREAMPLI:
        return 'Problème de préampli/amplificateur';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* NATURE_PERTURBATION */].BROUILLAGE_4G_5G:
        return 'Brouillage 4G/5G';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* NATURE_PERTURBATION */].PROBLEME_DIFFUSION:
        return 'Diffusion (défaut de l\'émetteur)';
      case __WEBPACK_IMPORTED_MODULE_0__model__["b" /* NATURE_PERTURBATION */].AUTRE:
        return 'Autre';
      default:
        return '';
    }
  };
}

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["h" /* OUI_NON_NSP */].OUI:
        return 'Oui';
      case __WEBPACK_IMPORTED_MODULE_0__model__["h" /* OUI_NON_NSP */].NON:
        return 'Non';
      case __WEBPACK_IMPORTED_MODULE_0__model__["h" /* OUI_NON_NSP */].NE_SAIT_PAS:
        return 'Je ne sais pas';
      default:
        return '';
    }
  };
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["g" /* PERTURBATIONS */].PERMANENTES:
        return 'Permanentes';
      case __WEBPACK_IMPORTED_MODULE_0__model__["g" /* PERTURBATIONS */].ALEATOIRES:
        return 'Aléatoires';
      default:
        return '';
    }
  };
}

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["e" /* TYPE_CONSTRUCTION */].EOLIENNE:
        return 'Eolienne';
      case __WEBPACK_IMPORTED_MODULE_0__model__["e" /* TYPE_CONSTRUCTION */].IMMEUBLE:
        return 'Immeuble';
      default:
        return '';
    }
  };
}

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["i" /* TYPE_LOGEMENT */].MAISON:
        return 'Maison';
      case __WEBPACK_IMPORTED_MODULE_0__model__["i" /* TYPE_LOGEMENT */].IMMEUBLE:
        return 'Immeuble';
      default:
        return '';
    }
  };
}

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["j" /* TYPE_PROBLEME */].PERMANENT:
        return 'Permanent';
      case __WEBPACK_IMPORTED_MODULE_0__model__["j" /* TYPE_PROBLEME */].TEMPORAIRE:
        return 'Temporaire/ Aléatoire';
      default:
        return '';
    }
  };
}

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_assign__);


/* harmony default export */ __webpack_exports__["a"] = UrlResolverInterceptor;

// @ngInject
function UrlResolverInterceptor($injector) {
  return {
    request: function request(config) {
      if (!config.urlConfig) {
        return config;
      }
      // On injecte UrlResolverService au moment voulu pour éviter
      // des problèmes de dépendences cycliques
      return $injector.get('UrlResolverService').resolveUrl(config.url, config.urlConfig).then(function (resolvedUrl) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default()(config, {
          url: resolvedUrl
        });
      });
    }
  };
}

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__providers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_endsWith__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_endsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_endsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startsWith__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_startsWith__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





// @ngInject

var UrlResolverService = function () {
  // @ngInject
  function UrlResolverService($urlMatcherFactory) {
    _classCallCheck(this, UrlResolverService);

    this.$urlMatcherFactory = $urlMatcherFactory;
  }

  _createClass(UrlResolverService, [{
    key: 'resolveUrl',
    value: function resolveUrl(path, config) {
      var pathParams = config.pathParams,
          server = config.server;

      var compiledPath = void 0;
      if (!pathParams) {
        compiledPath = path;
      } else {
        compiledPath = this.$urlMatcherFactory.compile(path).format(pathParams);
      }
      // Ne doit être utilisé que pour nos requêtes
      var serveur = server || '/';
      var finalUrl = serveur;
      if (!__WEBPACK_IMPORTED_MODULE_1_lodash_endsWith___default()(serveur, '/')) {
        finalUrl += '/';
      }
      if (__WEBPACK_IMPORTED_MODULE_2_lodash_startsWith___default()(compiledPath, '/')) {
        finalUrl += compiledPath.substr(1);
      } else {
        finalUrl += compiledPath;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__providers__["d" /* $qProvider */])().when(finalUrl);
    }
  }]);

  return UrlResolverService;
}();

/* harmony default export */ __webpack_exports__["a"] = UrlResolverService;

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_model__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_model__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pattern_util__ = __webpack_require__(62);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(258);







var LteInterface1Component = function LteInterface1Component() {
  _classCallCheck(this, LteInterface1Component);

  this.controller = LteInterface1Controller;
  this.template = __webpack_require__(310);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = LteInterface1Component;

var LteInterface1Controller = function () {
  function LteInterface1Controller($scope, $ngRedux) {
    _classCallCheck(this, LteInterface1Controller);

    this.CIVILITE = __WEBPACK_IMPORTED_MODULE_2__base_model__["a" /* CIVILITE */];
    this.MODE_RACCORDEMENT = __WEBPACK_IMPORTED_MODULE_1__common_model__["c" /* MODE_RACCORDEMENT */];
    this.TYPE_LOGEMENT = __WEBPACK_IMPORTED_MODULE_1__common_model__["i" /* TYPE_LOGEMENT */];
    this.OUI_NON = __WEBPACK_IMPORTED_MODULE_1__common_model__["d" /* OUI_NON */];
    this.OUI_NON_NSP = __WEBPACK_IMPORTED_MODULE_1__common_model__["h" /* OUI_NON_NSP */];
    this.regex = new RegExp(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/, 'u');
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.emailPattern = __WEBPACK_IMPORTED_MODULE_4__utils_pattern_util__["a" /* EMAIL_PATTERN */];
    this.telephonePattern = __WEBPACK_IMPORTED_MODULE_4__utils_pattern_util__["b" /* TELEPHONE_PATTERN */];
  }

  _createClass(LteInterface1Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_3__utils_routes_util__["c" /* STEPS */].LTE_INTERFACE_1));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          typePersonne: state.demande.data.typePersonne,
          data: state.demande.data.lteInterface1 ? state.demande.data.lteInterface1.asMutable({ deep: true }) : _this.data
        };
      })(this);
      this.data = { civilite: __WEBPACK_IMPORTED_MODULE_2__base_model__["a" /* CIVILITE */].DEFAULT_VALUE,
        modeRaccordement: __WEBPACK_IMPORTED_MODULE_1__common_model__["c" /* MODE_RACCORDEMENT */].DEFAULT_VALUE,
        typeLogement: __WEBPACK_IMPORTED_MODULE_1__common_model__["i" /* TYPE_LOGEMENT */].DEFAULT_VALUE,
        voisinsImpactes: __WEBPACK_IMPORTED_MODULE_1__common_model__["h" /* OUI_NON_NSP */].DEFAULT_VALUE };
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'defineRaccordement',
    value: function defineRaccordement() {
      if (this.data.modeRaccordement === __WEBPACK_IMPORTED_MODULE_1__common_model__["c" /* MODE_RACCORDEMENT */].NSP) {
        if (this.data.typeLogement === __WEBPACK_IMPORTED_MODULE_1__common_model__["i" /* TYPE_LOGEMENT */].IMMEUBLE) {
          this.data.modeRaccordement = __WEBPACK_IMPORTED_MODULE_1__common_model__["c" /* MODE_RACCORDEMENT */].COLLECTIF;
        } else {
          this.data.modeRaccordement = __WEBPACK_IMPORTED_MODULE_1__common_model__["c" /* MODE_RACCORDEMENT */].INDIVIDUEL;
        }
      }
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateLteInterface1(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.defineRaccordement();
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateLteInterface1(this.data));
    }
  }]);

  return LteInterface1Controller;
}();

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(259);





var LteInterface2Component = function LteInterface2Component() {
  _classCallCheck(this, LteInterface2Component);

  this.controller = LteInterface2Controller;
  this.template = __webpack_require__(311);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = LteInterface2Component;

var LteInterface2Controller = function () {
  function LteInterface2Controller($scope, $ngRedux) {
    _classCallCheck(this, LteInterface2Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  _createClass(LteInterface2Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].LTE_INTERFACE_2));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.lteInterface2 ? state.demande.data.lteInterface2.asMutable({ deep: true }) : _this.data,
          typePersonne: state.demande.data.typePersonne
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.data = {};
    }
    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateLteInterface2(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateLteInterface2(this.data));
    }
  }]);

  return LteInterface2Controller;
}();

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_routes_util__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].LTE_INTERFACE_1, {
    url: '/lte-interface-1',
    template: '<dmattnt-lte-interface-1></dmattnt-lte-interface-1>',
    data: { label: 'Station LTE détectée' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].LTE_INTERFACE_2, {
    url: '/lte-interface-2',
    template: '<dmattnt-lte-interface-2></dmattnt-lte-interface-2>',
    data: { label: 'À bientôt' }
  });
}

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(261);




var PrtvDepotFacture2Component = function PrtvDepotFacture2Component() {
  _classCallCheck(this, PrtvDepotFacture2Component);

  this.controller = PrtvDepotFacture2Controller;
  this.template = __webpack_require__(312);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvDepotFacture2Component;

var PrtvDepotFacture2Controller = function () {
  function PrtvDepotFacture2Controller($scope, $ngRedux) {
    _classCallCheck(this, PrtvDepotFacture2Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(PrtvDepotFacture2Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE_2));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.prtvDepotFacture ? state.demande.data.prtvDepotFacture.asMutable({ deep: true }) : _this.data,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier : state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : ''
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.disableNext = true;
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvDepotFacture2(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvDepotFacture2(this.data));
    }
  }]);

  return PrtvDepotFacture2Controller;
}();

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(262);




var PrtvDepotFacture3Component = function PrtvDepotFacture3Component() {
  _classCallCheck(this, PrtvDepotFacture3Component);

  this.controller = PrtvDepotFacture3Controller;
  this.template = __webpack_require__(313);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvDepotFacture3Component;

var PrtvDepotFacture3Controller = function () {
  function PrtvDepotFacture3Controller($scope, $ngRedux) {
    _classCallCheck(this, PrtvDepotFacture3Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(PrtvDepotFacture3Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE_3));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.prtvDepotFacture2 ? state.demande.data.prtvDepotFacture2.asMutable({ deep: true }) : _this.data,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier : state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          factureFileName: state.demande.data.prtvDepotFacture ? state.demande.data.prtvDepotFacture.factureFileName : null,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
          checkCode: state.demande.data ? state.demande.data.checkCode : '',
          numeroAnfr: state.demande.data ? state.demande.data.numeroAnfr : ''
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.disableNext = true;
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvDepotFacture3(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvDepotFacture3(this.data));
    }
  }]);

  return PrtvDepotFacture3Controller;
}();

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_liste_antenniste_repository__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pdf_util__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_pattern_util__ = __webpack_require__(62);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(263);








var PrtvDepotFactureComponent = function PrtvDepotFactureComponent() {
  _classCallCheck(this, PrtvDepotFactureComponent);

  this.controller = PrtvDepotFactureController;
  this.template = __webpack_require__(314);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvDepotFactureComponent;

var PrtvDepotFactureController = function () {
  function PrtvDepotFactureController($scope, $ngRedux) {
    _classCallCheck(this, PrtvDepotFactureController);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.allAntennistesCalled = false;
    this.rayonMax = __WEBPACK_IMPORTED_MODULE_3__model__["b" /* MINUMUM_DISTANCE */];
    this.lastRayon = 0;
    this.dernierChangementRayon = new Date();
    this.nbOfAntennistes = 0;
    this.loadingWebService = false;
    this.data = {
      denomination: '',
      nomContact: '',
      adresseContact: '',
      telContact: '',
      isFactureOk: false,
      factureFile: '',
      factureFileName: '',
      autresFactures: []
    };
    this.emailPattern = __WEBPACK_IMPORTED_MODULE_5__utils_pattern_util__["a" /* EMAIL_PATTERN */];
    this.telephonePattern = __WEBPACK_IMPORTED_MODULE_5__utils_pattern_util__["b" /* TELEPHONE_PATTERN */];
  }

  _createClass(PrtvDepotFactureController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        //on arrive de la reclamation, donc on a toutes les etapes de la demande.
        if (!_this.allAntennistesCalled && state.demande.data.accueilInterface2 !== undefined) {
          _this.getAllAntennisteListUntilResult(state.demande.data.numeroAnfr, __WEBPACK_IMPORTED_MODULE_3__model__["b" /* MINUMUM_DISTANCE */]);
        }
        //on arrive de la recherche du suivi, donc on a aucune etape de la demande.
        if (!_this.allAntennistesCalled && state.demande.data.codeStatut === 'PRTV_DE_EN_COURS_SAISIE_PAR_LE_TSP' && state.demande.data.accueilInterface2 === undefined) {
          _this.getAllAntennisteListUntilResult(state.demande.data.numeroAnfr, __WEBPACK_IMPORTED_MODULE_3__model__["b" /* MINUMUM_DISTANCE */]);
        }
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.prtvDepotFacture ? state.demande.data.prtvDepotFacture.asMutable({ deep: true }) : _this.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier : state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
          checkCode: state.demande.data ? state.demande.data.checkCode : '',
          numeroAnfr: state.demande.data ? state.demande.data.numeroAnfr : ''
        };
      })(this);

      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.disableNext = true;

      //angular prend pas de ng-change sur un file alors :
      this.$scope.factureFileChanged = function (input) {
        try {
          var file = input.files[0];
          _this.updateFactureFile(file);
          _this.$scope.$apply();
        } catch (error) {
          _this.data.factureFileName = '';
          _this.data.factureFile = '';
        }
      };

      this.$scope.otherFileChanged = function (input) {
        _this.tempFilename = input.name;
        _this.$scope.$apply();
      };
    }
  }, {
    key: 'updateFactureFile',
    value: function updateFactureFile(file) {
      var _this2 = this;

      this.convertFileToBase(file).then(function (convertedFile) {
        if (file instanceof Blob) {
          _this2.data.factureFile = convertedFile;
          _this2.data.factureFileName = file.name;
          document.getElementById('removableFacture').style.display = 'block';
          _this2.$scope.$apply();
        } else {
          _this2.onClickRemoveFactureFile();
        }
      });
    }
  }, {
    key: 'updateTempFile',
    value: function updateTempFile(file, id) {
      var _this3 = this;

      if (file !== undefined) {
        this.convertFileToBase(file).then(function (convertedFile) {
          if (file instanceof Blob) {
            _this3.tempFile = convertedFile;
            _this3.tempFilename = file.name;
            var obj = {
              binary: convertedFile,
              name: file.name,
              id: id
            };
            _this3.data.autresFactures.push(obj);
            _this3.$scope.$apply();
          }
        });
      }
    }
  }, {
    key: 'getAllAntennisteListUntilResult',
    value: function getAllAntennisteListUntilResult(numeroAnfr, rayonMax) {
      var _this4 = this;

      if (this.fetching) {
        return;
      }
      if (numeroAnfr === undefined) {
        return;
      }
      //on passe a true au premier appel, pour qu'on ne rappelle pas apres sans avoir modifié la distance.
      this.allAntennistesCalled = true;
      this.loadingWebService = true;
      __WEBPACK_IMPORTED_MODULE_2__repositories_liste_antenniste_repository__["a" /* default */].getAntennisteList(numeroAnfr, rayonMax).then(function (response) {
        if (response.total > 0) {
          _this4.allAntennistes = response;
          _this4.nbOfAntennistes = response.data.length;
          _this4.rayonMax = rayonMax;
          _this4.loadingWebService = false;
        } else {
          var nouveauRayon = rayonMax + __WEBPACK_IMPORTED_MODULE_3__model__["c" /* DISTANCE_STEP */];
          if (nouveauRayon < __WEBPACK_IMPORTED_MODULE_3__model__["d" /* MAXIMUM_DISTANCE */]) {
            _this4.getAllAntennisteListUntilResult(numeroAnfr, nouveauRayon);
          }
        }
      });
    }
  }, {
    key: 'onChangeRayonMax',
    value: function onChangeRayonMax() {
      var _this5 = this;

      var temp = this.rayonMax;
      var changement = new Date();
      setTimeout(function () {
        //si le rayon courant est le dernier rayon modifié, et qu'il est different du dernier rayon envoyé
        if (temp === _this5.rayonMax && temp !== _this5.lastRayon) {
          //si le changement date de plus d'une seconde
          if (Math.abs(changement.getTime() - _this5.dernierChangementRayon.getTime()) > 1000) {
            _this5.loadingWebService = true;
            _this5.dernierChangementRayon = new Date();
            __WEBPACK_IMPORTED_MODULE_2__repositories_liste_antenniste_repository__["a" /* default */].getAntennisteList(_this5.demande.numeroAnfr, temp).then(function (response) {
              if (typeof response.data !== 'undefined') {
                _this5.allAntennistes = response;
                _this5.nbOfAntennistes = response.data.length;
                _this5.lastRayon = temp;
                _this5.loadingWebService = false;
              }
            });
          }
        }
      }, 1000);
    }
  }, {
    key: 'onClickRemoveFactureFile',
    value: function onClickRemoveFactureFile() {
      this.data.factureFile = '';
      this.data.factureFileName = '';
      this.data.autresFactures = [];
      document.getElementById('factureFile').value = '';
      document.getElementById('removableFacture').style.display = 'none';
    }
  }, {
    key: 'convertFileToBase',
    value: function convertFileToBase(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var base64String = reader.result.split(',')[1];
          resolve(base64String);
        };
        reader.onerror = function () {
          reject('');
        };
      });
    }
  }, {
    key: 'onClickAddOtherFile',
    value: function onClickAddOtherFile() {
      try {
        var file = document.getElementById('otherFile').files[0];
        var id = new Date().toISOString();
        this.updateTempFile(file, id);
        document.getElementById('otherFile').value = null;
      } catch (error) {
        console.error(error, 'Erreur lors du téléchargement de votre fichier');
      }
    }
  }, {
    key: 'download',
    value: function download() {
      __WEBPACK_IMPORTED_MODULE_4__utils_pdf_util__["a" /* default */].openPdfUrl(this.numeroAnfr, this.checkCode, false);
      this.pdfurl = __WEBPACK_IMPORTED_MODULE_4__utils_pdf_util__["a" /* default */].buildPdfUrl(this.numeroAnfr, this.checkCode, false);
    }
  }, {
    key: 'onClickRemoveOtherFiles',
    value: function onClickRemoveOtherFiles(e) {
      this.data.autresFactures = this.data.autresFactures.filter(function (file) {
        return file.id !== e.target.getAttribute('deleteId');
      });
    }
  }, {
    key: 'checkDuplicatesFiles',
    value: function checkDuplicatesFiles() {
      if (this.data.autresFactures.length > 0) {
        var tab = JSON.parse(JSON.stringify(this.data.autresFactures));
        //ajoute la première facture pour comparer les doublons avec tous les fichiers
        tab.unshift({
          binary: this.data.factureFile,
          name: this.data.factureFileName,
          id: 'facture'
        });
        var uniqueNamesArray = tab.filter(function (file, index, array) {
          return index === array.findIndex(function (files) {
            return files.name === file.name;
          });
        });
        // retire le premier fichier,
        uniqueNamesArray.shift();
        // update les fichiers
        this.data.autresFactures = uniqueNamesArray;
      }
    }

    // Actions

  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.checkDuplicatesFiles();
      if (this.data.factureFile !== '') {
        this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvDepotFacture(this.data));
      }
    }
  }]);

  return PrtvDepotFactureController;
}();

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_emetteurtnt_repository__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_constantes_util_js__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_multiplex_actions__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_model__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__base_model__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_assign__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_filter__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_some__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_flattenDeep__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_flattenDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_flattenDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_remove__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_includes__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_pattern_util__ = __webpack_require__(62);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(264);





















var PrtvInterface1Component = function PrtvInterface1Component() {
  _classCallCheck(this, PrtvInterface1Component);

  this.controller = PrtvInterface1Controller;
  this.template = __webpack_require__(315);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvInterface1Component;

var PrtvInterface1Controller = function () {
  function PrtvInterface1Controller($scope, $ngRedux) {
    _classCallCheck(this, PrtvInterface1Controller);

    this.CIVILITE = __WEBPACK_IMPORTED_MODULE_7__base_model__["a" /* CIVILITE */];
    this.OUI_NON = __WEBPACK_IMPORTED_MODULE_4__common_model__["d" /* OUI_NON */];
    this.OUI_NON_NSP = __WEBPACK_IMPORTED_MODULE_4__common_model__["h" /* OUI_NON_NSP */];
    this.TYPE_PERTURBATEUR = __WEBPACK_IMPORTED_MODULE_5__model__["a" /* TYPE_PERTURBATEUR */];
    this.suspicionLteCalled = false;
    this.data = { chaines: [] };
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.chainesCode = {};
    this.muxExclus = ['R15', 'ROM1', 'ROML', 'ROM2'];
    this.suspicionLte = {
      loading: false,
      message: ''
    };
    this.regex = new RegExp(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/, 'u');
    this.emailPattern = __WEBPACK_IMPORTED_MODULE_17__utils_pattern_util__["a" /* EMAIL_PATTERN */];
    this.telephonePattern = __WEBPACK_IMPORTED_MODULE_17__utils_pattern_util__["b" /* TELEPHONE_PATTERN */];
  }

  _createClass(PrtvInterface1Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_6__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_1));
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_3__actions_multiplex_actions__["d" /* default */].loadData());
      this.suspicionLteCalled = false;
      this.isAdresseDomCom = false;

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.asMutable({ deep: true }) : _this.data,
          //On vérifie si on a déjà récupérer la liste des mux sinon on les reload
          multiplex: state.demande.data.accueilInterface2 && state.demande.data.accueilInterface2.multiplex ? state.demande.data.accueilInterface2.multiplex : state.multiplex.data ? state.multiplex.data.data : state.multiplex.data,
          adresse: state.demande.data.accueilInterface2 && state.demande.data.accueilInterface2.adresse ? state.demande.data.accueilInterface2.adresse : null,
          typePersonne: state.demande.data.typePersonne
        };
      })(function (selectedState) {
        __WEBPACK_IMPORTED_MODULE_8_lodash_assign___default()(_this, selectedState);
        if (!_this.data.chaines) {
          _this.data.chaines = [];
        }
        _this.handleChainesLoaded();
        _this.data.allChaines = _this.computeChaines();
        // pour appeler une seule fois le flagLte
        if (!_this.suspicionLteCalled) {
          _this.flagLte();
        }
        if (_this.adresse) {
          // Est-ce que l'adresse concerne un DOM / COM ?
          _this.isAdresseDomCom = ['97', '98'].indexOf(_this.adresse.commune.insee.substr(0, 2)) !== -1;
        }
      });
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'handleChainesLoaded',
    value: function handleChainesLoaded() {
      var _this2 = this;

      if (this.fetching) {
        return;
      }
      if (!this.data.chaines.length || !this.multiplex.length) {
        return;
      }
      this.data.chaines = __WEBPACK_IMPORTED_MODULE_9_lodash_filter___default()(this.data.chaines, function (chaine) {
        return __WEBPACK_IMPORTED_MODULE_11_lodash_some___default()(_this2.multiplex, function (m) {
          return __WEBPACK_IMPORTED_MODULE_11_lodash_some___default()(m.chainesActives, function (c) {
            return c.id === chaine.id;
          });
        });
      });
      __WEBPACK_IMPORTED_MODULE_10_lodash_forEach___default()(this.data.chaines, function (chaine) {
        _this2.chainesCode[chaine.id] = true;
      });
      if (this.data.infoChaineLocal === __WEBPACK_IMPORTED_MODULE_1__utils_constantes_util_js__["a" /* CHAINES_LOCALES_RECUES */]) {
        this.chainesCode[0] = true;
      }
    }
  }, {
    key: 'onTypePerturbationChange',
    value: function onTypePerturbationChange(typePerturbation) {
      this.data.typePerturbation = typePerturbation;
    }
  }, {
    key: 'flagLte',
    value: function flagLte() {
      var _this3 = this;

      if (this.adresse === null) {
        return;
      }
      this.suspicionLte.loading = true;
      this.suspicionLteCalled = true;
      if (!this.adresse.numero) {
        this.suspicionLte = __WEBPACK_IMPORTED_MODULE_0__repositories_emetteurtnt_repository__["a" /* default */].searchSuspicionLte(this.adresse.voie, this.adresse.codePostal.codepostal, this.adresse.commune.nom).then(function (response) {
          _this3.suspicionLte.message = response.message;
        }).finally(function () {
          return _this3.suspicionLte.loading = false;
        });
      } else {
        this.suspicionLte = __WEBPACK_IMPORTED_MODULE_0__repositories_emetteurtnt_repository__["a" /* default */].searchSuspicionLte(this.adresse.numero + ' ' + this.adresse.voie, this.adresse.codePostal.codepostal, this.adresse.commune.nom).then(function (response) {
          _this3.suspicionLte.message = response.message;
        }).finally(function () {
          return _this3.suspicionLte.loading = false;
        });
      }
    }
  }, {
    key: 'computeChaines',
    value: function computeChaines() {
      var _this4 = this;

      if (this.multiplex === null) {
        return [];
      }
      //on exclue les multiplex de domtom
      this.multiplex = __WEBPACK_IMPORTED_MODULE_9_lodash_filter___default()(this.multiplex, function (m) {
        return !__WEBPACK_IMPORTED_MODULE_16_lodash_includes___default()(_this4.muxExclus, m.code);
      });
      //on exclue les chaines locales
      return __WEBPACK_IMPORTED_MODULE_15_lodash_remove___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_flattenDeep___default()(__WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(this.multiplex, function (m) {
        return m.chainesActives;
      })), function (d) {
        return d.id;
      }), function (c) {
        return c.code !== '30-39';
      });
    }
  }, {
    key: 'onChangeSelected',
    value: function onChangeSelected(chaine) {
      if (chaine) {
        if (this.chainesCode[chaine.id]) {
          // Sélection de la chaîne
          this.data.chaines.push(chaine);
        } else {
          // Déselection de la chaîne
          this.data.chaines = __WEBPACK_IMPORTED_MODULE_9_lodash_filter___default()(this.data.chaines, function (c) {
            return c.id !== chaine.id;
          });
        }
      } else {
        if (this.chainesCode[0]) {
          this.data.infoChaineLocal = __WEBPACK_IMPORTED_MODULE_1__utils_constantes_util_js__["a" /* CHAINES_LOCALES_RECUES */];
        } else {
          this.data.infoChaineLocal = '';
        }
      }
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_demande_actions__["d" /* default */].updatePrtvInterface1(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.data.demandeEnquetePapier = true;
      this.data.isAdresseDomCom = this.isAdresseDomCom;
      if (this.data.stationLteConfirmee === 'OUI' || this.suspicionLte.message !== '0') {
        this.data.demandeEnquetePapier = false;
      }
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_2__actions_demande_actions__["d" /* default */].updatePrtvInterface1(this.data));
    }
  }]);

  return PrtvInterface1Controller;
}();

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(265);





var PrtvInterface2Component = function PrtvInterface2Component() {
  _classCallCheck(this, PrtvInterface2Component);

  this.controller = PrtvInterface2Controller;
  this.template = __webpack_require__(316);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvInterface2Component;

var PrtvInterface2Controller = function () {
  function PrtvInterface2Controller($scope, $ngRedux) {
    _classCallCheck(this, PrtvInterface2Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(PrtvInterface2Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_2));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier : state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          data: state.demande.data.prtvInterface2 ? state.demande.data.prtvInterface2.asMutable({ deep: true }) : _this.data,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : ''
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.disableNext = true;
      this.prerequis = { antenne: false, voisins: false };
    }
  }, {
    key: 'onPrerequisChange',
    value: function onPrerequisChange(prerequis) {
      this.disableNext = prerequis.antenne && prerequis.voisins === true ? false : true;
    }
    // Actions

  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.data.demandeEnquetePapier = this.demandeEnquetePapier;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvInterface2(this.data));
    }
  }]);

  return PrtvInterface2Controller;
}();

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__repositories_chaines_locales_repository__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_model__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model__ = __webpack_require__(38);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(266);








var PrtvInterface3Component = function PrtvInterface3Component() {
  _classCallCheck(this, PrtvInterface3Component);

  this.controller = PrtvInterface3Controller;
  this.template = __webpack_require__(317);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvInterface3Component;

var PrtvInterface3Controller = function () {
  function PrtvInterface3Controller($scope, $ngRedux) {
    var _this = this;

    _classCallCheck(this, PrtvInterface3Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.MAUVAISE_INSTABLE_BONNE_EXCELLENTE = __WEBPACK_IMPORTED_MODULE_3__common_model__["f" /* MAUVAISE_INSTABLE_BONNE_EXCELLENTE */];
    this.PERTURBATIONS = __WEBPACK_IMPORTED_MODULE_3__common_model__["g" /* PERTURBATIONS */];
    this.OTHER_VALUE = __WEBPACK_IMPORTED_MODULE_4__model__["e" /* OTHER_VALUE */];
    this.containsStations = false;
    this.data = {
      connexionQuality: '',
      isContinue: false,
      channels: {},
      receivedStation: '',
      otherSelectedStationName: '',
      isNoOrientation: false,
      perturbationsValue: '',
      validStation: ''
    };
    this.$scope.$watch(function () {
      return _this.data.receivedStation;
    }, function () {
      return _this.handleOtherStation();
    });
    this.$scope.$watch(function () {
      return _this.data.otherSelectedStationName;
    }, function () {
      return _this.handleOtherStation();
    });
  }

  _createClass(PrtvInterface3Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_2__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_3));
      // Connexion au state récupérer les données modifiées
      this.alreadyFetched = false;

      var disconnect = this.$ngRedux.connect(function (state) {
        if (!_this2.alreadyFetched) {
          if (state.demande.data.prtvInterface2 !== undefined) {
            _this2.alreadyFetched = true;
            _this2.fetchChainesPrtvSuivi(state.demande.data);
          }
        }
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier : state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          data: state.demande.data.prtvInterface3 ? state.demande.data.prtvInterface3.asMutable({ deep: true }) : _this2.data,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : ''
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
  }, {
    key: 'fetchChainesPrtvSuivi',
    value: function fetchChainesPrtvSuivi(demande) {
      if (demande.accueilInterface2) {
        var adresse = demande.accueilInterface2.adresse.commune.nom;
        var codeinsee = demande.accueilInterface2.adresse.commune.insee;
        this.callChainesLocales(adresse, codeinsee);
      }
      if (demande.informationsSuivi) {
        var _adresse = demande.informationsSuivi.nomCommune;
        var _codeinsee = demande.informationsSuivi.inseeCommune;
        this.callChainesLocales(_adresse, _codeinsee);
      }
    }
  }, {
    key: 'callChainesLocales',
    value: function callChainesLocales(adresse, codeinsee) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__repositories_chaines_locales_repository__["a" /* default */].getChainesLocales(adresse, codeinsee).then(function (response) {
        _this3.containsStations = response.data && response.data[0].station.length > 0;
        _this3.creerTableauSitesStations(response);
      });
    }
  }, {
    key: 'handleOtherStation',
    value: function handleOtherStation() {
      if (this.data.receivedStation === __WEBPACK_IMPORTED_MODULE_4__model__["e" /* OTHER_VALUE */]) {
        this.data.validStation = this.data.otherSelectedStationName;
      } else {
        this.data.validStation = this.data.receivedStation;
      }
    }
  }, {
    key: 'creerTableauSitesStations',
    value: function creerTableauSitesStations(response) {
      //data des sites et des stations
      var site = response.data[0].site;
      var station = response.data[0].station;
      var siteMap = site.map(function (name) {
        return {
          name: name
        };
      });
      var stationMap = station.map(function (name) {
        return {
          name: name,
          switchValue: false
        };
      });
      this.data.channels = { station: [].concat(_toConsumableArray(stationMap)), site: siteMap };
    }
  }, {
    key: 'onChangeConnexionQuality',
    value: function onChangeConnexionQuality() {
      this.data.isContinue = this.data.connexionQuality === this.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.BONNE || this.data.connexionQuality === this.MAUVAISE_INSTABLE_BONNE_EXCELLENTE.EXCELLENTE;
    }
  }, {
    key: 'onChangeButtonNoOrientation',
    value: function onChangeButtonNoOrientation() {
      this.data.otherSelectedStationName = '';
    }
  }, {
    key: 'onChangeInputOtherStation',
    value: function onChangeInputOtherStation() {
      this.data.isNoOrientation = false;
    }
  }, {
    key: 'onClickStationButton',
    value: function onClickStationButton() {
      this.data.isNoOrientation = false;
      this.data.otherSelectedStationName = '';
    }

    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvInterface3(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvInterface3(this.data));
    }
  }]);

  return PrtvInterface3Controller;
}();

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_model__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date_util__ = __webpack_require__(103);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(267);






var PrtvInterface4Component = function PrtvInterface4Component() {
  _classCallCheck(this, PrtvInterface4Component);

  this.controller = PrtvInterface4Controller;
  this.template = __webpack_require__(318);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvInterface4Component;

var PrtvInterface4Controller = function () {
  function PrtvInterface4Controller($scope, $ngRedux) {
    _classCallCheck(this, PrtvInterface4Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.TYPE_CONSTRUCTION = __WEBPACK_IMPORTED_MODULE_2__common_model__["e" /* TYPE_CONSTRUCTION */];
    this.dateMax = new Date().toString();
    this.firstPerturbationDateIsvalid = true;
    this.data = {
      isConstructionKnowledge: false,
      is5KmAround: false,
      constructionType: '',
      firstPerturbationDate: null
    };
  }

  _createClass(PrtvInterface4Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_4));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier : state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          data: state.demande.data.prtvInterface4 ? state.demande.data.prtvInterface4.asMutable({ deep: true }) : _this.data,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : ''
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.disableNext = true;
    }
  }, {
    key: 'onChangeFirstPertubationDate',
    value: function onChangeFirstPertubationDate() {
      this.firstPerturbationDateIsvalid = __WEBPACK_IMPORTED_MODULE_3__utils_date_util__["a" /* default */].validate(this.data.firstPerturbationDate);
    }
  }, {
    key: 'onChangeIsConstructionKnowledge',
    value: function onChangeIsConstructionKnowledge() {
      if (!this.data.isConstructionKnowledge) {
        this.data.is5KmAround = false;
        this.data.constructionType = '';
        this.data.firstPerturbationDate = null;
      }
    }
    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvInterface4(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvInterface4(this.data));
    }
  }]);

  return PrtvInterface4Controller;
}();

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_date_util__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model__ = __webpack_require__(38);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(268);






var PrtvInterface5Component = function PrtvInterface5Component() {
  _classCallCheck(this, PrtvInterface5Component);

  this.controller = PrtvInterface5Controller;
  this.template = __webpack_require__(319);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvInterface5Component;

var PrtvInterface5Controller = function () {
  function PrtvInterface5Controller($scope, $ngRedux) {
    _classCallCheck(this, PrtvInterface5Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.OTHER_VALUE = __WEBPACK_IMPORTED_MODULE_3__model__["e" /* OTHER_VALUE */];
    this.NO_ANSWER = __WEBPACK_IMPORTED_MODULE_3__model__["f" /* NO_ANSWER */];
    this.data = {};
  }

  _createClass(PrtvInterface5Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_5));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          dataPrtv3: state.demande.data.prtvInterface3 ? state.demande.data.prtvInterface3.asMutable({ deep: true }) : _this.data,
          dataPrtv4: state.demande.data.prtvInterface4 ? state.demande.data.prtvInterface4.asMutable({ deep: true }) : _this.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier : state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
          adresseComplete: state.demande.data.accueilInterface2 ? state.demande.data.accueilInterface2.adresse.numero + ' ' + state.demande.data.accueilInterface2.adresse.voie + ' ' + state.demande.data.accueilInterface2.adresse.commune.codepostal + ' ' + state.demande.data.accueilInterface2.adresse.commune.nom : '',
          channels: state.demande.data.prtvInterface3 ? state.demande.data.prtvInterface3.channels.station ? state.demande.data.prtvInterface3.channels.station.filter(function (channel) {
            return channel.switchValue;
          }).map(function (channel) {
            return channel.name;
          }).join(', ') : _this.NO_ANSWER : _this.NO_ANSWER
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.disableNext = true;
    }
  }, {
    key: 'onChangeFirstPertubationDate',
    value: function onChangeFirstPertubationDate() {
      this.firstPerturbationDateIsvalid = __WEBPACK_IMPORTED_MODULE_2__utils_date_util__["a" /* default */].validate(this.data.firstPerturbationDate);
    }
  }, {
    key: 'handleAnswer',
    value: function handleAnswer(answer) {
      if (answer === '' || answer === null) {
        return this.NO_ANSWER;
      } else if (answer === true) {
        return 'Oui';
      } else if (answer === false) {
        return 'Non';
      } else {
        return answer;
      }
    }
  }, {
    key: 'handleAnswerConstruction',
    value: function handleAnswerConstruction(answer) {
      if (!this.dataPrtv4.isConstructionKnowledge) {
        return this.NO_ANSWER;
      } else {
        return this.handleAnswer(answer);
      }
    }
    // Actions

  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvInterface5(this.data, true));
    }
  }, {
    key: 'nextStep',
    value: function nextStep() {
      //assign the data of previous pages to this one for saving next
      Object.assign(this.data, this.dataPrtv3, this.dataPrtv4);
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtvInterface5(this.data));
    }
  }]);

  return PrtvInterface5Controller;
}();

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(269);




var PrtvInterface6Component = function PrtvInterface6Component() {
  _classCallCheck(this, PrtvInterface6Component);

  this.controller = PrtvInterface6Controller;
  this.template = __webpack_require__(320);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = PrtvInterface6Component;

var PrtvInterface6Controller = function () {
  function PrtvInterface6Controller($scope, $ngRedux) {
    _classCallCheck(this, PrtvInterface6Controller);

    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  _createClass(PrtvInterface6Controller, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_6));

      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.prtvInterface6 ? state.demande.data.prtvInterface6.asMutable({ deep: true }) : _this.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier : state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom : state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : ''
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
      this.disableNext = true;
    }

    // Actions

  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.data.nom = this.nom;
      this.data.prenom = this.prenom;
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updatePrtv6ToFacture(this.data));
    }
  }]);

  return PrtvInterface6Controller;
}();

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model__ = __webpack_require__(38);


/* harmony default export */ __webpack_exports__["a"] = factory;

function factory() {
  return function (value) {
    switch (value) {
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* TYPE_PERTURBATEUR */].CONSTRUCTION:
        return 'Construction';
      case __WEBPACK_IMPORTED_MODULE_0__model__["a" /* TYPE_PERTURBATEUR */].EOLIENNE:
        return 'Éolienne';
      default:
        return '';
    }
  };
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_routes_util__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_1, {
    url: '/prtv-interface-1',
    template: '<dmattnt-prtv-interface-1></dmattnt-prtv-interface-1>',
    data: { label: 'Étude approfondie' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_2, {
    url: '/prtv-interface-2',
    template: '<dmattnt-prtv-interface-2></dmattnt-prtv-interface-2>',
    data: { label: 'Demande d\'enquête' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_3, {
    url: '/prtv-interface-3',
    template: '<dmattnt-prtv-interface-3></dmattnt-prtv-interface-3>',
    data: { label: 'Contrôles à effectuer par vous-même' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_4, {
    url: '/prtv-interface-4',
    template: '<dmattnt-prtv-interface-4></dmattnt-prtv-interface-4>',
    data: { label: 'Informations complémentaires' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_5, {
    url: '/prtv-interface-5',
    template: '<dmattnt-prtv-interface-5></dmattnt-prtv-interface-5>',
    data: { label: 'Validation des informations' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_INTERFACE_6, {
    url: '/prtv-interface-6',
    template: '<dmattnt-prtv-interface-6></dmattnt-prtv-interface-6>',
    data: { label: 'Informations validées' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE, {
    url: '/prtv-depot-facture',
    template: '<dmattnt-prtv-depot-facture></dmattnt-prtv-depot-facture>',
    data: { label: 'Dépôt facture' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE_2, {
    url: '/prtv-depot-facture-2',
    template: '<dmattnt-prtv-depot-facture-2></dmattnt-prtv-depot-facture-2>',
    data: { label: 'Confirmation des informations de l’antenniste' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].PRTV_DEPOT_FACTURE_3, {
    url: '/prtv-depot-facture-3',
    template: '<dmattnt-prtv-depot-facture-3></dmattnt-prtv-depot-facture-3>',
    data: { label: 'Informations transmises' }
  });
}

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_deburr__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_deburr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_deburr__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(271);





var SuivieAuthentComponent = function SuivieAuthentComponent() {
  _classCallCheck(this, SuivieAuthentComponent);

  this.controller = SuivieAuthentController;
  this.template = __webpack_require__(321);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = SuivieAuthentComponent;

var SuivieAuthentController = function () {
  function SuivieAuthentController($scope, $ngRedux) {
    _classCallCheck(this, SuivieAuthentController);

    this.data = {};
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.regex = new RegExp(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/, 'u');
  }

  _createClass(SuivieAuthentController, [{
    key: '$onInit',
    value: function $onInit() {
      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].SUIVIE_AUTHENT));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching
        };
      })(this);
      this.data.identifiant = 'VGS_';
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }

    // Actions

  }, {
    key: 'nextStep',
    value: function nextStep() {
      //enlever les accents
      this.data.nom = __WEBPACK_IMPORTED_MODULE_2_lodash_deburr___default()(this.data.nom);
      this.data.prenom = __WEBPACK_IMPORTED_MODULE_2_lodash_deburr___default()(this.data.prenom);
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateSuivieAuthent(this.data));
    }
  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateSuivieAuthent(this.data, true));
    }
  }]);

  return SuivieAuthentController;
}();

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_routes_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_pdf_util__ = __webpack_require__(167);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(272);





var SuivieResultatComponent = function SuivieResultatComponent() {
  _classCallCheck(this, SuivieResultatComponent);

  this.controller = SuivieResultatController;
  this.template = __webpack_require__(322);
};

// @ngInject


/* harmony default export */ __webpack_exports__["a"] = SuivieResultatComponent;

var SuivieResultatController = function () {
  function SuivieResultatController($scope, $ngRedux) {
    _classCallCheck(this, SuivieResultatController);

    this.data = {};
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  _createClass(SuivieResultatController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      // Demande de récupération de la demande avant connexion au state
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].loadDemande(__WEBPACK_IMPORTED_MODULE_1__utils_routes_util__["c" /* STEPS */].SUIVIE_RESULTAT));
      // Connexion au state récupérer les données modifiées
      var disconnect = this.$ngRedux.connect(function (state) {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.asMutable({
            deep: true
          }) : _this.data,
          commentaire: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.commentaire : null,
          dateStatut: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.dateStatut : null,
          demandeEnquete: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.demandeEnquete : null,
          //statut renvoie booleen, pour telecharger le pdf uniquement si on a fini la DE
          //sinon, on redirige vers les pages pour poursuivre la demande (voir dans la fonction du router)
          statut: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.codeStatut === 'PRTV_DE_FACTURE_TRANSMISE' || state.demande.data.suivieResultat.codeStatut === 'EN_COURS_QUALIF_DE_TELECHARGEE' : null,
          statutFactureTransmise: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.codeStatut === 'PRTV_DE_FACTURE_TRANSMISE' : false,
          checkCode: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.checkCode : null,
          numeroAnfr: state.demande.data.suivieResultat ? state.demande.data.suivieResultat.numeroAnfr : null
        };
      })(this);
      // Déconnexion du state à la suppression du composant
      this.$scope.$on('$destroy', disconnect);
    }
    // Actions

  }, {
    key: 'nextStep',
    value: function nextStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateSuivieResultat(this.data));
    }
  }, {
    key: 'prevStep',
    value: function prevStep() {
      this.$ngRedux.dispatch(__WEBPACK_IMPORTED_MODULE_0__actions_demande_actions__["d" /* default */].updateSuivieResultat(this.data, true));
    }
  }, {
    key: 'download',
    value: function download() {
      __WEBPACK_IMPORTED_MODULE_2__utils_pdf_util__["a" /* default */].openPdfUrl(this.numeroAnfr, this.checkCode, true);
      this.pdfurl = __WEBPACK_IMPORTED_MODULE_2__utils_pdf_util__["a" /* default */].buildPdfUrl(this.numeroAnfr, this.checkCode, true);
    }
  }]);

  return SuivieResultatController;
}();

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_routes_util__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].SUIVIE_AUTHENT, {
    url: '/suivie-authent',
    template: '<dmattnt-suivie-authent></dmattnt-suivie-authent>',
    data: { label: 'Suivi' }
  }).state(__WEBPACK_IMPORTED_MODULE_0__utils_routes_util__["c" /* STEPS */].SUIVIE_RESULTAT, {
    url: '/suivie-resultat',
    template: '<dmattnt-suivie-resultat></dmattnt-suivie-resultat>',
    data: { label: 'Resultat' }
  });
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_seamless_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = reduce;



var INITIAL_STATE = __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default()({
  failure: false,
  fetching: false,
  data: {}
});
/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["a" /* REQUEST_DEMANDE */]:
      return state.merge({
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["b" /* RECEIVE_DEMANDE */]:
      return state.merge({
        fetching: false,
        failure: false,
        data: action.payload.demande
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_demande_actions__["c" /* FAILURE_DEMANDE */]:
      return state.merge({
        fetching: false,
        failure: true
      });
    default:
      return state;
  }
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_seamless_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_general_actions__ = __webpack_require__(37);
/* harmony export (immutable) */ __webpack_exports__["a"] = reduce;



var INITIAL_STATE = __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default()({
  working: false,
  runningTask: 0
});

/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_general_actions__["a" /* TASK_STARTED */]:
      return state.merge({
        working: true,
        runningTask: state.runningTask + 1
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_general_actions__["b" /* TASK_DONE */]:
      return state.merge({
        working: state.runningTask > 1,
        runningTask: state.runningTask - 1
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_general_actions__["c" /* RESET */]:
      return INITIAL_STATE;
    default:
      return state;
  }
}

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_seamless_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_multiplex_actions__ = __webpack_require__(60);
/* harmony export (immutable) */ __webpack_exports__["a"] = reduce;



var INITIAL_STATE = __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default()({
  failure: false,
  fetching: false,
  data: null
});
/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_multiplex_actions__["a" /* REQUEST_MULTIPLEX */]:
      return state.merge({
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_multiplex_actions__["b" /* RECEIVE_MULTIPLEX */]:
      return state.merge({
        fetching: false,
        data: action.payload.data
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_multiplex_actions__["c" /* FAILURE_MULTIPLEX */]:
      return state.merge({
        fetching: false,
        failure: true
      });
    default:
      return state;
  }
}

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_seamless_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_type_defaut_actions__ = __webpack_require__(102);
/* harmony export (immutable) */ __webpack_exports__["a"] = reduce;




var INITIAL_STATE = __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default()({
  failure: false,
  fetching: false,
  data: null
});
/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_type_defaut_actions__["a" /* REQUEST_TYPE_DEFAUT */]:
      return state.merge({
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_type_defaut_actions__["b" /* RECEIVE_TYPE_DEFAUT */]:
      return state.merge({
        fetching: false,
        data: __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default()(action.payload.data, 'nom')
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_type_defaut_actions__["c" /* FAILURE_TYPE_DEFAUT */]:
      return state.merge({
        fetching: false,
        failure: true
      });
    default:
      return state;
  }
}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_seamless_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_type_perturbation_actions__ = __webpack_require__(162);
/* harmony export (immutable) */ __webpack_exports__["a"] = reduce;




var INITIAL_STATE = __WEBPACK_IMPORTED_MODULE_0_seamless_immutable___default()({
  failure: false,
  fetching: false,
  data: null
});
/*
 * Désactivation de la vérification de l'ordre des paramètres par défaut.
 * Redux impose le premier paramètre (l'état) d'un reducer avec une valeur par défaut, or les paramètres par défaut
 * devraient être positionnés en dernier et non en premier.
 */
/* jshint -W138 */
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_type_perturbation_actions__["a" /* REQUEST_TYPE_PERTURBATION */]:
      return state.merge({
        fetching: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_type_perturbation_actions__["b" /* RECEIVE_TYPE_PERTURBATION */]:
      return state.merge({
        fetching: false,
        data: __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default()(action.payload.data, 'nom')
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_type_perturbation_actions__["c" /* FAILURE_TYPE_PERTURBATION */]:
      return state.merge({
        fetching: false,
        failure: true
      });
    default:
      return state;
  }
}

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_camelCase__);






function getAntenneLTEPerturbation(codeinsee, adresse, datePerturbation, latitude, longitude, rayon) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].getAntenneLTEPerturbation,
    params: {
      adresse: adresse,
      commune: codeinsee,
      datesignalement: datePerturbation,
      rayon: rayon
    }
  }).then(function (r) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default()(r.data, function (value, key) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default()(key);
    });
  });
}

function getReamenagement(adresse, nomCommune) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].getReamenagement,
    params: {
      adresse: adresse,
      commune: nomCommune
    }
  }).then(function (r) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default()(r.data, function (value, key) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default()(key);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  getAntenneLTEPerturbation: getAntenneLTEPerturbation, getReamenagement: getReamenagement
};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__providers__ = __webpack_require__(3);


function getAdresseApiDataGouv(adresse) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: 'https://api-adresse.data.gouv.fr/search/',
    params: {
      q: adresse,
      limit: 1
    }
  }).then(function (r) {
    return r.data.features;
  }).catch(function () {
    return [];
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  getAdresseApiDataGouv: getAdresseApiDataGouv
};

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function getChainesLocales(adresseInsee, codeInsee) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].getChainesLocales,
    urlConfig: {
      pathParams: {
        codeinsee: codeInsee,
        adresse: adresseInsee
      }
    }
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  getChainesLocales: getChainesLocales
};

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function searchCommune(query) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
  var showCom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].searchCommune,
    params: {
      query: query,
      page: page,
      start: start,
      limit: limit,
      showCom: showCom
    }
  }).then(function (r) {
    return r.data;
  });
}

function searchCodePostal(codepostal) {
  var showCom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].searchCodepostal,
    params: {
      codepostal: codepostal,
      showCom: showCom
    }
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  searchCommune: searchCommune,
  searchCodePostal: searchCodePostal
};

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__providers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lz_string__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lz_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lz_string__);
var DEMANDE_TNT = 'DEMANDE_TNT';




function loadDemande() {
  var serialized = window.localStorage.getItem(DEMANDE_TNT);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__providers__["d" /* $qProvider */])().when(serialized ? JSON.parse(__WEBPACK_IMPORTED_MODULE_1_lz_string___default.a.decompress(serialized)) : {});
}

function cacheDemande(demande) {
  if (demande) {
    var jsonData = JSON.stringify(demande);
    var compressedData = __WEBPACK_IMPORTED_MODULE_1_lz_string___default.a.compress(jsonData);
    window.localStorage.setItem(DEMANDE_TNT, compressedData);
  } else {
    window.localStorage.removeItem(DEMANDE_TNT);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__providers__["d" /* $qProvider */])().when(true);
}

/* harmony default export */ __webpack_exports__["a"] = {
  loadDemande: loadDemande,
  cacheDemande: cacheDemande
};

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function getAntennisteList(numeroAnfr, rayonMax) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].getAntennisteList,
    urlConfig: {
      pathParams: {
        numeroanfr: numeroAnfr,
        rayon: rayonMax
      }
    }
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  getAntennisteList: getAntennisteList
};

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function getMessageCommune(codeInsee) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].getMessageCommune,
    params: {
      codeinsee: codeInsee,
      destinataire: 'ASSISTANCE_TNT'
    }
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  getMessageCommune: getMessageCommune
};

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function getMultiplexList() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].getMultiplex
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  getMultiplexList: getMultiplexList
};

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_snake_case_util__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__ = __webpack_require__(166);








function postReclamation(demande) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'POST',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].postLte,
    data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(demande, function (value, key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_snake_case_util__["a" /* default */])(key);
    })
  }).then(function (r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(r.data, function (value, key) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default()(key);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  postReclamation: postReclamation
};

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_snake_case_util__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__ = __webpack_require__(166);








function postReclamation(demande) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'POST',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].postPrtv,
    data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(demande, function (value, key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_snake_case_util__["a" /* default */])(key);
    })
  }).then(function (r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(r.data, function (value, key) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default()(key);
    });
  });
}

function updateReclamation(demande) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'POST',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].updatePrtv,
    data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(demande, function (value, key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_snake_case_util__["a" /* default */])(key);
    })
  }).then(function (r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(r.data, function (value, key) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default()(key);
    });
  });
}

function updateReclamationDemandeEnquete(demande) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'POST',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].updatePrtvDemandeEnquete,
    data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(demande, function (value, key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_snake_case_util__["a" /* default */])(key);
    })
  }).then(function (r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(r.data, function (value, key) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default()(key);
    });
  });
}

function updateReclamationDemandeFacture(demande) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'POST',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].updatePrtvWithFactureAntenniste,
    data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(demande, function (value, key) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_snake_case_util__["a" /* default */])(key);
    })
  }).then(function (r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_deeply_util__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_mapKeys___default.a)(r.data, function (value, key) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_camelCase___default()(key);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  postReclamation: postReclamation,
  updateReclamation: updateReclamation,
  updateReclamationDemandeEnquete: updateReclamationDemandeEnquete,
  updateReclamationDemandeFacture: updateReclamationDemandeFacture
};

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function checkDossier(demande) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].checkDossier,
    urlConfig: {
      pathParams: {
        numeroanfr: demande.suivieAuthent.identifiant,
        nom: demande.suivieAuthent.nom,
        prenom: demande.suivieAuthent.prenom
      }
    }
  }).then(function (r) {
    return r.data;
  });
}

function checkFactureDossier(demande) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].checkDossier,
    urlConfig: {
      pathParams: {
        numeroanfr: demande.numeroAnfr,
        nom: demande.prtvInterface6.nom,
        prenom: demande.prtvInterface6.prenom
      }
    }
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  checkDossier: checkDossier,
  checkFactureDossier: checkFactureDossier
};

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function load() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].getTypeDefaut
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  load: load
};

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configuration__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__providers__ = __webpack_require__(3);



function load() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__providers__["b" /* $httpProvider */])()({
    method: 'GET',
    url: __WEBPACK_IMPORTED_MODULE_0__configuration__["a" /* default */].getTypePerturbation,
    params: {
      filter: '[{"property":"visibleSitePublic","value":true}]'
    }
  }).then(function (r) {
    return r.data;
  });
}

/* harmony default export */ __webpack_exports__["a"] = {
  load: load
};

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHAINES_LOCALES_RECUES; });
var CHAINES_LOCALES_RECUES = 'Chaîne(s) locale(s) reçue(s)';

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_some__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_deburr__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_deburr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_deburr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniq__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_defaults__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_defaults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_capitalize__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_capitalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_capitalize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_toString__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_toString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_toString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_difference__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_includes__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_common_model__ = __webpack_require__(2);












/**
 * Construction de l'objet de demande PRTV à partir d'une demande antenniste
 *
PRTV (antenniste)
{
  "date_anomalie" : Date "AAAA-MM-JJ", Obligatoire
  "descriptif" : Chaîne de caractères
  "impact" : Chaîne de caractères
  "signalant" : (Obligatoire) {
    "type_signalant" : Chaîne de caractères, Obligatoire
    "denomination_commerciale" : Chaîne de caractères
    "siret" : Chaîne de caractères
    "civilite" : Chaîne de caractères, Obligatoire(M ou MME)
    "nom" : Chaîne de caractères, Obligatoire
    "prenom" : Chaîne de caractères, Obligatoire
    "telephone1" : Chaîne de caractères
    "adresse" : (Obligatoire) {
      "numero" : Chaîne de caractères
      "voie" : Chaîne de caractères, Obligatoire
      "complement" : Chaîne de caractères
      "boite_postale" : Chaîne de caractères
      "ville" : Chaîne de caractères, Obligatoire
      "code_postal" : Chaîne de caractères, Obligatoire
      "cedex" : Chaîne de caractères
      "adresse_structuree" : Chaîne de caractères, obligatoire
    }
  }
  "multiplex_impactes" : ["1","2", …] (voir liste des multiplex, utilisé l’id)
  "adresses_impactees" : (Obligatoire – Au moins une adresse) [{
    "adresse" : {
      "numero" : Chaîne de caractères
      "voie" : Chaîne de caractères, Obligatoire
      "ville" : Chaîne de caractères, Obligatoire
      "code_postal" : Chaîne de caractères, Obligatoire
      "adresse_structuree" : Chaîne de caractères, obligatoire
    }
    "type_perturbation" : Entier, (voir liste des types de perturbation, utiliser l’id), Obligatoire
    "type_defaut" : Entier, (voir liste des défauts, utiliser l’id), Obligatoire
    "id_commune" : Entier, (voir liste des communes, utiliser l’id), obligatoire
  }]
}
*/
function demandeAntennisteToPrtv(demande) {
  return {
    dateConstat: demande.accueilInterface2.datePerturbation,
    descriptif: demande.constat.descriptif,
    impact: demande.constat.impactSuppose,
    emetteur: '' + demande.constat.emetteurtnt.emetteurtnt.id + '',
    signalant: __WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default()({ adresse: formatAdresse(demande.contact.adresse, demande.contact.complementAdresse, demande.contact.adresse.voie) }, formatSignalant(demande.typePersonne, demande.contact)),
    multiplexImpactes: __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(demande.constat.multiplex, 'id'),
    adressesImpactees: [{
      idCommune: demande.accueilInterface2.adresse.commune.id,
      inseeCommune: demande.accueilInterface2.adresse.commune.insee,
      typeDefaut: demande.constat.typeProbleme === 'Permanent' ? 1 : 2,
      typePerturbation: demande.constat.typePerturbation.id,
      adresse: formatAdresse(demande.accueilInterface2.adresse, {}, demande.voieShort),
      civilite: 'M',
      nom: 'Indéterminé',
      prenom: 'Indéterminé'
    }]
  };
}

/**
 * Construction de l'objet de demande PRTV à partir d'une demande
 *
PRTV
{
  "date_anomalie" : Date "AAAA-MM-JJ", Obligatoire
  "complement" : Chaîne de caractères
  "voisinsConcernes" : Chaîne de caractères
  "perturbateur" : Chaîne de caractères
  "perturbateurElement" : Chaîne de caractères
  "perturbateurAmiable" : Chaîne de caractères
  "perturbateurCoordonnees" : Chaîne de caractères
  "perturbateurAutre" : Chaîne de caractères
  "stationLteConfirmee" : Chaîne de caractères
  "signalant" : (Obligatoire) {
    "type_signalant" : Chaîne de caractères, Obligatoire
    "civilite" : Chaîne de caractères, Obligatoire(M ou MME)
    "nom" : Chaîne de caractères, Obligatoire
    "prenom" : Chaîne de caractères, Obligatoire
    "telephone1" : Chaîne de caractères
    "adresse" : (Obligatoire) {
      "numero" : Chaîne de caractères
      "voie" : Chaîne de caractères, Obligatoire
      "complement" : Chaîne de caractères
      "boite_postale" : Chaîne de caractères
      "ville" : Chaîne de caractères, Obligatoire
      "code_postal" : Chaîne de caractères, Obligatoire
      "cedex" : Chaîne de caractères
      "adresse_structuree" : Chaîne de caractères, obligatoire
    }
  }
  "multiplex_impactes" : ["1","2", …] (voir liste des multiplex, utilisé l’id)
  "adresses_impactees" : (Obligatoire – Au moins une adresse) [{
    "adresse" : {
      "numero" : Chaîne de caractères
      "voie" : Chaîne de caractères, Obligatoire
      "ville" : Chaîne de caractères, Obligatoire
      "code_postal" : Chaîne de caractères, Obligatoire
      "adresse_structuree" : Chaîne de caractères, obligatoire
    }
    "type_perturbation" : Entier, (voir liste des types de perturbation, utiliser l’id), Obligatoire
    "type_defaut" : Entier, (voir liste des défauts, utiliser l’id), Obligatoire
    "id_commune" : Entier, (voir liste des communes, utiliser l’id), obligatoire
  }]
}
*/
function demandeToPrtv(demande) {
  var adresseImpactee = demande.accueilInterface2.adresse;
  return {
    numeroAnfr: demande.numeroAnfr,
    checkCode: demande.checkCode,
    dateConstat: demande.accueilInterface2.datePerturbation,
    complement: demande.prtvInterface1 ? demande.prtvInterface1.complement ? __WEBPACK_IMPORTED_MODULE_7_lodash_toString___default()((demande.prtvInterface1.infoChaineLocal ? demande.prtvInterface1.infoChaineLocal + '; ' : '') + demande.prtvInterface1.complement).trim() : demande.prtvInterface1.infoChaineLocal : null,
    signalant: __WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default()({ adresse: formatAdresse(demande.accueilInterface2.adresse, demande.accueilInterface2.complementAdresse, demande.voieShort) }, formatSignalant(demande.typePersonne, demande.prtvInterface1)),
    multiplexImpactes: demande.prtvInterface1 ? demande.prtvInterface1.isAdresseDomCom ? demande.prtvInterface1.chainesRecues === 'OUI' ? [] : multiplexRom1(demande.accueilInterface2.multiplexAll) : multiplexFromChaines(demande.prtvInterface1.chaines, demande.accueilInterface2.multiplex) : [],
    voisinsConcernes: demande.prtvInterface1 ? demande.prtvInterface1.voisinsConcernes : '',
    perturbateur: demande.prtvInterface1 ? demande.prtvInterface1.perturbateur : '',
    perturbateurElement: demande.prtvInterface1 ? demande.prtvInterface1.perturbateurElement : '',
    perturbateurAmiable: demande.prtvInterface1 ? demande.prtvInterface1.perturbateurAmiable : '',
    perturbateurCoordonnees: demande.prtvInterface1 ? demande.prtvInterface1.perturbateurCoordonnees : '',
    perturbateurAutre: demande.prtvInterface1 ? demande.prtvInterface1.perturbateurAutre : '',
    stationLteConfirmee: demande.prtvInterface1 ? demande.signalementAntenniste && demande.signalementAntenniste.natureProbleme && demande.signalementAntenniste.natureProbleme === __WEBPACK_IMPORTED_MODULE_10__modules_common_model__["b" /* NATURE_PERTURBATION */].BROUILLAGE_4G_5G || !demande.prtvInterface1.demandeEnquetePapier : demande.defaultSuspicionLte,
    demandeEnquete: demande.prtvInterface1 ? demande.prtvInterface1.demandeEnquetePapier : false,
    adressesImpactees: [__WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default()({
      adresse: formatAdresse(adresseImpactee, {}, demande.voieShort),
      idCommune: adresseImpactee.commune.id,
      inseeCommune: adresseImpactee.commune.insee,
      typeDefaut: 3,
      typePerturbation: demande.prtvInterface1 && demande.prtvInterface1.typePerturbation ? demande.prtvInterface1.typePerturbation.id : 10
    }, formatCoordoonees(demande.accueilInterface2))]
  };
}

/*Demande de PRTV pour la demande d'enquete
{
  receivedStation: station selectionnee parmi celles que l'utilisateur reçoit via
  l'appel a vigispectre pour recevoir les stations
  otherSelectedStationName: station alternative entree manuellement par l'utilisateur
  validStation: station valide (soit celle reçue et selectionee, soit celle entree manuellement)
  isNoOrientation: booleen qui repond a : l'utilisateur connait l'orientation de son antenne ?
  perturbationsValue: valeur de la perturbation du signal
  isConstructionKnowledge: booleen qui repond a : l'utilisateur connait le type de construction (immeuble, eolienne)
  qui pourrait causer les problemes de reception
  constructionType: type de la construction (immeuble, eolienne)
  isCloseAround: booleen qui repond a : l'edifice se situe a moins de 5 km de l'antenne
  firstPerturbationDate: date a laquelle les premieres perturbations sont arrivees
}
*/

function demandeToPrtvDemandeEnquete(demande) {

  var multiplex = void 0;
  if (demande.prtvInterface1) {
    var _demande$prtvInterfac = demande.prtvInterface1,
        complement = _demande$prtvInterfac.complement,
        infoChaineLocal = _demande$prtvInterfac.infoChaineLocal;


    var texteComplement = [infoChaineLocal, complement].filter(Boolean).join('; ').trim();

    var isChaineLocalRecu = texteComplement === 'Chaîne(s) locale(s) reçue(s)';
    var hasUncheckedChannel = demande.prtvInterface5.channels.station.every(function (item) {
      return item.switchValue;
    });
    var isChaineInvalid = isChaineLocalRecu && hasUncheckedChannel;

    if (!isChaineInvalid) {
      multiplex = demande.accueilInterface2.multiplexAll.find(function (i) {
        return i.code === 'R15';
      }).id;
    }
  }

  return {
    numeroAnfr: demande.numeroAnfr,
    checkCode: demande.checkCode,
    informationsReclamation: [__WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default()({
      connexionQuality: demande.prtvInterface5 ? demande.prtvInterface5.connexionQuality : '',
      channelsArray: demande.prtvInterface5 ? demande.prtvInterface5.channels.station : [],
      channelsString: demande.prtvInterface5 ? demande.prtvInterface5.channels.station ? demande.prtvInterface5.channels.station.filter(function (channel) {
        return channel.switchValue;
      }).map(function (channel) {
        return channel.name;
      }).join(', ') : '' : '',
      receivedStation: demande.prtvInterface5 ? demande.prtvInterface5.receivedStation : '',
      otherSelectedStationName: demande.prtvInterface5 ? demande.prtvInterface5.otherSelectedStationName : '',
      validStation: demande.prtvInterface5 ? demande.prtvInterface5.validStation : '',
      isNoOrientation: demande.prtvInterface5 ? demande.prtvInterface5.isNoOrientation : true,
      perturbationsValue: demande.prtvInterface5 ? demande.prtvInterface5.perturbationsValue : '',
      isConstructionKnowledge: demande.prtvInterface5 ? demande.prtvInterface5.isConstructionKnowledge : false,
      constructionType: demande.prtvInterface5 ? demande.prtvInterface5.constructionType : '',
      isCloseAround: demande.prtvInterface5 ? demande.prtvInterface5.is5KmAround : false,
      firstPerturbationDate: demande.prtvInterface5 ? demande.prtvInterface5.firstPerturbationDate : null,
      multiplexLocalImpactes: multiplex
    })]
  };
}

/* Demande de PRTV pour la demande d'enquete, ajout de la facture et des informations de l'antenniste
*/

function demandeAvecFactureDemandeEnquete(demande) {
  return {
    numeroAnfr: demande.numeroAnfr,
    checkCode: demande.checkCode,
    informationsDemandeEnqueteAntenniste: [__WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default()({
      deAdresseAntenniste: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.adresseContact : '',
      deDenominationCommercialeAntenniste: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.denomination : '',
      factureFile: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.factureFile : '',
      factureFileName: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.factureFileName : '',
      isFactureOk: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.isFactureOk : false,
      deEmailAntenniste: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.mailContact : '',
      deNomAntenniste: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.nomContact : '',
      autresFactures: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.autresFactures : [],
      deNumeroTelephoneAntenniste: demande.prtvDepotFacture2 ? demande.prtvDepotFacture2.telContact : ''
    })]
  };
}

/**
LTE
{
  "date_anomalie" : Date "AAAA-MM-JJ", Obligatoire
  "signalant" : (Obligatoire) {
    "type_signalant" : Chaîne de caractères (Obligatoire), Obligatoire
    "civilite" : Chaîne de caractères, Obligatoire
    "nom" : Chaîne de caractères, Obligatoire
    "prenom" : Chaîne de caractères, Obligatoire
    "telephone1" : Chaîne de caractères (Obligatoire si telephone2 et courriel non renseigné)
    "telephone2" : Chaîne de caractères (Obligatoire si telephone1 et courriel non renseigné)
    "courriel" : Chaîne de caractères (Obligatoire si telephone1 et telephone2 non renseigné)
    "adresse" : (Obligatoire) {
      "numero" : Chaîne de caractères
      "voie" : Chaîne de caractères, Obligatoire
      "complement" : Chaîne de caractères
      "boite_postale" : Chaîne de caractères
      "ville" : Chaîne de caractères, Obligatoire
      "code_postal" : Chaîne de caractères, Obligatoire
      "cedex" : Chaîne de caractères
      "adresse_structuree" : Chaîne de caractères, obligatoire
   }
  }
  "multiplex_impactes" : ["1","2", …] (voir liste des multiplex, utilisé l’id)
  "adresses_impactees : (Obligatoire – Au moins une adresse) [
    {
      "civilite" : Entier (voir liste des civilités, utiliser l’id), obligatoire
      "nom" : Chaîne de caractères, Obligatoire
      "prenom" : Chaîne de caractères, Obligatoire
      "telephone1" : Chaîne de caractères
      "telephone2" : Chaîne de caractères
      "courriel" : Chaîne de caractères
      "adresse" : {
        "numero" : Chaîne de caractères
        "voie" : Chaîne de caractères, Obligatoire
        "ville" : Chaîne de caractères, Obligatoire
        "code_postal" : Chaîne de caractères, Obligatoire
        "adresse_structuree" : Chaîne de caractères, obligatoire
      }
      "id_commune" : Entier, (voir liste des communes, utiliser l’id), obligatoire
      "type_perturbation" : Entier, (voir liste des types de perturbation, utiliser l’id), Obligatoire
      "type_defaut" : Entier, (voir liste des défauts, utiliser l’id), Obligatoire
    }, {
       …
    }
  ]
  "operateur_lte" : Chaine de caractères, (Voir liste des opérateurs LTE, utiliser le code), obligatoire
// -> code_operateur_lte de la première antenne (station_lte)
  "type_raccordement" : Chaîne de caractères  (Individuel ou Collectif), obligatoire
  "station_lte" : [
    {
      "numero_anfr" : Chaîne de caractères, obligatoire
      "code_antenne_operateur" : Chaîne de caractères, obligatoire
      "code_operateur_lte" : Chaine de caractères, (Voir liste des opérateurs LTE, utiliser le code), obligatoire
      "techno" : Chaîne de caractères (LTE700 ou LTE800)
      "azimut" : Chaîne de caractères, obligatoire
      "puissance_recue" : Chaîne de caractères, obligatoire
      "distance" : Chaîne de caractères, obligatoire
    },{
      …
    }
  ]
}
 */
function demandeToLte(demande) {
  var adresseImpactee = demande.accueilInterface2.adresse;
  var antennes = '';
  if (demande.signalementAntenniste && demande.signalementAntenniste.antennes) {
    antennes = demande.signalementAntenniste.antennes.data;
  } else if (demande.dysfonctionnementInterface && demande.dysfonctionnementInterface.antennes) {
    antennes = demande.dysfonctionnementInterface.antennes.data;
  }
  return {
    dateConstat: demande.accueilInterface2.datePerturbation,
    signalant: __WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default()({ adresse: formatAdresse(demande.accueilInterface2.adresse, demande.accueilInterface2.complementAdresse, demande.voieShort) }, formatSignalant(demande.typePersonne, demande.lteInterface1)),
    multiplexImpactes: multiplexFromChaines(demande.accueilInterface2.chaines, demande.accueilInterface2.multiplex),
    adressesImpactees: [__WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default()({
      adresse: formatAdresse(adresseImpactee, {}, demande.voieShort),
      idCommune: adresseImpactee.commune.id,
      inseeCommune: adresseImpactee.commune.insee,
      typeDefaut: 3,
      typePerturbation: 10
    }, formatCoordoonees(demande.lteInterface1))],
    typeRaccordement: demande.lteInterface1.modeRaccordement ? __WEBPACK_IMPORTED_MODULE_6_lodash_capitalize___default()(demande.lteInterface1.modeRaccordement) : __WEBPACK_IMPORTED_MODULE_6_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_10__modules_common_model__["c" /* MODE_RACCORDEMENT */].COLLECTIF),
    stationLte: antennes
  };
}

function multiplexRom1(allMutiplex) {
  var muxInclud = ['ROM1'];
  var multiplex = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(allMutiplex, function (m) {
    return __WEBPACK_IMPORTED_MODULE_9_lodash_includes___default()(muxInclud, m.code);
  });
  return __WEBPACK_IMPORTED_MODULE_4_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(multiplex, 'id'));
}

function multiplexFromChaines(chaines, allMultiplex) {
  // On récupère les multiplex qui marchent et on fait la difference pour envoyer les mux qui marchent pas
  var muxConcernes = __WEBPACK_IMPORTED_MODULE_8_lodash_difference___default()(allMultiplex, __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(allMultiplex, function (m) {
    return m.chainesActives.length && __WEBPACK_IMPORTED_MODULE_2_lodash_some___default()(m.chainesActives, function (c) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_some___default()(chaines, function (c2) {
        return c.id === c2.id;
      });
    });
  }));

  return __WEBPACK_IMPORTED_MODULE_4_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(muxConcernes, 'id'));
}

function formatSignalant(typeSignalant) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return __WEBPACK_IMPORTED_MODULE_5_lodash_defaults___default()({ typeSignalant: typeSignalant }, formatCoordoonees(data));
}

function formatCoordoonees(data) {
  return {
    denominationCommerciale: data.societe,
    siret: data.siret,
    civilite: data.civilite ? data.civilite : 'MME',
    nom: data.nom ? data.nom : 'anonyme',
    prenom: data.prenom ? data.prenom : 'anonyme',
    telephone1: data.telephone1 ? data.telephone1 : '0000000000',
    telephone2: data.telephone2,
    courriel: data.courriel
  };
}

function formatAdresse() {
  var adresse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var complementAdresse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var voieName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var adresseStruct = __WEBPACK_IMPORTED_MODULE_3_lodash_deburr___default()((adresse.numero || '') + ' ' + voieName + ' ' + adresse.codePostal.codepostal + ' ' + adresse.commune.nom);
  return {
    numero: __WEBPACK_IMPORTED_MODULE_3_lodash_deburr___default()(adresse.numero),
    voie: __WEBPACK_IMPORTED_MODULE_3_lodash_deburr___default()(voieName),
    complement: __WEBPACK_IMPORTED_MODULE_3_lodash_deburr___default()(complementAdresse.complement),
    ville: __WEBPACK_IMPORTED_MODULE_3_lodash_deburr___default()(adresse.commune.nom),
    codePostal: __WEBPACK_IMPORTED_MODULE_3_lodash_deburr___default()(adresse.codePostal.codepostal),
    adresseStructuree: __WEBPACK_IMPORTED_MODULE_3_lodash_deburr___default()(adresseStruct)
  };
}

/* harmony default export */ __webpack_exports__["a"] = { demandeAntennisteToPrtv: demandeAntennisteToPrtv, demandeToPrtv: demandeToPrtv, demandeToLte: demandeToLte, demandeToPrtvDemandeEnquete: demandeToPrtvDemandeEnquete, demandeAvecFactureDemandeEnquete: demandeAvecFactureDemandeEnquete };

/***/ }),
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_symbol__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_sanitize__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angular_sanitize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angular_sanitize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_i18n_fr_fr_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angular_i18n_fr_fr_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angular_i18n_fr_fr_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng_redux__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ng_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ng_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducers_combine_reducers__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_thunk__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_ui_notification__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angular_ui_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angular_ui_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_messages__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angular_messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angular_messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular_ui_mask__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angular_ui_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angular_ui_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular_ui_router__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angular_ui_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angular_ui_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angular_ui_switch__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angular_ui_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angular_ui_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ui_select__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ui_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_ui_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angularjs_datepicker__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angularjs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angularjs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_common_common_module__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_base_base_module__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_accueil_accueil_module__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_antenniste_antenniste_module__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_lte_lte_module__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_prtv_prtv_module__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_suivie_dossier_suivie_dossier_module__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__main_routes__ = __webpack_require__(184);















// Workaround pour que les modifications sur le fichier index.html soient
// surveillées par Webpack
// Le if permet de ne pas ajouter cette dépendence en mode production
if (false) {
  require('raw-loader!./index.html');
  require('raw-loader!./favicon.png');
}

__webpack_require__(182);










__WEBPACK_IMPORTED_MODULE_1_angular___default.a.module('dmattnt', [__WEBPACK_IMPORTED_MODULE_14__modules_common_common_module__["a" /* default */].moduleName, __WEBPACK_IMPORTED_MODULE_15__modules_base_base_module__["a" /* default */].moduleName, __WEBPACK_IMPORTED_MODULE_16__modules_accueil_accueil_module__["a" /* default */].moduleName, __WEBPACK_IMPORTED_MODULE_17__modules_antenniste_antenniste_module__["a" /* default */].moduleName, __WEBPACK_IMPORTED_MODULE_18__modules_lte_lte_module__["a" /* default */].moduleName, __WEBPACK_IMPORTED_MODULE_19__modules_prtv_prtv_module__["a" /* default */].moduleName, __WEBPACK_IMPORTED_MODULE_20__modules_suivie_dossier_suivie_dossier_module__["a" /* default */].moduleName, 'ngLocale', 'ui.select', 'ngSanitize', 'ui.router', 'uiSwitch', 'ngRedux', 'ui-notification', 'ui.mask', '720kb.datepicker', 'ngMessages']).config(__WEBPACK_IMPORTED_MODULE_21__main_routes__["a" /* default */]).config( /* @ngInject */function ($ngReduxProvider) {
  var middlewares = [__WEBPACK_IMPORTED_MODULE_6_redux_thunk___default.a];
  if (false) {
    var createLogger = require('redux-logger');
    var logger = createLogger({
      level: 'info',
      collapsed: true
    });
    middlewares.push(logger);
  }

  $ngReduxProvider.createStoreWith(__WEBPACK_IMPORTED_MODULE_5__reducers_combine_reducers__["a" /* default */], middlewares);
}).run( /* @ngInject */function ($templateCache) {
  $templateCache.put('selectize/select.tpl.html', __webpack_require__(183));
}).config(['uiMask.ConfigProvider', function (uiMaskConfigProvider) {
  uiMaskConfigProvider.clearOnBlur(false);
}]);

// bootstrap angular app
__WEBPACK_IMPORTED_MODULE_1_angular___default.a.element(document.body).ready(function () {
  return __WEBPACK_IMPORTED_MODULE_1_angular___default.a.bootstrap(document.body, ['dmattnt']);
});

/***/ })
],[576]);


// WEBPACK FOOTER //
// app.ebb6bff836b8b4bdcd69.js